const es = {
    common: {
        english: "Inglés",
        spanish: "Español",
        french: "Francés",
        login: "Iniciar sesión",
        register: "Registrarse",
        save: "Guardar",
        cancel: "Cancelar",
        delete: "Eliminar",
        edit: "Editar",
        loading: "Cargando...",
        language: "Idioma",
        divisions: "Divisiones",
        seasons: "Temporadas",
        season: "Temporada",
        teams: "Equipos",
        players: "Jugadores",
        referees: "Árbitros",
        getStarted: "Comenzar",
        learnMore: "Más información",
        sending: "Enviando...",
        backToLogin: "Volver al inicio de sesión",
        table: {
            subtitle: "Gestiona los elementos de esta lista",
            add: "Agregar",
            prev: "Anterior",
            next: "Siguiente",
            page: "Página",
            of: "de"
        },
        previous: "Anterior",
        next: "Siguiente",
        collapse: "Contraer",
        expand: "Expandir"
    },
    nav: {
        home: "Inicio",
        organizations: "Organizaciones",
        notifications: "Notificaciones",
        settings: "Configuración",
        financial: "Finanzas",
        subscription: "Suscripción",
        advertise: "Publicidad",
    },
    marketplaceCategories: {
        "sports-equipment": "Equipamiento deportivo",
        "uniforms-apparel": "Uniformes y ropa deportiva",
        "team-equipment": "Equipamiento para equipos",
        "facility-rentals": "Alquiler de instalaciones",
        "training-equipment": "Equipamiento de entrenamiento",
        "coaching-services": "Servicios de entrenamiento",
        "officiating-services": "Servicios de arbitraje",
        "sports-photography": "Fotografía deportiva",
        "equipment-repair": "Reparación de equipamiento",
        "tournament-services": "Servicios para torneos",
    },
    marketplacePage: {
        title: "Marketplace",
        details: "Detalles del anuncio",
        category: "Categoría",
        allCategories: "Todas las categorías",
        type: "Tipo",
        allTypes: "Todos los tipos",
        sale: "En venta",
        rental: "En alquiler",
        city: "Ciudad",
        cityPlaceholder: "Buscar por ciudad",
        search: "Buscar",
        searchPlaceholder: "Buscar por nombre del anuncio o categoría",
        catalogSubtitle: "Explora anuncios de la comunidad deportiva.",
        clearFilters: "Borrar filtros",
        noListings: "No se encontraron anuncios.",
        noImage: "Sin imagen",
        locationNotAvailable: "Ubicación no disponible",
        pageOf: "Página {page} de {pages}",
        contactSeller: "Contactar al vendedor",
        favorite: "Guardar anuncio",
        favoriteUpdated: "Favorito actualizado.",
        conversationStarted: "Conversación iniciada.",
        report: "Reportar",
        reportPrompt: "Indica por qué reportas este anuncio.",
        reportSubmitted: "Reporte enviado.",
        rentalTerms: "Condiciones de alquiler",
        seller: "Vendedor",
        sellerPrivateContact: "Los datos de contacto permanecen privados hasta que el vendedor los comparta.",
        moreFromSeller: "Más anuncios de este vendedor",
        blockSeller: "Bloquear vendedor",
        confirmBlockSeller: "¿Bloquear a este vendedor? Sus anuncios dejarán de aparecer para ti.",
        sellerBlocked: "Vendedor bloqueado.",
        blockedUsers: "Usuarios bloqueados del marketplace",
        blockedUsersDescription: "Administra los vendedores que has bloqueado. Sus anuncios no aparecerán en tus resultados.",
        blockedUserHint: "Sus anuncios del marketplace están ocultos para ti.",
        noBlockedUsers: "No has bloqueado usuarios del marketplace.",
        blockedSeller: "Usuario {id}",
        unblock: "Desbloquear",
        safetyTitle: "Seguridad del marketplace",
        safetyText: "Reúnete en lugares públicos, verifica el artículo y la transacción de forma independiente y no compartas información personal innecesaria. Los pagos, depósitos, entregas, reembolsos y disputas de alquiler se gestionan fuera de AngeonX Sports.",
    },
    marketplaceManagementPage: {
        title: "Mis anuncios",
        subtitle: "Administra tus anuncios del marketplace, imágenes, condiciones de alquiler y campañas promocionales.",
        availableCredits: "Créditos de anuncio",
        enterpriseIncluded: "Incluido con Enterprise",
        listingUsage: "Uso de publicaciones",
        search: "Buscar anuncios",
        searchPlaceholder: "Buscar por nombre del anuncio o categoría",
        statusFilter: "Estado del anuncio",
        allStatuses: "Todos",
        createListing: "Crear anuncio",
        noListings: "Todavía no has creado anuncios.",
        noImage: "Sin imagen",
        locationNotAvailable: "Ubicación no disponible",
        view: "Ver",
        edit: "Editar",
        editTitle: "Editar anuncio",
        createTitle: "Crear anuncio",
        saved: "Anuncio guardado.",
        sections: {details: "Detalles del anuncio", location: "Ubicación", images: "Imágenes"},
        fields: {title: "Título", type: "Tipo", condition: "Condición", description: "Descripción", category: "Categoría", sport: "Deporte", price: "Precio", currency: "Moneda", city: "Ciudad", region: "Región", state: "Estado / provincia", country: "País", searchLocation: "Buscar ubicación", locationPlaceholder: "Busca una ciudad, región o país", locationLoading: "Cargando búsqueda de ubicación...", locationHint: "Selecciona una sugerencia de Google Maps para guardar correctamente la ubicación y las coordenadas.", primaryImage: "Imagen principal", imagesSelected: "imágenes seleccionadas", imagesHint: "Selecciona una o más imágenes", rentalPrice: "Precio de alquiler", pricingPeriod: "Periodo de precio", hour: "Hora", day: "Día", week: "Semana", month: "Mes", minimumPeriod: "Periodo mínimo", maximumPeriod: "Periodo máximo", depositRequired: "Depósito requerido", rentalTerms: "Condiciones de alquiler"},
        imageDeleted: "Imagen eliminada.",
        statusUpdated: "Estado del anuncio actualizado.",
        promote: "Promocionar anuncio",
        promotionTitle: "Promocionar anuncio",
        promotionName: "Nombre de la campaña",
        promotionSponsor: "Patrocinador",
        promotionSelectSponsor: "Selecciona un patrocinador",
        promotionZones: "Ubicaciones publicitarias",
        promotionSubmit: "Crear promoción",
        promotionCreated: "Borrador de promoción creado.",
        promotionStatus: "Promoción",
        managePromotion: "Administrar promoción",
        promotionStatuses: {draft: "Borrador", scheduled: "Programada", running: "Activa", paused: "Pausada"},
        promotionAlreadyExists: "Este anuncio ya tiene una campaña promocional. Se abrirá ahora.",
        promotionBudgetHint: "Después, completa las fechas, los países, la moneda y la segmentación. El presupuesto final se calcula con las tarifas actuales de las ubicaciones al pagar.",
        promotionConfirmTitle: "¿Crear campaña promocional?",
        promotionConfirmMessage: "Se creará un borrador para {title}. Podrás revisar las fechas, la audiencia y el requisito de pago antes de activarlo.",
        promotionConfirmHint: "Los miembros de ligas con Enterprise pueden recibir esta promoción sin costo adicional.",
        promotionConfirm: "Continuar",
        promotionBadge: "PROMOCIÓN",
        promotionNoSponsorTitle: "Primero crea un perfil de patrocinador",
        promotionNoSponsorMessage: "Se requiere un perfil de patrocinador para crear y administrar una campaña publicitaria para este anuncio.",
        promotionCreateSponsor: "Crear patrocinador",
        actions: {updateStatus: "Actualizar estado", remove: "Eliminar anuncio", confirmStatus: "¿Cambiar este anuncio a « {{status}} »?", confirmRemove: "¿Eliminar este anuncio?"},
        conditions: {new: "Nuevo", likeNew: "Como nuevo", used: "Usado", notApplicable: "No aplica"},
        filters: {title: "Filtrar anuncios", subtitle: "Filtra el marketplace por tipo, condición, ubicación y precio.", all: "Todos", listingType: "Tipo de anuncio", condition: "Condición", status: "Estado", category: "Categoría", sport: "Deporte", city: "Ciudad", cityPlaceholder: "Escribe la ciudad", region: "Estado / Provincia", regionPlaceholder: "Escribe el estado o provincia", state: "Estado / provincia", statePlaceholder: "Escribe el estado o provincia", country: "País", countryPlaceholder: "Escribe el país", minPrice: "Precio mínimo", maxPrice: "Precio máximo", apply: "Aplicar filtros"},
        statuses: {available: "Disponible", reserved: "Reservada", paused: "Pausado", sold: "Vendido", rented: "Alquilado", expired: "Expirado", removed: "Eliminado"},
    },
    marketplaceModerationPage: {
        searchRank: "#", searchTerm: "Búsqueda", searches: "Búsquedas", reportListing: "Anuncio", reportReason: "Motivo", reportActions: "Acciones",
        title: "Moderación del marketplace", subtitle: "Revisa reportes y administra la visibilidad de los anuncios.", staffTools: "Herramientas del personal", moderation: "Moderación", analyticsPeriod: "Periodo de analítica", last7Days: "Últimos 7 días", last30Days: "Últimos 30 días", last90Days: "Últimos 90 días", allTime: "Todo el tiempo", allListings: "Todos los anuncios", activeListings: "Anuncios activos", hiddenListings: "Anuncios ocultos", reports: "Reportes", search: "Buscar anuncios", searchPlaceholder: "Buscar por nombre del anuncio o categoría", filters: "Filtros", filtersSubtitle: "Filtra por tipo, categoría, deporte o ciudad.", listingType: "Tipo de anuncio", category: "Categoría", sport: "Deporte", city: "Ciudad", cityPlaceholder: "Escribe la ciudad", all: "Todos", sale: "En venta", rental: "En alquiler", apply: "Aplicar filtros", clear: "Borrar filtros", listings: "Anuncios del marketplace", listingsSubtitle: "Revisa el contenido y la visibilidad de los anuncios.", noListings: "No se encontraron anuncios.", topSearches: "Búsquedas principales", topSearchesSubtitle: "Búsquedas más frecuentes durante el periodo seleccionado.", noSearchActivity: "No hay actividad de búsqueda registrada.", pendingReports: "Reportes pendientes", reportsSubtitle: "Revisa los reportes enviados por usuarios.", noPendingReports: "No hay reportes pendientes.", deletedListing: "Anuncio eliminado", noDetails: "Sin detalles", dismiss: "Descartar", markReviewed: "Marcar como revisado", moderationUpdated: "Moderación del anuncio actualizada.", unableToModerate: "No se pudo moderar el anuncio.", reportReviewed: "Reporte revisado.", unableToReview: "No se pudo revisar el reporte.", staffRequired: "Se requiere acceso del personal.", removalAction: "Acción de moderación", listing: "Anuncio", removeListing: "Eliminar anuncio", removalNotice: "El anuncio se eliminará de los resultados del marketplace. Se notificará al vendedor.", removalReason: "Motivo de eliminación", removalPlaceholder: "Explica por qué se elimina este anuncio.", removalRequired: "El motivo de eliminación es obligatorio.", cancel: "Cancelar", removing: "Eliminando...", removed: "Anuncio eliminado del marketplace.", close: "Cerrar", resolution: "Resolución:",
    },
    auth: {
        loginTitle: "Iniciar sesión",
        signingIn: "Iniciando sesión...",
        registerTitle: "Crear cuenta",
        forgotPassword: "¿Olvidaste tu contraseña?",
        resendActivation: "Reenviar correo de activación",
        new: "¿Nuevo en AngeonX Sports?",
        signUpTitle: "Regístrate",
        didntReceived: "¿No recibiste el correo de activación?",
        email: "Correo electrónico",
        password: "Contraseña",
        toast: {
            invalid: "Credenciales inválidas. Por favor intenta nuevamente. Si el error persiste, contacta al soporte de AngeonX Sports."
        },
        title: "Inicia sesión para comenzar"
    },
    signUp: {
        titleManager: "Registrar un nuevo administrador y organización",
        addSponsor: "Registrar un nuevo patrocinador / anunciante",
        addAccount: "Registrar una nueva cuenta",
        yourInfo: "Tu información",
        role: "Me estoy registrando como:",
        orgInfo: "Información de la organización",
        sponsorInfo: "Información del negocio o patrocinador",
        form: {
            firstName: "Nombre",
            lastName: "Apellido",
            dob: "Fecha de nacimiento",
            dobHint: "Se utiliza para validar elegibilidad por edad, divisiones y verificación del jugador.",
            gender: "Género",
            genderNotSpecified: "Prefiero no decirlo",
            genderMale: "Masculino",
            genderFemale: "Femenino",
            email: "Correo electrónico",
            mobile: "Teléfono móvil",
            password: "Contraseña",
            password2: "Repetir contraseña",
            manager: "Administrador de liga / academia",
            sponsor: "Patrocinador / anunciante",
            orgType: "Tipo de organización",
            orgName: "Nombre de la organización",
            sponsorName: "Nombre del negocio / patrocinador",
            website: "Sitio web",
            contactName: "Nombre de contacto",
            contactEmail: "Correo electrónico de contacto",
            sportAudience: "Deporte principal / público objetivo",
            orgLocation: "¿Dónde se encuentra tu liga o academia?",
            orgLocationInfo: "Usamos esto para mostrar tu organización en búsquedas locales, mapas y Connect.",
            sponsorLocation: "¿Dónde se encuentra tu negocio?",
            sponsorLocationInfo: "Usamos esto para segmentación local (por ejemplo, mostrar tu promoción a personas cercanas).",
            yourLocation: "Tu ubicación",
            orgLabelLocation: "La ubicación ayuda a equipos y jugadores a descubrir tu liga o academia.",
            sponsorLabelLocation: "La ubicación nos ayuda a mostrar tu promoción a jugadores y usuarios cercanos.",
            agreeTo: "Acepto los",
            terms: "Términos de uso",
            creatingLabel: "Creando cuenta...",
            sports: {
                "american-football": "Fútbol americano",
                baseball: "Béisbol",
                basketball: "Baloncesto",
                hockey: "Hockey",
                rugby: "Rugby",
                soccer: "Fútbol",
                softball: "Softbol",
                volleyball: "Voleibol",
                multi: "Deportes múltiples / generales"
            },
            "player": "Jugador",
            "playerDescription": "Únete a equipos, administra tu perfil y participa en eventos.",
            "managerDescription": "Crea ligas, academias, equipos, calendarios y administra eventos.",
            "sponsorDescription": "Promociona tu negocio en comunidades deportivas y audiencias locales.",
            "locationInfo": "Información de ubicación",
            "yourLocationInfo": "Tu ubicación nos ayuda a conectarte con equipos, ligas, eventos y oportunidades deportivas cercanas.",
            "playerLabelLocation": "Se usa para conectarte con oportunidades deportivas cercanas."
        },
        alreadyHaveAccount: "Ya tengo una cuenta",
        toast: {
            created: "¡Cuenta creada! Revisa tu correo electrónico para activarla y luego podrás iniciar sesión.",
            error: "Algo salió mal. Por favor intenta nuevamente más tarde o contacta con AngeonX Sports soporte."
        }
    },
    resenActivation: {
        title: "Introduce tu correo electrónico para reenviar el enlace de activación",
        status: "✅ ¡El correo de activación ha sido enviado correctamente!",
        toast: {
            sent: "¡Correo de activación enviado!",
            unknownError: "Ocurrió un error desconocido.",
            failed: "❌ No se pudo reenviar el correo de activación.",
            wrong: "⚠️ Algo salió mal. Por favor intenta nuevamente.",
            error: "Error al enviar el correo. Intenta más tarde."
        }
    },
    forgotPassword: {
        title: "Introduce tu correo electrónico para restablecer tu contraseña",
        button: "Enviar enlace de recuperación"
    },
    policy: {
        title: "Términos de Servicio y Política de Privacidad",
    },
    topBar: {
        passion: "¡Donde la pasión se transforma en rendimiento!",
        powerAi: "Gestión deportiva inteligente, impulsada por IA",
        ourTech: "Tu juego, tu tecnología"
    },
    home: {
        hero: {
            title: "Bienvenido a",
            subtitle: "Portal oficial de la liga. Sigue divisiones, calendarios, resultados y estadísticas en un solo lugar.",
        },
        divisions: {
            noItems: "Aún no hay divisiones disponibles.",
            open: "ABIERTA",
            closed: "CERRADA",
            seasonStart: "Inicio de la temporada",
            seasonEnd: "Fin de la temporada",
        },
        upcomingGames: {
            title: "Próximos partidos",
            noItems: "No hay próximos partidos programados."
        },
        latestResults: {
            title: "Últimos resultados",
            noItems: "Aún no hay resultados disponibles."
        },
        game: {
            home: "Local",
            visitor: "Visitante",
            noPlay: "No jugado",
            final: "Final",
            noScore: "Sin marcador",
            field: "Cancha"
        },
        eventStatus: {
            draft: "Borrador",
            scheduled: "Programado",
            in_progress: "En progreso",
            completed: "Finalizado",
            canceled: "Cancelado",
            forfeit: "Forfeit",
            double_forfeit: "Doble forfeit",
            extra: "Entradas / tiempo extra"
        },
        partners: {
            title: "Socios oficiales",
            subtitle: "Con el orgulloso respaldo de organizaciones de confianza"
        },
        footer: {
            brandTitle: "Portal oficial en AngeonX Sports",
            terms: "Términos y condiciones",
            contact: "Contacto",
            rights: "© {year} AngeonX Inc. Todos los derechos reservados.",
            angeonx: "AngeonX Sports™ es un producto de AngeonX Inc. (angeonx.com | angeonx.ca)",
            poweredBy: "Impulsado por",
            version: "Versión"
        }
    },
    defaultHome: {
        hero: {
            title: "Revolucionando la gestión deportiva",
            subtitle: "Programación impulsada por IA, seguimiento de resultados y análisis de rendimiento. Plataforma de gestión deportiva para ligas, torneos y academias. Deportes de equipo e individuales."
        },
        youtube: {
            title: "Mira tutoriales en YouTube",
            subtitle: "AngeonX Sports está transformando la forma en que ligas, torneos y academias gestionan el deporte — todo desde una sola plataforma, diseñada para máxima flexibilidad y control.",
            why: "¿Por qué AngeonX Sports?",
            because: "Porque necesitas más que hojas de cálculo y chats — necesitas herramientas potentes que trabajen juntas.",
            visitButton: "Ir al canal"
        },
        keyFeatures: {
            title: "Funcionalidades claves",
            feature1: {
                title: "Planificación inteligente",
                subtitle: "Calendarios automatizados que minimizan conflictos."
            },
            feature2: {
                title: "Análisis de rendimiento",
                subtitle: "Análisis del rendimiento de jugadores y equipos impulsado por IA."
            },
            feature3: {
                title: "Resultados y estadísticas",
                subtitle: "Sigue fácilmente los resultados de los partidos y la clasificación."
            },
            feature4: {
                title: "Calificación de árbitros",
                subtitle: "Evalúa a los árbitros según su desempeño."
            },
            feature5: {
                title: "Mercado deportivo",
                subtitle: "Encuentra ligas, equipos, jugadores y árbitros."
            }
        },
        advertise: {
            title: "Para patrocinadores y negocios locales",
            subtitle: "Haz que tu marca llegue a jugadores, padres y equipos en tu área — directamente dentro de la app de AngeonX Sports.",
            bullet1: "Publica tu anuncio en nuestra aplicación móvil",
            bullet2: "Segmenta por deporte y ubicación (fútbol, béisbol, etc.)",
            bullet3: "Sin contratos largos — ejecuta campañas semanales"
        },
        elevate: {
            title: "¿Listo para llevar tu organización deportiva al siguiente nivel?",
            subtitle: "Comienza a gestionar tu liga con programación inteligente y análisis impulsados por IA."
        },
        download: {
            title: "Descarga la app de AngeonX Sports",
            subtitle: "Mantente conectado con tu liga, tu equipo y tus eventos — directamente desde tu teléfono.",
            scanLabel: "Escanea para descargar"
        }
    },
    termsPolicy: {
        heroTitle: "Términos de Servicio y Política de Privacidad",
        effectiveDateLabel: "Fecha de entrada en vigor",
        effectiveDate: "9 de marzo de 2025",
        lastUpdatedLabel: "Última actualización",
        lastUpdated: "19 de mayo de 2026",

        intro: {
            p1: "AngeonX Sports (\"nosotros\", \"nos\", \"nuestro\") es operado por AngeonX Inc., una corporación incorporada en Manitoba, Canadá.",
            p2: "Al acceder o utilizar el sitio web o las aplicaciones móviles de AngeonX Sports (la \"Plataforma\"), aceptas quedar sujeto a estos Términos de Servicio y Política de Privacidad (\"Términos\"). Si no estás de acuerdo, no debes utilizar la Plataforma."
        },
        summary: {
            title: "Resumen en lenguaje claro",
            p1: "Para operar ligas y beneficios para usuarios, podemos compartir datos personales limitados con socios autorizados solo cuando sea necesario para prestar servicios solicitados.",
            bullets: [
                "Esto puede incluir nombre, apellido, correo electrónico, número móvil y fecha de nacimiento cuando sea necesario para operaciones de liga o gestión de seguros/beneficios.",
                "Compartimos únicamente los datos mínimos necesarios para el propósito específico del servicio.",
                "Al crear una cuenta o continuar usando AngeonX Sports, aceptas estos términos de uso y compartición de datos."
            ]
        },

        termsOfService: {
            title: "1. Términos de Servicio",

            eligibility: {
                title: "1.1 Elegibilidad",
                p1: "Debes tener al menos 13 años para usar la Plataforma. Si eres menor de edad en tu jurisdicción, solo podrás usar la Plataforma bajo la supervisión y consentimiento de un padre o tutor legal. Los padres o tutores son responsables de supervisar el uso de la Plataforma por parte de los menores."
            },

            userAccounts: {
                title: "1.2 Cuentas de Usuario",
                p1: "Para usar AngeonX Sports, debes proporcionar información de registro precisa, incluyendo nombre, correo electrónico y número de teléfono móvil. Aceptas:",
                bullets: [
                    "Mantener la confidencialidad de tus credenciales de acceso.",
                    "Aceptar la responsabilidad por toda la actividad realizada en tu cuenta.",
                    "Notificarnos inmediatamente sobre cualquier acceso o uso no autorizado."
                ],
                p2: "Nos reservamos el derecho de suspender o cancelar cuentas que violen estos Términos."
            },

            platformPurpose: {
                title: "1.3 Propósito de la Plataforma",
                p1: "AngeonX Sports es una plataforma de gestión deportiva que permite:",
                bullets: [
                    "Gestión de ligas y academias.",
                    "Gestión de equipos y jugadores.",
                    "Programación de partidos y eventos.",
                    "Marcadores en vivo y tablas de posiciones.",
                    "Mensajería y comunicación.",
                    "Interacciones en Connect.",
                    "Calificaciones y comentarios sobre árbitros.",
                    "Funciones premium basadas en suscripción."
                ],
                p2: "La Plataforma se proporciona únicamente como una herramienta de gestión. No somos responsables de eventos deportivos reales, del rendimiento de los jugadores, de decisiones arbitrales ni de resultados en el mundo real."
            },

            userConduct: {
                title: "1.4 Conducta del Usuario",
                p1: "Al usar AngeonX Sports, aceptas no:",
                bullets: [
                    "Participar en acoso, discurso de odio o comportamiento abusivo.",
                    "Publicar información difamatoria, falsa o engañosa.",
                    "Usar la Plataforma para actividades fraudulentas o ilegales.",
                    "Intentar obtener acceso no autorizado a cualquier parte de la Plataforma.",
                    "Realizar ingeniería inversa, descompilar o intentar obtener el código fuente de la Plataforma."
                ],
                p2: "Nos reservamos el derecho de eliminar contenido o suspender cuentas a nuestra discreción si consideramos que estos Términos han sido violados."
            },

            userGeneratedContent: {
                title: "1.5 Contenido Generado por los Usuarios",
                p1: "Los usuarios pueden enviar contenido, incluidos mensajes, calificaciones, estadísticas, anuncios, fotos e información de perfil (en conjunto, el \"Contenido del Usuario\").",
                p2: "Conservas la propiedad de tu Contenido del Usuario, pero otorgas a AngeonX Sports (AngeonX Inc.) una licencia no exclusiva, mundial y libre de regalías para usar, alojar, almacenar, reproducir, modificar y mostrar dicho contenido únicamente con el propósito de operar, mantener y mejorar la Plataforma.",
                p3: "Eres el único responsable del Contenido del Usuario que envías. No somos responsables del Contenido del Usuario publicado por los usuarios, pero podemos eliminar contenido que viole estos Términos o la ley aplicable."
            },

            refereeRatings: {
                title: "1.6 Calificaciones y Reseñas de Árbitros",
                p1: "Los usuarios pueden enviar calificaciones o comentarios sobre árbitros, umpires, entrenadores u otros participantes. Al enviar dichas calificaciones, aceptas:",
                bullets: [
                    "Proporcionar evaluaciones veraces y justas basadas en tu experiencia.",
                    "No publicar contenido difamatorio, discriminatorio o malicioso."
                ],
                p2: "Las opiniones expresadas en las calificaciones y comentarios pertenecen a los usuarios individuales y no representan necesariamente las opiniones de AngeonX Sports. No somos responsables del contenido de dichas calificaciones, pero podemos eliminarlas o moderarlas cuando corresponda."
            },

            subscriptions: {
                title: "1.7 Suscripciones, Facturación y Política de Reembolsos",
                p1: "Ciertas funciones de la Plataforma solo están disponibles a través de suscripciones pagadas o planes premium. Al suscribirte, aceptas:",
                bullets1: [
                    "Pagar todas las tarifas aplicables asociadas a tu plan elegido.",
                    "La renovación automática de tu suscripción al final de cada período de facturación, a menos que canceles antes de la renovación.",
                    "Los precios pueden variar según la moneda y la región, y pueden aplicarse impuestos."
                ],
                p2: "Puedes cancelar tu suscripción en cualquier momento a través de la Plataforma, y conservarás el acceso a las funciones premium hasta el final del período de facturación actual. Salvo que la ley lo exija, las tarifas de suscripción no son reembolsables.",
                p3: "Si se ofrece una prueba gratuita, los usuarios tendrán acceso a las funciones premium durante la duración del período de prueba sin costo.",
                p4: "Al final del período de prueba:",
                bullets2: [
                    "La suscripción no se convertirá automáticamente en un plan pagado.",
                    "La cuenta del usuario se degradará automáticamente al plan Free, a menos que el usuario se suscriba activamente a un plan pagado.",
                    "No se aplicará ningún cargo a menos que el usuario complete explícitamente la compra de una suscripción pagada."
                ],
                p5: "Los detalles sobre la duración de la prueba y las funciones incluidas se proporcionarán en el momento de la inscripción."
            },

            stripe: {
                title: "1.8 Procesamiento de Pagos con Stripe",
                p1: "Todas las transacciones de pago en AngeonX Sports son procesadas por Stripe, Inc. (\"Stripe\"). No recopilamos, almacenamos ni procesamos directamente la información completa de tu tarjeta de crédito o detalles de pago. Cuando realizas una compra o te suscribes a un plan, tus datos de pago se transmiten directamente a Stripe y están sujetos a sus políticas.",
                p2: "Al realizar cualquier pago a través de la Plataforma, tú:",
                bullets: [
                    "Aceptas estar sujeto a los Términos de Servicio y la Política de Privacidad de Stripe.",
                    "Reconoces que los servicios de procesamiento de pagos son proporcionados por Stripe y están sujetos a sus acuerdos."
                ],
                p3: "Las políticas actuales de Stripe están disponibles en",
                legalLinkLabel: "Stripe Legal",
                privacyLinkLabel: "Stripe Privacy",
                p4: "No somos responsables de:",
                bullets2: [
                    "Retrasos o fallos en el procesamiento de pagos.",
                    "Autorizaciones de tarjeta o verificaciones antifraude realizadas por Stripe o tu banco.",
                    "La gestión de contracargos o disputas regidas por las reglas de Stripe.",
                    "Las tasas de conversión de divisas aplicadas por Stripe o tu institución financiera."
                ]
            },

            thirdParty: {
                title: "1.9 Servicios de Terceros",
                p1: "Podemos utilizar proveedores de servicios de terceros para operar y dar soporte a la Plataforma, incluyendo, entre otros:",
                bullets: [
                    "Procesadores de pago (por ejemplo, Stripe).",
                    "Proveedores de alojamiento en la nube.",
                    "Servicios de notificaciones y mensajería.",
                    "Proveedores de analítica.",
                    "Socios deportivos autorizados (como ligas y federaciones) y proveedores de beneficios (como aseguradoras) cuando sea necesario para prestar servicios o beneficios solicitados."
                ],
                p2: "El uso de estos servicios de terceros puede estar sujeto a sus respectivos términos y políticas de privacidad."
            },

            intellectualProperty: {
                title: "1.10 Propiedad Intelectual",
                p1: "Todo el contenido y los materiales de la Plataforma, incluidos, entre otros, el nombre AngeonX Sports, el logotipo, la marca, el código del software, el diseño de la interfaz de usuario y las marcas comerciales, son propiedad de AngeonX Inc. o de sus licenciantes y están protegidos por las leyes de propiedad intelectual.",
                p2: "No puedes reproducir, distribuir, modificar, crear obras derivadas ni mostrar públicamente ninguna parte de la Plataforma sin nuestro consentimiento previo por escrito.",
                p3: "Las suscripciones White-label o Elite pueden permitir la personalización cosmética de la marca (por ejemplo, logotipo, colores o subdominio personalizados) para las organizaciones, pero no transfieren la propiedad del software subyacente ni de la Plataforma."
            },

            marketingRights: {
                title: "1.11 Derechos de Marketing y Publicidad",
                p1: "Al utilizar la Plataforma, las organizaciones y los usuarios otorgan a AngeonX Sports (AngeonX Inc.) una licencia no exclusiva, mundial y libre de regalías para utilizar la siguiente información con fines de marketing y promoción:",
                bullets1: [
                    "Nombres de organizaciones, ligas y equipos.",
                    "Logotipos y activos de marca mostrados públicamente.",
                    "Testimonios enviados voluntariamente por usuarios u organizaciones.",
                    "Estadísticas de uso no sensibles (por ejemplo, número de partidos, ligas o equipos gestionados).",
                    "Capturas de pantalla públicas de clasificaciones, calendarios o vistas de la Plataforma sin exponer datos personales."
                ],
                p2: "Esta licencia es únicamente para:",
                bullets2: [
                    "Campañas de marketing y materiales promocionales.",
                    "Casos de estudio y muestras en el sitio web.",
                    "Publicaciones en redes sociales.",
                    "Presentaciones de ventas o para inversionistas."
                ],
                p3: "No utilizaremos:",
                bullets3: [
                    "Datos personales privados como direcciones de correo electrónico o números de teléfono para marketing público.",
                    "Información financiera o detalles de pago.",
                    "Datos personales sensibles.",
                    "Imágenes identificables o información personal de menores para marketing sin el consentimiento adecuado (por ejemplo, consentimiento parental u organizacional cuando sea requerido)."
                ],
                p4: "Si una organización o un usuario desea excluirse del uso de marketing, puede contactarnos por escrito en",
                email: "kbolasports@angeonx.com"
            },

            advertising: {
                title: "1.12 Publicidad y Patrocinios",
                p1: "La Plataforma puede mostrar anuncios, banners de patrocinadores o contenido promocional. No respaldamos ni garantizamos ningún producto o servicio de terceros presentado en dichos anuncios.",
                p2: "Los usuarios interactúan con anunciantes o patrocinadores bajo su propio riesgo, y cualquier disputa o reclamación será únicamente entre el usuario y el tercero."
            },

            serviceAvailability: {
                title: "1.13 Disponibilidad del Servicio y Exención de Garantías",
                p1: "La Plataforma se proporciona \"tal cual\" y \"según disponibilidad\", sin garantías de ningún tipo, ya sean expresas o implícitas, incluidas, entre otras, garantías implícitas de comerciabilidad, idoneidad para un propósito particular o no infracción.",
                p2: "No garantizamos que:",
                bullets: [
                    "La Plataforma sea ininterrumpida, oportuna, segura o libre de errores.",
                    "Los datos (incluidos puntajes, clasificaciones o calendarios) sean siempre precisos o estén actualizados.",
                    "Los defectos se corregirán inmediatamente."
                ]
            },

            limitation: {
                title: "1.14 Limitación de Responsabilidad",
                p1: "En la máxima medida permitida por la ley, AngeonX Sports y AngeonX Inc. (incluidos sus directores, funcionarios, empleados y afiliados) no serán responsables por daños indirectos, incidentales, especiales, consecuentes o punitivos, ni por pérdida de beneficios o ingresos, ya sean incurridos directa o indirectamente, ni por pérdida de datos, fondo de comercio u otras pérdidas intangibles, resultantes de:",
                bullets: [
                    "Tu acceso o uso de la Plataforma, o la imposibilidad de acceder o usarla.",
                    "Cualquier conducta o contenido de otros usuarios o terceros en la Plataforma.",
                    "Errores o inexactitudes en calendarios, resultados, clasificaciones o estadísticas.",
                    "Tiempo de inactividad, retrasos o fallos de infraestructura o servicios de terceros.",
                    "Problemas de procesamiento de pagos, disputas o contracargos gestionados por Stripe o bancos."
                ]
            },

            indemnification: {
                title: "1.15 Indemnización",
                p1: "Aceptas indemnizar y eximir de responsabilidad a AngeonX Inc., AngeonX Sports y a sus funcionarios, directores, empleados y agentes frente a cualquier reclamación, responsabilidad, daño, pérdida y gasto (incluidos honorarios legales razonables) que surjan de o estén relacionados de cualquier manera con:",
                bullets: [
                    "Tu acceso o uso de la Plataforma.",
                    "Tu violación de estos Términos.",
                    "Tu Contenido del Usuario.",
                    "Cualquier disputa entre tú y otro usuario u organización."
                ]
            },

            governingLaw: {
                title: "1.16 Ley Aplicable",
                p1: "Estos Términos se rigen e interpretan de conformidad con las leyes de la Provincia de Manitoba y las leyes federales de Canadá aplicables en ella. Cualquier disputa derivada de estos Términos o del uso de la Plataforma estará sujeta a la jurisdicción exclusiva de los tribunales ubicados en Manitoba, Canadá."
            }
        },

        privacyPolicy: {
            title: "2. Política de Privacidad",

            collect: {
                title: "2.1 Información que Recopilamos",
                p1: "Cuando utilizas AngeonX Sports, recopilamos los siguientes tipos de información:",
                bullets: [
                    "Información personal: nombre, apellido, dirección de correo electrónico, número de teléfono móvil, fecha de nacimiento y otros datos de perfil proporcionados por ti.",
                    "Información de uso: registros de actividad, información del dispositivo, dirección IP, interacciones con funciones de la Plataforma y análisis de rendimiento utilizados para mejorar nuestros servicios.",
                    "Información de suscripción: tipo de plan, estado de facturación, moneda y datos relacionados con pagos no asociados a tarjeta."
                ]
            },

            payments: {
                title: "Pagos e Información de Tarjeta de Crédito",
                p1: "No recopilamos, almacenamos ni procesamos directamente la información de tu tarjeta de crédito o pagos. Todas las transacciones se gestionan de forma segura a través de nuestro procesador de pagos externo de confianza, Stripe. Cuando realizas una compra o te suscribes a un plan, tus datos de pago se transmiten directamente a Stripe y están sujetos a su Política de Privacidad y Términos de Servicio. Al usar nuestros servicios y realizar cualquier pago a través de la Plataforma, también aceptas quedar sujeto a las políticas y términos de Stripe."
            },

            useData: {
                title: "2.2 Cómo Usamos tus Datos",
                p1: "Usamos la información que recopilamos para:",
                bullets: [
                    "Crear y gestionar tu cuenta.",
                    "Permitir la comunicación y colaboración entre usuarios mediante chat y notificaciones.",
                    "Operar y gestionar ligas, equipos, calendarios y eventos.",
                    "Brindar soporte al cliente y responder consultas.",
                    "Mejorar y optimizar las funciones y el rendimiento de la Plataforma.",
                    "Hacer cumplir estos Términos y proteger la integridad de la Plataforma."
                ]
            },

            contactSharing: {
                title: "2.3 Compartición de Información de Contacto",
                p1: "De forma predeterminada, tu información de contacto (nombre, correo electrónico, número móvil) no se comparte con terceros fuera de la Plataforma. Dentro de la Plataforma:",
                bullets: [
                    "Puedes elegir en tus preferencias compartir tus datos de contacto (correo electrónico y móvil) con administradores de organizaciones o equipos dentro del módulo Connect de la app para coordinar oportunidades o invitaciones.",
                    "Si no activas esta opción, toda la comunicación se gestionará a través del sistema de mensajería y chat interno."
                ]
            },

            dataSharing: {
                title: "2.4 Política de Compartición de Datos",
                p1: "No vendemos tu información personal. Compartimos información personal solo cuando es necesario para operar la Plataforma, prestar servicios o beneficios deportivos solicitados, o cumplir obligaciones legales. Podemos compartir datos con:",
                bullets: [
                    "Con proveedores de servicios (por ejemplo, Stripe, hosting, notificaciones) que ayudan a operar la Plataforma.",
                    "Con organizaciones asociadas autorizadas que participan en operaciones deportivas o beneficios para usuarios (por ejemplo, ligas, federaciones o aseguradoras), solo para fines legítimos de servicio como verificación de elegibilidad, registro, programación, gestión de reclamaciones o activación de beneficios.",
                    "Únicamente los datos mínimos necesarios para el fin específico, que pueden incluir nombre, apellido, correo electrónico, número móvil y fecha de nacimiento cuando lo exija el servicio asociado.",
                    "Cuando lo requiera la ley, una regulación o un proceso legal.",
                    "Para proteger los derechos, la propiedad o la seguridad de AngeonX Sports, nuestros usuarios o el público."
                ],
                p2: "AngeonX Sports y AngeonX Inc. no son responsables por el uso indebido independiente de datos personales por parte de organizaciones de terceros después de una compartición lícita conforme a esta Política. Sin embargo, exigimos que los terceros autorizados procesen los datos solo para fines de servicio aprobados y bajo salvaguardas contractuales y legales adecuadas."
            },

            retention: {
                title: "2.5 Retención de Datos",
                p1: "Conservamos los datos personales mientras tu cuenta permanezca activa o según sea necesario para proporcionar la Plataforma y cumplir obligaciones legales. Después de la eliminación de la cuenta:",
                bullets: [
                    "Eliminamos o anonimizamos los datos personales del perfil cuando sea posible.",
                    "Algunos datos (por ejemplo, registros, copias de seguridad) pueden conservarse durante un período limitado por motivos de seguridad, prevención de fraude o cumplimiento legal."
                ]
            },

            security: {
                title: "2.6 Seguridad de los Datos",
                p1: "Implementamos medidas técnicas y organizativas estándar de la industria para proteger tu información contra acceso no autorizado, pérdida, uso indebido o alteración. Sin embargo, ninguna plataforma en línea puede garantizar una seguridad del 100 %, y tú eres responsable de proteger tus credenciales de acceso."
            },

            children: {
                title: "2.7 Privacidad de los Niños",
                p1: "No recopilamos conscientemente información personal de niños menores de 13 años sin el consentimiento de sus padres. Si llegamos a saber que hemos recopilado información personal de un menor de 13 años sin el consentimiento adecuado, tomaremos medidas para eliminar dicha información.",
                p2: "Los padres o tutores que crean que su hijo ha proporcionado información personal pueden contactarnos en",
                email: "kbolasports@angeonx.com",
                p3: "para solicitar la eliminación."
            },

            international: {
                title: "2.8 Usuarios Internacionales",
                p1: "Si accedes a la Plataforma desde fuera de Canadá, entiendes y aceptas que tu información puede ser transferida, almacenada y procesada en Canadá y en otros países donde operan nuestros proveedores de servicios. Las leyes de protección de datos pueden diferir de las de tu jurisdicción."
            },

            rights: {
                title: "2.9 Tus Derechos",
                p1: "Dependiendo de tu jurisdicción, puedes tener derechos respecto a tus datos personales, incluido el derecho a:",
                bullets: [
                    "Solicitar acceso a los datos personales que conservamos sobre ti.",
                    "Solicitar la corrección de datos inexactos o incompletos.",
                    "Solicitar la eliminación de tus datos personales, sujeto a los requisitos legales.",
                    "Controlar cómo se comparte tu información de contacto dentro de la Plataforma."
                ],
                p2: "Las solicitudes relacionadas con tus datos pueden enviarse a",
                email: "kbolasports@angeonx.com"
            },

            updates: {
                title: "2.10 Actualizaciones de la Política",
                p1: "Podemos actualizar estos Términos y esta Política de Privacidad periódicamente para reflejar cambios en nuestras prácticas, requisitos legales o funciones de la Plataforma. Cuando hagamos cambios materiales, te notificaremos a través de la Plataforma o por otros medios razonables. El uso continuo de la Plataforma después de dichos cambios constituye tu aceptación de los Términos actualizados."
            }
        },

        contact: {
            title: "3. Contáctanos",
            p1: "Si tienes alguna pregunta sobre estos Términos de Servicio o esta Política de Privacidad, o si deseas ejercer cualquiera de tus derechos, contáctanos en:",
            company: "AngeonX Inc.",
            city: "Winnipeg, Manitoba, Canadá",
            emailLabel: "Correo electrónico",
            email: "kbolasports@angeonx.com",
            p2: "Al crear una cuenta, acceder o continuar usando AngeonX Sports, reconoces que has leído, entendido y aceptas estos Términos de Servicio y esta Política de Privacidad, incluyendo el intercambio limitado de datos personales con ligas autorizadas y proveedores de beneficios (como aseguradoras) estrictamente para prestar servicios y beneficios solicitados."
        }
    },
    header: {
        quickActions: {
            title: "Acciones rápidas",
            subtitle: "Crea y navega más rápido",
            newOrg: "Nueva organización",
            addVenue: "Agregar campo o cancha",
            subscriptions: "Suscripciones",
            newSponsor: "Nuevo patrocinador",
            newCampaign: "Nueva campaña"
        },
        notifications: {
            title: "Notificationes",
            unread: "no leídas",
            subtitle: "Estás al día",
            noUnread: "No hay notificaciones sin leer",
            info: "Verás actualizaciones aquí a medida que ocurra actividad.",
            viewMore: "Ver más"
        },
        switchProfile: {
            title: "Cambiar perfil",
            profile: "perfil",
            active: "Perfil activo",
            switchProfile: "Cambiar a este perfil",
            activeBadge: "Activo",
            switch: "Cambiar",
            plans: "Planes",
            invoices: "Facturas",
            subscriptions: "Suscripciones",
            logout: "Cerrar sesión"
        }
    },
    sidebar: {
        core: "Principal",
        people: "Personas",
        management: "Gestión",
        officials: "Oficiales",
        referees: "Árbitros / Umpires",
        assignments: "Asignaciones",
        organizations: "Organizaciones",
        players: "Jugadores",
        financialDashboard: "Panel financiero",
        settings: "Configuración",
        venue: "Instalaciones",
        waivers: "Exenciones",
        sanctions: "Reglas & sanciones",
        payoutAccounts: "Cuentas de pago",
        staff: "Personal",
        subscriptions: "Suscripciones",
        plans: "Planes",
        invoices: "Facturas",
        admin: "Admin",
        advertising: "Publicidad",
        adsDashboard: "Panel de anuncios",
        dashboard: "Panel de control",
        audience: "Audiencia",
        managementData: "Datos de gestión",
        sponsors: "Patrocinadores",
        campaigns: "Campañas",
        commerce: "Comercio",
        marketplace: "Marketplace"
    },
    refereesPage: {
        title: "Árbitros / Umpires", officialsTitle: "Oficiales", officialsEmpty: "No se encontraron oficiales activos.", addOfficial: "Añadir oficial", addExistingOfficial: "Añadir oficial existente", createOfficial: "Crear nuevo oficial", officialRole: "Oficial", findOfficials: "Buscar oficiales", filterOfficials: "Busca y filtra los oficiales de tus organizaciones.",
        settings: "Configuración",
        subtitle: "Gestiona los oficiales activos de tu organización.",
        empty: "No se encontraron árbitros o umpires activos.",
        add: "Añadir árbitro", addExisting: "Añadir árbitro existente", create: "Crear nuevo árbitro",
        official: "Oficial",
        organization: "Organización",
        contact: "Contacto",
        location: "Ubicación",
        status: "Estado", activate: "Activar", deactivate: "Desactivar", statuses: {accepted: "Activo", inactive: "Inactivo"},
        roleLabel: "Árbitro / Umpire",
        detailsEyebrow: "Perfil del oficial", viewDetails: "Ver detalles", rating: "Valoración",
        filtersBadge: "Filtros", filtersTitle: "Buscar árbitros", filtersSubtitle: "Busca y filtra los oficiales de tus organizaciones.", search: "Buscar", searchPlaceholder: "Buscar por nombre o email", allOrganizations: "Todas las organizaciones", sport: "Deporte", allSports: "Todos los deportes", allStatuses: "Todos los estados",
    },
assignmentsPage: {
        upgradePlanLabel: "PREMIUM", upgradeTitle: "Asignaciones de partidos no disponibles", upgradeSubtitle: "Esta función está disponible con planes de organización Enterprise.", upgradeCta: "Mejorar plan", upgradeTextPrefix: "Para gestionar las asignaciones de partidos de tus organizaciones, por favor", upgradeTextLink: "mejora tu suscripción",
        cancelOfficial: "Cancelar invitación", assignmentCancelled: "Asignación del oficial cancelada.",
        manageOfficials: "Gestionar oficiales",
        matchDay: "Jornada",
        detailsBadge: "Detalles de la asignación", historyTitle: "Historial de invitaciones", historySubtitle: "Revisa cada invitación y respuesta de los oficiales para este partido.", unknownOfficial: "Oficial desconocido", assignedBy: "Asignado por", systemAssignment: "Asignación del sistema", noAssignmentHistory: "Sin historial de invitaciones", noAssignmentHistoryHint: "Todavía no se han creado invitaciones de oficiales para este partido.",
        facilityTerm: "Instalaciones", assignFacilities: "Asignar instalaciones", facility: "Instalación", selectFacility: "Selecciona una instalación", facilityHint: "La instalación seleccionada se aplicará a todos los partidos seleccionados.", facilitiesTableTitle: "Asignaciones de instalaciones", facilitiesTableSubtitle: "Revisa y asigna instalaciones entre divisiones desde un solo espacio.",
        summary: {scheduled: "Programados", accepted: "Cubiertos", pending: "Pendientes", unassigned: "Sin asignar"},
        filters: "Filtros", scheduledOnly: "Solo partidos programados", clearFilters: "Limpiar filtros",
        allOfficials: "Todos los oficiales",
        assignmentModeAll: "Todos los partidos", assignmentModePerGame: "Por partido", coordinatorAssignmentModeHint: "Los coordinadores seleccionados se aplicarán a todos los partidos seleccionados.",
        applyToAllGames: "Aplicar a todos los partidos", saveAssignment: "Guardar asignaciones",
        fieldConflict: "El campo ya está reservado durante este horario.", refereeConflict: "El árbitro ya está asignado durante este horario.", coordinatorConflict: "El coordinador ya está asignado durante este horario.", conflictingEvent: "Partido en conflicto:", conflictingSelection: "Selección en conflicto:",
        assigned: "Asignado", unassigned: "Sin asignar", officialsTerm: "Oficiales", officialsWorkspaceTitle: "Asignaciones de oficiales", officialsWorkspaceBadge: "Oficiales", officialsWorkspaceSubtitle: "Coordina la cobertura de oficiales entre todas las divisiones de tu organización.", officialsTableTitle: "Asignaciones de oficiales", officialsTableSubtitle: "Selecciona partidos programados para invitar oficiales de sus grupos de fase.", officialsColumn: "Oficiales", officialsToInvite: "Oficiales a invitar", noOfficialsAssigned: "No hay oficiales asignados", assignOfficials: "Asignar oficiales",
        badge: "Operaciones de oficiales", title: "Asignaciones de árbitros", subtitle: "Coordina la cobertura arbitral de todas las divisiones de tu organización.", tableSubtitle: "Selecciona partidos programados para invitar árbitros de sus grupos de fase.", organization: "Organización", selectOrganization: "Selecciona una organización", division: "División", allDivisions: "Todas las divisiones", season: "Temporada", allSeasons: "Todas las temporadas", status: "Estado de asignación", allStatuses: "Todos los estados", dateFrom: "Fecha desde", dateTo: "Fecha hasta", allFields: "Todos los campos", allCoordinators: "Todos los coordinadores", games: "partidos", game: "Partido", divisionStage: "División / fase", dateLocation: "Fecha / ubicación", referees: "Árbitros / umpires", noReferee: "Sin árbitro asignado", selectAll: "Seleccionar todos los partidos programados de esta página", assignSelected: "Asignar árbitros", assignCoordinator: "Asignar coordinador", assignField: "Asignar campo", coordinators: "Coordinadores", field: "Campo", selectField: "Selecciona un campo", fieldHint: "El campo seleccionado se aplicará a todos los partidos seleccionados.", coordinatorHint: "Selecciona uno o más coordinadores para todos los partidos seleccionados.", selectedGames: "{{count}} partido(s) seleccionado(s)", noCoordinators: "No hay coordinadores disponibles.", selectGameFirst: "Selecciona al menos un partido programado.", updated: "Asignaciones actualizadas correctamente.", updateFailed: "No se pudieron actualizar las asignaciones.", tabs: {officials: "Oficiales", coordinators: "Coordinadores", fields: "Campos"}, tables: {officials: {title: "Asignaciones de árbitros", subtitle: "Selecciona partidos programados para invitar árbitros de sus grupos de fase.", assignees: "Árbitros", empty: "Sin árbitro asignado"}, coordinators: {title: "Asignaciones de coordinadores", subtitle: "Asigna coordinadores entre divisiones desde un solo espacio.", assignees: "Coordinadores", empty: "Sin coordinador asignado"}, fields: {title: "Asignaciones de campos", subtitle: "Revisa y asigna campos entre divisiones desde un solo espacio.", assignees: "Campo", empty: "Sin campo asignado"}}, noOrganizationTitle: "No hay una organización disponible", noOrganizationSubtitle: "Necesitas acceso a una organización para gestionar las asignaciones de árbitros.",
    },
    managementData: {
        title: "Datos de gestión",
        subtitle: "Panel de staff para adopción de la plataforma, activación de clientes y uso operativo.",
        admin: "Admin",
        staffOnly: "Este panel solo está disponible para usuarios staff.",
        loading: "Cargando datos de gestión...",
        loadError: "No se pudieron cargar los datos de gestión.",
        healthLoadError: "No se pudieron cargar los datos de salud de organizaciones.",
        noData: "No hay datos disponibles",
        periodFilter: "Periodo de reporte",
        periods: {
            lastWeek: "Última semana",
            last30Days: "Últimos 30 días",
            last3Months: "Últimos 3 meses",
            last6Months: "Últimos 6 meses",
            last1Year: "Último año"
        },
        cards: {
            clients: "Organizaciones cliente",
            activeClients: "{count} clientes activos",
            activeUsers: "Usuarios activos",
            totalUsers: "{count} usuarios totales",
            periodRegistrations: "Registros del periodo",
            selectedPeriod: "Equipos más jugadores en el periodo",
            completedGames: "Juegos completados",
            totalGames: "{count} juegos totales"
        },
        periodCards: {
            organizations: "Nuevas organizaciones",
            orgBreakdown: "{leagues} ligas · {academies} academias · {teams} equipos",
            structure: "Nuevas divisiones/temporadas",
            structureHint: "{stages} etapas · {groups} grupos",
            gamesCreated: "Juegos creados",
            results: "{count} resultados completados",
            newUsers: "Nuevos usuarios",
            activeUsers: "{count} activos en el periodo"
        },
        charts: {
            growthTitle: "Tendencia de adopción",
            growthSubtitle: "Nuevas organizaciones, usuarios y juegos por periodo móvil.",
            activationTitle: "Embudo de activación de clientes",
            activationSubtitle: "Cuántas organizaciones cliente llegaron a cada hito de configuración.",
            organizationSubscriptionsTitle: "Suscripciones de organizaciones",
            organizationSubscriptionsSubtitle: "Suscripciones web activas por plan.",
            userSubscriptionsTitle: "Suscripciones de usuarios",
            userSubscriptionsSubtitle: "Suscripciones app activas y usuarios activos recientes por plan.",
            organizationTypesTitle: "Desglose por tipo de organización",
            organizationTypesSubtitle: "Inventario actual y crecimiento reciente por tipo."
        },
        chartLabels: {
            organizations: "Organizaciones",
            users: "Usuarios",
            games: "Juegos",
            clients: "Organizaciones cliente",
            active30Days: "Activos 30 días"
        },
        funnel: {
            clients: "Clientes",
            divisions: "Divisiones",
            seasons: "Temporadas",
            teams: "Equipos",
            players: "Jugadores",
            results: "Resultados"
        },
        tables: {
            topOrganizations: "Clientes más activados",
            atRiskOrganizations: "Clientes que requieren atención",
            atRiskOrganizationsLoading: "Clientes que requieren atención · cargando...",
            organizationSubscriptions: "Conteo de planes de organizaciones",
            organizationSubscriptionsSubtitle: "Cuántas organizaciones están actualmente en cada plan web.",
            userSubscriptions: "Conteo de planes de usuarios",
            userSubscriptionsSubtitle: "Cuántos usuarios están actualmente en cada plan app, con actividad reciente."
        },
        table: {
            organization: "Organización",
            organizations: "Organizaciones",
            score: "Puntaje",
            plan: "Plan",
            divisions: "Divisiones",
            teams: "Equipos",
            players: "Jugadores",
            users: "Usuarios",
            active7Days: "Activos 7d",
            active30Days: "Activos 30d",
            active90Days: "Activos 90d",
            completed: "Completados",
            type: "Tipo",
            total: "Total",
            active: "Activo",
            createdLast30Days: "Creados últimos 30 días"
        }
    },
    financial: {
        noticeTitle: "Aviso:",
        noticeText1: "Los pagos procesados a través de AngeonX Sports utilizan Stripe Connect.",
        noticeText2: "Stripe normalmente cobra",
        noticeText3: "por transacción, y AngeonX Sports aplica una",
        noticeText4: "comisión de plataforma (las suscripciones ELITE tienen una comisión del 2.5%). Estas se deducen antes del pago a las organizationes.",
        example: "Ejemplo con un pago de {amount} → Las organizationes recibirían aproximadamente {net}.",
        filtersBadge: "Filtros",
        paymentsTitle: "Pagos",
        filtersSubtitle: "Elige organización, división, temporada y estado.",
        resetFilters: "Restablecer filtros",
        reset: "Restablecer",

        organization: "Organización",
        selectLeague: "Seleccionar liga",
        division: "División",
        selectDivision: "Seleccionar división",
        season: "Temporada",
        selectSeason: "Seleccionar temporada",
        status: "Estado",
        all: "Todos",
        pending: "Pendiente",
        paid: "Pagado",

        autoRefreshHint: "Los cambios actualizan automáticamente la tabla.",

        total: "Total",
        overall: "General",
        outstanding: "Pendiente",

        tableTitle: "Pagos",
        tableHeaders: {
            status: "Estado",
            amount: "Monto",
            description: "Descripción",
            organization: "Organización",
            season: "Temporada",
            game: "Juego",
            relatedObject: "Objeto relacionado",
            profile: "Perfil",
            createdAt: "Creado el",
            dueDate: "Fecha límite",
            sanction: "Sanción"
        },

        noValue: "—"
    },
    feeCalculator: {
        badge: "Calc",
        subtitle: "Estima las comisiones de la plataforma y de Stripe Connect.",
        currencyInUse: "Moneda en uso",

        currency: "Moneda",
        amountPaid: "Monto pagado",
        appFeePct: "Comisión de la app %",
        stripePct: "Stripe %",
        stripeFixed: "Cargo fijo de Stripe",

        breakdownTitle: "Desglose",
        breakdownSubtitle: "Estos valores son estimados y pueden variar según el país y el método de pago.",

        userPays: "El usuario paga",
        kbolaFee: "Comisión de AngeonX Sports ({pct}%)",
        amountBeforeStripe: "Monto antes de la comisión de Stripe",
        stripeFee: "Comisión de Stripe ({pct}% + {fixed})",
        organizationReceives: "La organización recibe",

        stripeAccountNote: "Las comisiones de Stripe se cobran a la cuenta conectada.",

        defaultTitle: "Calculadora de comisiones"
    },
    venuesPage: {
        pageTitle: "Instalaciones",
        settings: "Configuración",

        tableTitle: "Instalaciones",
        headers: {
            name: "Nombre",
            description: "Descripción",
            fields: "Campos",
            createdBy: "Creado por",
            actions: "Acciones"
        },

        noValue: "—",
        fieldTitle: "Campo",

        editVenue: "Editar instalación",
        deleteVenue: "Eliminar instalación",

        deleteConfirmTitle: "¿Eliminar instalación?",
        deleteConfirmMessage: "Estás a punto de eliminar \"{name}\".\n\nLa instalación y sus campos serán eliminados. Esto puede afectar juegos programados que usen esos campos.\n\n¿Estás seguro de que deseas continuar?",
        deleteConfirmButton: "Eliminar instalación",
        cancel: "Cancelar",

        deleteSuccess: "¡Instalación eliminada correctamente!",
        deleteFailed: "No se pudo eliminar la instalación.",
        loadFailed: "No se pudieron cargar las instalaciones."
    },
    staffPage: {
        pageTitle: "Personal",
        settings: "Configuración",
        subtitle: "Managers y coordinadores de tus ligas",
        searchPlaceholder: "Buscar managers o coordinadores...",
        noOrganizations: "Sin ligas vinculadas",
        noOrganizationName: "Liga desconocida",
        upgradePlanLabel: "PREMIUM",
        upgradeTitle: "Gestión de personal no disponible",
        upgradeSubtitle: "Esta función está disponible en los planes para Organizaciones Empresarial.",
        upgradeCta: "Mejorar plan",
        upgradeTextPrefix: "Para gestionar managers y coordinadores de tus organizaciones, por favor",
        upgradeTextLink: "mejora tu suscripción",
        roles: {
            manager: "Manager",
            coordinator: "Coordinador"
        }
    },
    playersPage: {
        pageTitle: "Jugadores",
        settings: "Configuración",
        subtitle: "Jugadores y coaches de tus ligas",
        filtersBadge: "Filtros",
        filtersTitle: "Jugadores",
        filtersSubtitle: "Filtra por organización y rol de perfil.",
        search: "Buscar",
        searchPlaceholder: "Buscar por nombre, correo, teléfono, equipo u organización...",
        organization: "Organización",
        allOrganizations: "Todas las organizaciones",
        profile: "Perfil",
        allProfiles: "Todos los perfiles",
        resetFilters: "Restablecer filtros",
        reset: "Restablecer",
        download: "Descargar",
        downloading: "Descargando...",
        downloadExcel: "Descargar lista filtrada como Excel",
        upgradePlanLabel: "PREMIUM",
        upgradeTitle: "Lista de jugadores no disponible",
        upgradeSubtitle: "Esta función está disponible en los planes para Organizaciones Empresarial.",
        upgradeCta: "Mejorar plan",
        upgradeTextPrefix: "Para ver y exportar jugadores y coaches de tus organizaciones, por favor",
        upgradeTextLink: "mejora tu suscripción",
        autoRefreshHint: "Los cambios actualizan automáticamente la lista.",
        noValue: "—",
        roles: {
            coach: "Coach",
            player: "Jugador"
        },
        gender: {
            male: "Masculino",
            female: "Femenino"
        },
        fields: {
            fullName: "Nombre completo",
            email: "Correo electrónico",
            phone: "Teléfono",
            gender: "Género",
            dob: "Fecha de nacimiento",
            organization: "Organización",
            activeTeam: "Equipo activo",
            role: "Rol",
            league: "Liga"
        }
    },
    staffPicker: {
        title: "Agregar manager a la organización",
        organization: "Organización",
        noOrganizations: "No hay organizaciones disponibles",
        profile: "Perfil de usuario",
        searchPlaceholder: "Buscar perfiles de usuario...",
        add: "Agregar",
        alreadyAdded: "Agregado",
        loadError: "No se pudieron cargar los perfiles de usuario.",
        noProfiles: "No hay perfiles de usuario disponibles.",
        noSearchResults: "No se encontraron perfiles para esta busqueda.",
        addSuccess: "Manager agregado correctamente.",
        addError: "No se pudo agregar este manager."
    },
    refereePicker: {
        title: "Agregar árbitro / umpire a la organización",
        organization: "Organización", noOrganizations: "No hay organizaciones disponibles", profile: "Perfil de usuario",
        searchPlaceholder: "Buscar árbitros y umpires...", add: "Agregar", alreadyAdded: "Agregado",
        loadError: "No se pudieron cargar los árbitros.", noProfiles: "No hay árbitros disponibles.", noSearchResults: "No se encontraron árbitros.",
        addSuccess: "Árbitro agregado correctamente.", addError: "No se pudo agregar este árbitro."
    },
    table: {
        subtitle: "Gestiona los elementos de esta lista",
        add: "Agregar",
        loading: "Cargando…",
        noRecords: "No se encontraron registros",
        prev: "Anterior",
        next: "Siguiente",
        page: "Página",
        of: "de",
        previousPage: "Página anterior",
        nextPage: "Página siguiente",
        pagination: "Paginación",
        total: "Total",
        toggleDropdown: "Mostrar opciones",
        addItemTitle: "Agregar {title}",
        goToPage: "Ir a la página {page}"
    },
    venueCreateModal: {
        "venueNameRequired": "El nombre del venue es obligatorio.",
        "addressRequired": "Por favor selecciona una dirección válida.",
        "fieldLabel": "Campo {{number}}",
        "removeField": "Eliminar",
        badge: "NUEVO",
        title: "Crear instalación",
        subtitle: "Agrega una instalación y sus campos.",

        close: "Cerrar",

        venueName: "Nombre de la instalación",
        venueNamePlaceholder: "ej.: Maple Sports Complex",

        description: "Descripción (opcional)",
        descriptionPlaceholder: "Cualquier nota sobre esta instalación…",

        address: "Dirección",
        addressPlaceholder: "Buscar instalaciones deportivas",

        fieldsTitle: "Campos",
        itemsCount: "{count} elemento(s)",

        fieldName: "Nombre del campo",
        fieldNamePlaceholder: "ej.: Campo A",

        fieldDescription: "Descripción",
        fieldDescriptionPlaceholder: "ej.: Césped, luces, tamaño…",

        addAnotherField: "Agregar otro campo",
        addAnotherFieldTitle: "Agregar otro campo",

        cancel: "Cancelar",
        creating: "Creando…",
        createVenue: "Crear instalación",

        validationAtLeastOneField: "Por favor, ingresa al menos un campo.",
        createSuccess: "¡Instalación creada correctamente!",
        createFailed: "No se pudo crear la instalación."
    },
    venueEditModal: {
        "addressRequired": "Por favor selecciona una dirección válida.",
        "fieldLabel": "Campo {{number}}",
        "existingField": "Existente",
        "newField": "Nuevo",
        "removeField": "Eliminar",
        badge: "EDITAR",
        title: "Editar instalación",
        subtitle: "Actualiza los detalles de la instalación y sus campos.",

        close: "Cerrar",

        venueName: "Nombre de la instalación",
        venueNameRequired: "El nombre de la instalación es obligatorio.",

        description: "Descripción (opcional)",

        address: "Dirección",
        addressPlaceholder: "Buscar instalaciones deportivas",

        fieldsTitle: "Campos",
        itemsCount: "{count} elemento(s)",

        fieldName: "Nombre del campo",
        fieldNamePlaceholder: "ej.: Campo A",

        fieldDescription: "Descripción",
        fieldDescriptionPlaceholder: "ej.: Césped, luces, tamaño…",

        addAnotherField: "Agregar otro campo",

        cancel: "Cancelar",
        saving: "Guardando…",
        updateVenue: "Actualizar instalación",

        updateSuccess: "¡Instalación actualizada correctamente!",
        updateFailed: "No se pudo actualizar la instalación."
    },
    waiversPage: {
        pageTitle: "Exenciones",
        settings: "Configuración",

        upgradePlanLabel: "PREMIUM",
        upgradeTitle: "Gestión de exenciones no disponible",
        upgradeSubtitle: "Esta función está disponible en los planes Organization Pro/Elite/Empresarial.",
        upgradeCta: "Mejorar plan",
        upgradeTextPrefix: "Para crear y gestionar exenciones para tus organizaciones, por favor",
        upgradeTextLink: "mejora tu suscripción",

        tableTitle: "Exenciones",
        tableHeaders: {
            title: "Título",
            type: "Tipo",
            language: "Idioma",
            createdBy: "Creado por",
            actions: ""
        },

        noValue: "—",
        waiverTypeLabel: "Tipo de exención",
        document: "Documento",
        text: "Texto",
        view: "Ver",

        editWaiver: "Editar exención",
        deleteWaiver: "Eliminar exención",

        createBadge: "NUEVO",
        createTitle: "Crear exención",
        createSubtitle: "Agrega una exención (Texto o Documento) a tu organización.",

        deleteConfirmTitle: "Eliminar exención",
        deleteConfirmMessage: "La exención \"{title}\" se eliminará permanentemente. Los jugadores ya no podrán firmarla y cualquier solicitud de firma pendiente quedará inválida.\n\n¿Seguro que deseas continuar?",
        deleteConfirmButton: "Sí, eliminar",
        deleteCancelButton: "No",

        createSuccess: "¡Exención creada correctamente!",
        updateSuccess: "¡Exención actualizada correctamente!",
        deleteSuccess: "¡Exención eliminada correctamente!",
        updateFailed: "No se pudo actualizar la exención.",
        deleteFailed: "No se pudo eliminar la exención.",
        loadFailed: "No se pudieron cargar las exenciones."
    },

    createWaiverForm: {
        title: "Título",
        titlePlaceholder: "ej.: Exención de participación del torneo",

        language: "Idioma",
        waiverType: "Tipo de exención",
        text: "Texto",
        documentPdf: "Documento (PDF)",

        content: "Contenido",
        contentPlaceholder: "Escribe aquí el texto de la exención…",
        contentHelper: "Consejo: mantenlo claro y conciso; incluye reconocimiento de riesgos y consentimiento.",

        pdfDocument: "Documento PDF",
        noFileSelected: "No se ha seleccionado ningún archivo",
        pdfHelper: "Sube una exención en PDF para que los participantes puedan verla y firmarla.",
        choosePdf: "Elegir PDF",

        close: "Cerrar",
        uploading: "Subiendo…",
        createWaiver: "Crear exención"
    },

    textWaiverModal: {
        title: "Contenido de la exención",
        close: "Cerrar"
    },

    waiverEditModal: {
        badge: "EDITAR",
        title: "Editar exención",
        subtitle: "Actualiza el título, el tipo y el contenido.",

        close: "Cerrar",
        titleLabel: "Título",
        titlePlaceholder: "Título de la exención",
        titleHelper: "Este es el nombre que verán los administradores en las listas.",

        waiverType: "Tipo de exención",
        text: "Texto",
        document: "Documento",
        waiverTypeHelper: "Cambia entre texto y documento. Sube un PDF cuando uses el tipo Documento.",
        language: "Idioma",

        createdBy: "Creado por",
        readOnly: "Solo lectura.",

        content: "Contenido",
        contentPlaceholder: "Escribe el texto de tu exención...",
        contentHelper: "Mantenlo claro y legalmente consistente. Considera agregar una sección de reconocimiento de firma.",
        pdfDocument: "Documento PDF",
        noFileSelected: "No se ha seleccionado ningún archivo",
        pdfHelper: "Sube un nuevo PDF para reemplazar el documento actual (opcional).",
        viewCurrentDocument: "Ver documento actual",
        choosePdf: "Elegir PDF",

        cancel: "Cancelar",
        saving: "Guardando...",
        saveChanges: "Guardar cambios"
    },
    sanctionRulesPage: {
        pageTitle: "Gestión de sanciones",
        settings: "Configuración",
        rulesPageTitle: "Reglas de sanción",

        upgradePlanLabel: "PREMIUM",
        upgradeTitle: "Gestión de reglas de sanción no disponible",
        upgradeSubtitle: "Esta función está disponible en los planes Organization Pro/Elite/Empresarial.",
        upgradeCta: "Mejorar plan",
        upgradeTextPrefix: "Para crear y gestionar sanciones y reglas para tus organizaciones, por favor",
        upgradeTextLink: "mejora tu suscripción",

        tableTitle: "Reglas de sanción",
        tableSubtitle: "Crea y gestiona reglas disciplinarias para tu organización.",
        tableHeaders: {
            name: "Nombre",
            createdBy: "Creado por",
            actions: ""
        },

        noValue: "—",
        editRule: "Editar regla",
        deleteRule: "Eliminar regla",

        createBadge: "NUEVO",
        createTitle: "Crear regla de sanción",
        createSubtitle: "Define una regla disciplinaria para tu organización.",

        deleteConfirmTitle: "Eliminar regla de sanción",
        deleteConfirmMessage: "La regla \"{name}\" se eliminará permanentemente.\n\nLas futuras acciones disciplinarias ya no podrán hacer referencia a esta regla.\n\n¿Seguro que deseas continuar?",
        deleteConfirmButton: "Sí, eliminar",
        deleteCancelButton: "No",

        createSuccess: "¡Regla de sanción creada correctamente!",
        updateSuccess: "¡Regla de sanción actualizada correctamente!",
        deleteSuccess: "¡Regla de sanción eliminada correctamente!",
        updateFailed: "No se pudo actualizar la regla de sanción.",
        deleteFailed: "No se pudo eliminar la regla de sanción.",
        loadFailed: "No se pudieron cargar las reglas de sanción."
    },
    createSanctionRuleForm: {
        sections: {
            basics: {
                title: "Aspectos básicos",
                hint: "Identidad de la regla y límite de acumulación."
            },
            suspensions: {
                title: "Suspensiones",
                hint: "Partidos aplicados por cada escenario de tarjeta."
            },
            resets: {
                title: "Reinicios y excepciones",
                hint: "Controla cómo se reinicia la acumulación."
            },
            fines: {
                title: "Multas",
                hint: "Sanciones económicas opcionales (déjalo en blanco si no aplica)."
            }
        },

        fields: {
            ruleName: "Nombre de la regla",
            ruleNamePlaceholder: "ej.: Acumulación estándar de amarillas/rojas",

            maxAccumulatedYellowCards: "Máximo de tarjetas amarillas acumuladas",
            accumulatedYellowSuspensionGames: "Suspensión por acumulación de amarillas (partidos)",

            redCardSuspension: "Suspensión por tarjeta roja",
            doubleYellowSuspension: "Suspensión por doble amarilla",
            accumulatedYellowSuspension: "Suspensión por acumulación de amarillas",

            yellowCardFine: "Multa por tarjeta amarilla ($)",
            yellowCardFinePlaceholder: "ej.: 10.00",
            doubleYellowFine: "Multa por doble amarilla ($)",
            doubleYellowFinePlaceholder: "ej.: 25.00",
            redCardFine: "Multa por tarjeta roja ($)",
            redCardFinePlaceholder: "ej.: 50.00"
        },

        toggles: {
            resetOnRed: {
                title: "Reiniciar amarillas después de tarjeta roja",
                hint: "Útil cuando la roja se trata como un reinicio completo."
            },
            resetOnDoubleYellow: {
                title: "Reiniciar amarillas después de doble amarilla",
                hint: "Limpia la acumulación cuando un jugador es expulsado por 2 amarillas."
            },
            overrideAccumulation: {
                title: "La doble amarilla reemplaza la sanción por acumulación",
                hint: "Evita acumular doble amarilla + sanción por acumulación."
            },
            resetOnStageChange: {
                title: "Reiniciar amarillas al cambiar de fase",
                hint: "Ejemplo: fase de grupos → playoffs."
            },
            resetSanctionsOnStageChange: {
                title: "Reiniciar sanciones al cambiar de fase",
                hint: "Limpia el historial de suspensiones/multas al cambiar de fase."
            }
        },

        close: "Cerrar",
        creating: "Creando...",
        create: "Crear regla de sanción",

        success: "Regla de sanción creada.",
        error: "No se pudo crear la regla de sanción."
    },
    sanctionRuleEditModal: {
        badge: "EDIT",
        title: "Edit Sanction Rule",
        subtitle: "Update accumulation, suspensions, and optional fines.",

        close: "Close",
        saving: "Saving...",
        saveChanges: "Save Changes",

        sections: {
            core: {
                title: "Core fields",
                hint: "Main configuration for the rule."
            },
            toggles: {
                title: "Resets & Overrides",
                hint: "Control how accumulation resets."
            },
            fines: {
                title: "Fines",
                hint: "Optional monetary penalties (leave blank for none)."
            }
        },

        fields: {
            ruleName: "Rule Name",
            ruleNamePlaceholder: "e.g., Standard FIFA Discipline",
            maxAccumulatedYellowCards: "Max Accumulated Yellow Cards",
            maxAccumulatedYellowCardsHint: "Maximum yellows allowed before accumulation suspension applies.",

            redCardSuspensionGames: "Red Card Suspension (games)",
            accumulatedYellowSuspensionGames: "Accumulated Yellow Suspension (games)",
            doubleYellowSuspensionGames: "Double Yellow Suspension (games)",

            yellowCardFine: "Yellow Card Fine ($)",
            yellowCardFinePlaceholder: "e.g., 10.00",
            doubleYellowFine: "Double Yellow Fine ($)",
            doubleYellowFinePlaceholder: "e.g., 25.00",
            redCardFine: "Red Card Fine ($)",
            redCardFinePlaceholder: "e.g., 50.00"
        },

        toggles: {
            resetOnRed: {
                title: "Reset yellow cards after red card",
                description: "Clears accumulated yellows when a red card is issued."
            },
            resetOnDoubleYellow: {
                title: "Reset yellow cards after double yellow",
                description: "Clears accumulation when a player is sent off via 2 yellows."
            },
            overrideAccumulation: {
                title: "Double yellow overrides accumulation sanction",
                description: "Prevents stacking double-yellow + accumulation penalty."
            },
            resetOnStageChange: {
                title: "Reset yellow cards on stage change",
                description: "Example: group stage → playoffs."
            },
            resetSanctionsOnStageChange: {
                title: "Reset sanctions on stage change",
                description: "Clears suspensions/fines history on stage transition."
            }
        }
    },
    stripeAccountsPage: {
        pageTitle: "Cuentas",
        payments: "Pagos",
        stripeAccounts: "Cuentas de Stripe",

        infoBadge: "INFO",
        infoTitle: "Comisiones de Stripe Connect y comisión de plataforma",
        infoSubtitle: "Calcula el pago neto que recibiría la liga para un monto determinado.",
        infoText1: "Los pagos procesados a través de AngeonX Sports utilizan Stripe Connect. Stripe normalmente cobra",
        infoText2: "por transacción, y AngeonX Sports aplica una",
        infoText3: "comisión de plataforma. Estas se deducen antes del pago a la liga.",
        infoExample: "Ejemplo con un pago de {amount} → La liga recibiría aproximadamente {net}.",

        tableTitle: "Cuentas de pago",
        tableSubtitle: "Gestiona las cuentas de pago de Stripe Connect para tu organización.",
        tableHeaders: {
            name: "Nombre",
            email: "Correo electrónico",
            country: "País",
            details: "Detalles",
            last4: "Últimos 4",
            status: "Estado",
            actions: ""
        },

        noValue: "—",
        detailsSubmittedYes: "✅",
        detailsSubmittedNo: "❌",

        verified: "Verificada",
        needsVerification: "Requiere verificación",
        completeVerification: "Completar verificación",
        completeVerificationTitle: "Completa los requisitos de onboarding en Stripe",

        createTitle: "Crear cuenta de Stripe",
        close: "Cerrar",

        onboardingLinkFailed: "No se pudo obtener el enlace de onboarding.",
        onboardingLinkError: "Error al generar el enlace de onboarding de Stripe"
    },
    createStripeAccountModal: {
        accountNickname: "Nombre de la cuenta",
        accountNicknamePlaceholder: "Cuenta Stripe de la liga",
        accountNicknameHelper: "Una etiqueta amigable para identificar esta cuenta de pago dentro de AngeonX Sports.",

        country: "País",
        countryPlaceholder: "Elige un país...",
        countryHelper: "Esto determina el país de Stripe Connect para los requisitos de onboarding.",

        cancel: "Cancelar",
        creating: "Creando...",
        createAndOnboard: "Crear y continuar onboarding",

        redirecting: "Redirigiendo al onboarding de Stripe...",
        onboardingLinkFailed: "No se pudo generar el enlace de onboarding.",
        enterNameWarning: "Por favor, ingresa un nombre.",
        selectCountryWarning: "Por favor, selecciona un país.",
        somethingWentWrong: "Algo salió mal"
    },
    stripeOnboardRetryPage: {
        brandAlt: "kBola Sports",
        title: "Configuración de Stripe incompleta",
        message: "No completaste la configuración de la cuenta. Por favor, inténtalo de nuevo.",
        retry: "Intentar de nuevo"
    },
    stripeOnboardSuccessPage: {
        brandAlt: "kBola Sports",
        title: "¡Configuración de la cuenta de Stripe completada!",
        message: "Tu cuenta de pagos está lista para recibir fondos."
    },
    subscriptionPage: {
        title: "Planes de suscripción",
        subtitle: "Elige tu ciclo de facturación y tipo de suscripción. Los precios se muestran en la moneda de tu perfil ({currency}).",

        billing: {
            monthly: "Mensual",
            yearly: "Anual",
            yearlyOnly: "Solo anual",
            currency: "Moneda"
        },

        audience: {
            individual: "Individual",
            organization: "Organización"
        },

        sections: {
            individualTitle: "Suscripciones individuales (App móvil)",
            individualHint: "Para jugadores, entrenadores y padres que usan la app móvil de AngeonX Sports. Desbloquea estadísticas avanzadas, herramientas de alineación, seguimiento de juegos y experiencias premium dentro de la app.",
            organizationTitle: "Suscripciones para organizaciones (Gestión en plataforma web)",
            organizationHint: "Para ligas, clubes y academias. Gestiona temporadas, calendarios, sanciones, pagos y herramientas administrativas desde el panel web de AngeonX Sports."
        },

        orgSelector: {
            badge: "Organización",
            title: "Selecciona la organización que recibirá esta suscripción",
            hint: "Aquí solo se muestran las organizaciones que puedes administrar. La suscripción se aplicará a las herramientas de gestión web de la organización seleccionada.",
            placeholder: "-- Elige organización --"
        },

        plans: {
            current: "Actual",
            bestValue: "Mejor valor",
            savePercent: "Ahorra {percent}%",
            processing: "Procesando...",
            selectOrganization: "Selecciona organización",
            subscribe: "Suscribirse",
            cancelSubscription: "Cancelar suscripción",
            noPriceAvailable: "No hay precio disponible para tu moneda.",
            orgRequired: "Por favor, selecciona una organización para esta suscripción.",
            checkoutFailed: "No se pudo crear la sesión de pago.",
            cancelFailed: "Error al cancelar la suscripción"
        },

        options: {
            "plans": {
                "free": "Gratis",
                "pro": "Pro",
                "elite": "Élite",
                "trial": "Prueba",
                "test": "Test",
                "enterprise": "Empresarial"
            },
            "features": {
                "elite_confirm_attendance": {
                    "label": "Confirmar asistencia a eventos",
                    "description": "Acceso para confirmar asistencia a los eventos a los que te inviten."
                },
                "free_limited_events": {
                    "label": "Solo 2 eventos activos",
                    "description": "Puedes ver e interactuar con los eventos a los que te inviten.\nPuedes crear hasta 2 eventos activos.\nPuedes invitar a tus compañeros de equipo a tus eventos.\nNo puedes añadir participantes externos por correo."
                },
                "free_in_app_notifications": {
                    "label": "Notificaciones básicas en la app",
                    "description": "Solo notificaciones básicas dentro de la app cuando está activa.\nSin notificaciones push cuando la app está cerrada o en segundo plano."
                },
                "free_limited_chat": {
                    "label": "Chat limitado",
                    "description": "Chat limitado.\nSolo chats de equipo.\nAlmacenamiento de las últimas 50 conversaciones por sala.\nSin chats privados."
                },
                "free_basic_preferences": {
                    "label": "Preferencias básicas",
                    "description": "Preferencias básicas.\nSin preferencias deportivas ni posiciones preferidas en el campo.\nBaja visibilidad en Connect."
                },
                "free_single_profile": {
                    "label": "Un solo perfil",
                    "description": "Solo puedes crear y usar un perfil con este plan."
                },
                "free_single_team": {
                    "label": "Gestiona un solo equipo",
                    "description": "Crea y gestiona un equipo como mánager de equipo con este plan."
                },
                "free_marketplace_features": {
                    "label": "Connect básico",
                    "description": "Connect básico.\nSin filtros avanzados para encontrar jugadores, árbitros, equipos u organizaciones.\nSin MapView exclusivo para filtros de distancia o ubicación.\nSin filtros por preferencias deportivas.\nBaja visibilidad para tu perfil y equipo."
                },
                "free_push_notifications": {
                    "label": "Sin notificaciones push",
                    "description": "No recibirás notificaciones push por invitaciones de equipos u organizaciones.\nSolo están disponibles notificaciones básicas dentro de la app."
                },
                "free_no_referee_reviews": {
                    "label": "Sin reseñas de árbitros/umpires",
                    "description": "Sin acceso para calificar a árbitros/umpires ni ver sus reseñas."
                },
                "free_no_ai": {
                    "label": "Sin sugerencias con IA",
                    "description": "Sin funciones de IA.\nSin sugerencias de organizaciones/equipos/torneos basadas en estadísticas o preferencias.\nSin pronósticos de probabilidad de victoria con IA."
                },
                "free_no_performance_insights": {
                    "label": "Sin insights de rendimiento con IA",
                    "description": "Sin insights de rendimiento con IA.\nSin recomendaciones para mejorar o impulsar tu carrera."
                },
                "free_no_streams_highlights": {
                    "label": "Sin acceso a transmisiones y resúmenes",
                    "description": "No puedes ver partidos transmitidos en vivo ni resúmenes de eventos vinculados a ti, incluidos tus equipos, ligas y jugadores seguidos."
                },
                "free_no_custom_support": {
                    "label": "Sin soporte personalizado",
                    "description": "Este plan no incluye acceso a soporte personalizado."
                },
                "pro_manage_events": {
                    "label": "Gestionar tus propios eventos",
                    "description": "Gestiona por completo tus eventos.\nCrea eventos ilimitados.\nInvita participantes externos por correo."
                },
                "pro_receive_push_notifications": {
                    "label": "Recibir notificaciones push",
                    "description": "Recibe notificaciones push sobre actividades relacionadas con tus eventos, equipos, resultados e invitaciones."
                },
                "pro_full_chat": {
                    "label": "Chat completo",
                    "description": "Acceso completo al chat.\nChats de equipo.\nChats privados."
                },
                "pro_referee_reviews": {
                    "label": "Reseñas de árbitros/umpires",
                    "description": "Califica el desempeño de árbitros/umpires.\nConsulta sus reseñas."
                },
                "pro_advanced_preferences": {
                    "label": "Preferencias avanzadas",
                    "description": "Preferencias completas en tus perfiles.\nPermite que mánagers y scouts conozcan tus deportes y posiciones preferidas.\nAyúdales a encontrarte más fácilmente."
                },
                "pro_detailed_results": {
                    "label": "Resultados detallados y en vivo",
                    "description": "Resultados detallados y en vivo de los partidos.\nIngresa estadísticas individuales de jugadores.\nGestiona sanciones en tus organizaciones.\nActualizaciones del gamecast en tiempo real durante el partido."
                },
                "social_media_sharable": {
                    "label": "Compartir en redes sociales",
                    "description": "Comparte resultados, posiciones, calendarios y eventos en redes sociales."
                },
                "pro_multi_profiles_limited": {
                    "label": "Gestiona hasta 3 perfiles",
                    "description": "Crea y gestiona hasta 3 perfiles en tu cuenta."
                },
                "pro_team_management_limited": {
                    "label": "Gestiona hasta 3 equipos",
                    "description": "Crea y gestiona hasta 3 equipos en tu cuenta."
                },
                "pro_marketplace_features": {
                    "label": "Connect para Pro",
                    "description": "Filtros completos en Connect.\nFiltros por deporte.\nFiltros por ubicación.\nMapView para búsquedas más rápidas.\nVisibilidad media en Connect."
                },
                "pro_custom_support": {
                    "label": "Soporte Pro personalizado",
                    "description": "Acceso a soporte personalizado básico.\nReporta incidencias y soluciónalas.\nSolicita documentos y videos de tutoriales.\nSin soporte por chat en vivo."
                },
                "elite_marketplace_features": {
                    "label": "Connect para jugadores Elite",
                    "description": "Acceso completo a Connect.\nTodos los filtros.\nAlta visibilidad para tus perfiles y equipos.\nLos mánagers y scouts te encontrarán más rápido que nunca."
                },
                "elite_ai_win_forecast": {
                    "label": "Pronóstico con IA: probabilidad de victoria",
                    "description": "Predicciones de resultados.\nProbabilidad de victoria basada en estadísticas previas, récords de equipo y oponente."
                },
                "elite_profile_performance_insights": {
                    "label": "Rendimiento con insights de IA para jugadores",
                    "description": "Recibe recomendaciones e insights de rendimiento con análisis de IA."
                },
                "elite_streams_highlights": {
                    "label": "Acceso a transmisiones y resúmenes",
                    "description": "Accede a transmisiones y resúmenes de partidos.\nDisfruta de recaps o partidos completos en vivo."
                },
                "elite_chat_support": {
                    "label": "Soporte personalizado",
                    "description": "Soporte totalmente personalizado.\nReporta incidencias y soluciónalas cuanto antes.\nSolicita tutoriales y videos.\nSoporte por chat en vivo."
                },
                "elite_multi_profiles_unlimited": {
                    "label": "Perfiles ilimitados",
                    "description": "Crea todos los perfiles que quieras.\nSin límites de perfiles."
                },
                "elite_team_management_unlimited": {
                    "label": "Gestión ilimitada de equipos",
                    "description": "Crea todos los equipos que quieras.\nSin límites de equipos."
                },
                "free_single_organization": {
                    "label": "Una sola organización",
                    "description": "Gestiona una sola organización con este plan."
                },
                "free_limited_divisions": {
                    "label": "Hasta 3 divisiones/categorías",
                    "description": "Crea y gestiona hasta 3 divisiones o categorías."
                },
                "free_limited_seasons": {
                    "label": "Una temporada por división/categoría",
                    "description": "Crea y gestiona hasta 1 temporada por división o categoría."
                },
                "free_ai_scheduling": {
                    "label": "Programación con IA",
                    "description": "Genera calendarios optimizados en segundos con IA. Resuelve conflictos automáticamente, asigna árbitros y equilibra campos y horarios según disponibilidad, ubicaciones y reglas de la liga."
                },
                "free_global_results": {
                    "label": "Resultados globales de partidos",
                    "description": "Ingresa resultados globales de partidos.\nLos resultados se cargan después del partido.\nSin estadísticas individuales.\nSin resultados detallados por partido."
                },
                "free_no_print_results": {
                    "label": "Calendario básico compartible e imprimible",
                    "description": "Gestiona calendarios en la plataforma.\nImprime y comparte un calendario y planilla de partido genéricos."
                },
                "free_no_import_export_schedule": {
                    "label": "Sin importar ni exportar calendarios",
                    "description": "Sin acceso para importar o exportar calendarios."
                },
                "free_basic_notifications": {
                    "label": "Notificaciones básicas",
                    "description": "Notificaciones automáticas básicas para mánagers y árbitros/umpires.\nCalendario creado.\nCambios de partido."
                },
                "pro_limited_management": {
                    "label": "Gestiona 5 divisiones y temporadas ilimitadas",
                    "description": "Crea y gestiona hasta 5 divisiones y temporadas ilimitadas."
                },
                "pro_print_schedule": {
                    "label": "Calendario personalizado imprimible y compartible",
                    "description": "Calendarios profesionales imprimibles y compartibles por deporte usando formatos de AngeonX Sports."
                },
                "pro_automatic_notifications": {
                    "label": "Notificar a todos",
                    "description": "Envía notificaciones a todos los participantes involucrados cuando se crea o actualiza un calendario."
                },
                "pro_push_notifications": {
                    "label": "Módulo de notificaciones",
                    "description": "Accede al módulo de notificaciones.\nEnvía notificaciones personalizadas a mánagers y árbitros/umpires de tus organizaciones."
                },
                "elite_full_notifications": {
                    "label": "Módulo completo de notificaciones",
                    "description": "Accede al módulo de notificaciones.\nEnvía notificaciones personalizadas a tus organizaciones.\nIncluye filtros y segmentación."
                },
                "elite_ai_result_forecast": {
                    "label": "Pronóstico con IA: probabilidad de victoria para organizaciones",
                    "description": "Usa IA para pronosticar probabilidades de victoria en próximos partidos de organizaciones según rendimiento previo, estadísticas del rival e historial."
                },
                "elite_stream_games": {
                    "label": "Transmitir partidos y resúmenes",
                    "description": "Transmite partidos en vivo y sube resúmenes desde el campo. Permite que familias, fans y scouts vean partidos en tiempo real o repasen momentos clave en la app."
                },
                "elite_download_game_stats": {
                    "label": "Descargar estadísticas de partidos",
                    "description": "Exporta estadísticas detalladas y resúmenes de partidos a PDF o Excel para revisión o uso compartido."
                },
                "elite_custom_branding": {
                    "label": "Marca personalizada",
                    "description": "Agrega el logo, colores y marca de tu organización a calendarios, resultados y perfiles.\nIncluye una landing page dedicada para tu organización."
                },
                "elite_referee_management_dashboard": {
                    "label": "Herramientas de gestión arbitral",
                    "description": "Gestiona asignaciones, controla disponibilidad y recopila calificaciones de desempeño de árbitros y umpires."
                },
                "free_standing": {
                    "label": "Posiciones básicas",
                    "description": "Posiciones básicas para organizaciones.\nSin puntos por sanciones en la tabla.\nSin puntos bonus en la tabla."
                },
                "pro_standing": {
                    "label": "Funciones Pro de posiciones",
                    "description": "Posiciones Pro para organizaciones.\nIncluye puntos por sanciones y bonus."
                },
                "waiver_management": {
                    "label": "Gestión de exenciones",
                    "description": "Gestiona exenciones para organizaciones, divisiones, temporadas y equipos."
                },
                "sanction_management": {
                    "label": "Gestión de sanciones",
                    "description": "Gestiona reglas de sanciones para organizaciones, divisiones, temporadas y equipos."
                },
                "venues_management": {
                    "label": "Gestión de sedes e instalaciones",
                    "description": "Gestiona sedes e instalaciones para organizaciones, divisiones, temporadas y equipos."
                },
                "entity_picture": {
                    "label": "Imagen de entidad",
                    "description": "Sube una imagen para una organización, división, temporada o equipo."
                },
                "elite_live_results": {
                    "label": "Resultados en vivo de partidos",
                    "description": "Resultados detallados y en vivo de partidos.\nIngresa estadísticas individuales de jugadores.\nGestiona sanciones en tus organizaciones.\nTransmite resultados en vivo en tiempo real."
                },
                "elite_limited_organizations": {
                    "label": "Divisiones y temporadas ilimitadas",
                    "description": "Crea y gestiona divisiones y temporadas ilimitadas."
                },
                "enterprise_chat_support": {
                    "label": "Soporte completo y prioritario",
                    "description": "Accede a soporte completo, personalizado y prioritario.\nReporta incidencias y soluciónalas cuanto antes.\nSolicita documentos y videos tutoriales.\nSoporte por chat en vivo."
                },
                "chat_media_messages": {
                    "label": "Mensajes multimedia en chat",
                    "description": "Envía y visualiza archivos multimedia, incluidas imágenes, en mensajes de chat."
                },
                "enterprise_organizations_unlimited": {
                    "label": "Divisiones y temporadas ilimitadas",
                    "description": "Crea y gestiona divisiones y temporadas ilimitadas."
                },
                "manage_player_picture": {
                    "label": "Gestionar imágenes de jugadores",
                    "description": "Permite a los mánagers de organizaciones subir imágenes para sus jugadores."
                },
                "manage_team_players": {
                    "label": "Gestionar jugadores de equipos",
                    "description": "Permite a los mánagers de organizaciones gestionar jugadores de equipos."
                },
                "enterprise_user_management": {
                    "label": "Gestionar usuarios",
                    "description": "Crea usuarios, asigna jugadores, entrenadores y coordinadores, envía emails de activación e importa estructuras de organizaciones."
                },
                "import_schedule_from_file": {
                    "label": "Importar calendario desde archivo .xlsx",
                    "description": "Permite a los mánagers de organizaciones importar calendarios desde archivos .xlsx."
                },
                "in_app_advertising": {
                    "label": "Publicidad en la app",
                    "description": "Permite a las organizaciones usar publicidad dentro de la app para promocionar eventos, actividades y productos de patrocinadores."
                },
                "event_sync_calendar": {
                    "label": "Sincronizar eventos con el calendario",
                    "description": "Sincroniza tus eventos con el calendario de tu dispositivo."
                },
                "pro_event_photos": {
                    "label": "Fotos de eventos",
                    "description": "Permite a los usuarios agregar hasta 3 fotos por evento."
                },
                "elite_event_photos": {
                    "label": "Fotos de eventos",
                    "description": "Permite a los usuarios agregar hasta 5 fotos por evento."
                },
                "enterprise_event_photos": {
                    "label": "Fotos de eventos",
                    "description": "Permite a los usuarios agregar hasta 10 fotos por evento."
                },
                "marketplace_manage_listing_free": {"label": "Gestiona hasta 3 publicaciones del marketplace", "description": "Crea y gestiona hasta 3 publicaciones activas de deportes."},
                "marketplace_manage_listing_pro": {"label": "Gestiona hasta 10 publicaciones del marketplace", "description": "Crea y gestiona hasta 10 publicaciones activas de deportes."},
                "marketplace_manage_listing_elite": {"label": "Publicaciones ilimitadas del marketplace", "description": "Crea y gestiona publicaciones activas ilimitadas de deportes."},
                "enterprise_marketplace_buy_sell_listings": {"label": "Publicaciones ilimitadas del marketplace", "description": "Crea y gestiona publicaciones activas ilimitadas para tu organización."},
                "marketplace_manage_listing_trial": {"label": "Gestiona hasta 3 publicaciones del marketplace", "description": "Crea y gestiona hasta 3 publicaciones activas durante tu prueba."}
            }
        },

        billingSuffix: {
            month: "/ mes",
            year: "/ año"
        },

        confirmCancel: {
            title: "Confirmar cancelación",
            message: "Estás a punto de cancelar tu suscripción actual. ¿Estás seguro de que deseas hacerlo?",
            yes: "Sí",
            no: "No"
        },

        customPlan: {
            title: "¿Necesitas una suscripción personalizada?",
            body1: "Ya sea que gestiones una pequeña academia local o una organización con múltiples ligas, sabemos que cada estructura y presupuesto es diferente.",
            body2: "Si nuestros planes estándar te parecen demasiado grandes, demasiado pequeños o demasiado costosos para tu realidad, contáctanos y trabajaremos contigo en una solución ajustada a tus necesidades.",
            body3: "Contáctanos en",
            body4: "y te ayudaremos a encontrar la configuración adecuada. También puedes solicitar una",
            freeTrial: "cuenta de prueba GRATIS"
        },

        accessibility: {
            featureLevel: "Nivel de función {level} de {total}"
        }
    },
    invoicesPage: {
        title: "Facturas de suscripción",
        subtitle: "Facturas de tu plan móvil. Las fechas se muestran en tu zona horaria local ({timezone}).",

        actions: {
            refresh: "Actualizar"
        },

        table: {
            title: "Facturas",
            headers: {
                subscription: "Suscripción",
                type: "Tipo",
                status: "Estado",
                amountPaid: "Monto pagado",
                amountDue: "Monto pendiente",
                period: "Periodo",
                view: "Ver"
            }
        },

        status: {
            paid: "PAGADA",
            open: "PENDIENTE"
        }
    },
    organizations: {
        "pageTitle": "Organizaciones",

        "removeSuccess": "La organización fue eliminada correctamente",
        "removeFailed": "No se pudo eliminar la organización",
        "removeError": "Error al eliminar la organización",

        "confirmArchiveTitle": "¿Archivar organización?",
        "confirmArchiveMessage": "Esto archivará la organización y los datos relacionados: divisiones, temporadas, equipos, jugadores, estadísticas, etc. ¿Estás seguro?",
        "confirmArchive": "Archivar",
        "cancel": "Cancelar",

        "locationFallback": "Administra divisiones, temporadas, equipos y estadísticas en un solo lugar.",

        "divisions": "Divisiones",
        "seasons": "Temporadas",
        "teams": "Equipos",

        "openDivisions": "Abrir divisiones",
        "downloadImportTemplate": "Descargar plantilla de importación",
        "downloadingImportTemplate": "Preparando plantilla...",
        "importTemplateDownloaded": "Plantilla de importación descargada",
        "importTemplateDownloadError": "No se pudo descargar la plantilla de importación.",
        "importExistingData": "Importar datos existentes",
        "importDataBadge": "DATOS",
        "closeImport": "Cerrar",
        "importMappingHint": "Sube un archivo Excel o CSV. Leeremos cada hoja y sugeriremos las asignaciones antes de importar datos.",
        "sourceColumn": "Columna de origen",
        "kbolaField": "Campo de AngeonX Sports",
        "sampleValue": "Valor de ejemplo",
        "ignoreColumn": "Ignorar columna",
        "missingRequiredFields": "Faltan campos obligatorios",
        "requiredFieldsMapped": "Todos los campos obligatorios están asignados para esta hoja.",
        "validateMapping": "Validar asignación",
        "importUnsupportedFile": "Selecciona un archivo Excel o CSV.",
        "importNoSheets": "No se encontraron hojas importables.",
        "importFileParsed": "Archivo leído. Revisa las asignaciones de columnas.",
        "importParseError": "No se pudo leer el archivo de importación.",
        "importMissingRequiredFields": "Asigna todos los campos obligatorios antes de continuar.",
        "importMappingReady": "La asignación está lista para el paso de importación.",
        "validatingMapping": "Validando...",
        "importValidationError": "No se pudo validar la asignación de importación.",
        "importRowValidationError": "Revisa las filas señaladas antes de continuar.",
        "importRowErrors": "Filas que requieren atención",
        "importRowErrorsShort": "errores",
        "importRowLabel": "Fila {{row}}:",
        "importStructure": "Importar estructura",
        "importingStructure": "Importando estructura...",
        "importStructureSuccess": "Se importaron todos los datos revisados de la organización.",
        "importStructureError": "No se pudo importar la estructura de la organización.",
        "sendActivationEmails": "Enviar correos de activación",
        "sendingActivationEmails": "Enviando correos de activación...",
        "activationEmailsSent": "Correos de activación enviados.",
        "activationEmailsError": "No se pudieron enviar los correos de activación.",
        "manageActivations": "Gestionar activaciones",
        "activationPanelTitle": "Activación de usuarios importados",
        "activationPanelHint": "Enviaremos un correo de activación para que cada usuario pueda establecer una contraseña y acceder a la plataforma.",
        "pendingActivations": "activaciones pendientes",
        "sendAllActivations": "Enviar email de activación",
        "loadingActivations": "Cargando estado de activación...",
        "noPendingActivations": "Todas las cuentas importadas están activadas.",
        "activationAccount": "Cuenta", "activationType": "Rol", "activationStatusLabel": "Estado", "activationAction": "Acción", "activationAccountType": "Tipo de cuenta",
        "resendActivation": "Reenviar", "sendActivationEmail": "Enviar email de activación", "activationSent": "Correo de activación enviado.", "activationPartial": "Se enviaron {{count}} email(s) de activación; no se pudo contactar a algunas cuentas.", "activationSendError": "No se pudo enviar este correo de activación.", "activationLoadError": "No se pudo cargar el estado de activación.", "searchActivations": "Buscar por nombre o email", "clearSearch": "Borrar búsqueda", "activationLastSent": "Último email", "confirmSendActivations": "¿Enviar emails de activación a todos los usuarios pendientes?", "confirmResendActivation": "¿Enviar un email de activación a este usuario?", "refreshActivations": "Actualizar estado de activación", "createUserTitle": "Crear usuario y enviar activación", "createUserSubtitle": "El usuario recibirá un email para establecer una contraseña y acceder a la plataforma.", "createUserOrganization": "Organización", "createUserChooseOrganization": "Selecciona una organización", "createUserRole": "Rol", "createUserRoles": {"player": "Jugador", "coach": "Entrenador", "coordinator": "Coordinador", "referee": "Árbitro / Umpire"}, "createUserFirstName": "Nombre", "createUserLastName": "Apellidos", "createUserEmail": "Email", "createUserMobile": "Móvil", "createUserDob": "Fecha de nacimiento", "createUserSaving": "Creando usuario...", "createUserSubmit": "Crear y enviar activación", "createUserActivationSent": "Usuario creado y email de activación enviado.", "createUserExistingAccount": "Usuario existente añadido correctamente.", "createUserError": "No se pudo crear el usuario.",
        "createUserOptional": "opcional",
        "activationFilters": {"all": "Todos", "player": "Jugadores", "coach": "Entrenadores", "referee": "Árbitros"},
        "activationStatus": {"pending": "Pendiente", "sent": "Enviado", "activated": "Activada"},
        "chooseImportFile": "Elige un archivo para importar",
        "importSupportedFiles": "Los libros de Excel pueden contener varias hojas; los archivos CSV contienen una hoja.",
        "parsingImportFile": "Leyendo archivo...",
        "chooseFile": "Elegir archivo",
        "noImportFile": "No se seleccionó ningún archivo",
        "importFileHint": "Formatos compatibles: .xlsx, .xls, .csv",
        "clearImport": "Limpiar archivo seleccionado",
        "importSheets": "Hojas de importación",
        "importPreview": "Vista previa de datos",
        "importPreviewLimit": "Mostrando las primeras 10 filas",
        "importReviewSummary": "Resumen de revisión de importación",
        "importSummarySheets": "hojas",
        "importSummaryRows": "filas",
        "importSummaryErrors": "errores",
        "importFields": {
            "externalId": "ID externo", "divisionExternalId": "ID externo de división", "division": "División", "name": "Nombre", "description": "Descripción", "sport": "Deporte", "mountDistance": "Distancia del montículo", "pitchLimit": "Límite de lanzamientos", "restingGames": "Partidos de descanso", "gameDuration": "Duración del partido", "registrationStartDate": "Inicio de registro", "registrationEndDate": "Fin de registro", "startDate": "Fecha de inicio", "endDate": "Fecha de finalización", "lateRegistrationUntil": "Registro tardío hasta", "state": "Estado", "registrationFeeType": "Tipo de cuota", "lateRegistrationFee": "Cuota de registro tardío", "seasonExternalId": "ID externo de temporada", "season": "Temporada", "scheduleType": "Tipo de calendario", "minGamesRequired": "Mínimo de partidos", "gamesMode": "Formato de partidos", "qtyTeamsQualified": "Equipos clasificados", "qtyTeamsAdditional": "Equipos adicionales", "stageExternalId": "ID externo de etapa", "stage": "Etapa", "teamExternalId": "ID externo de equipo", "team": "Equipo", "teamAliasName": "Alias del equipo", "email": "Correo electrónico", "mobile": "Móvil", "firstName": "Nombre", "lastName": "Apellido", "dob": "Fecha de nacimiento", "gender": "Género", "shirtNumber": "Número", "position": "Posición", "note": "Nota", "isActive": "Activo", "status": "Estado", "contact": "Correo o móvil"
        },
        "upgrade": "Actualizar",
        "coordinators": "Coordinadores",

        "brandingTheme": "Marca y Tema",
        "editOrganization": "Editar organización",
        "archiveOrganization": "Archivar organización",

        "planFree": "Gratis",
        "planTrial": "Prueba",
        "planPaid": "Pagado"
    },
    addOrganization: {
        "title": "Nueva organización",
        "newBadge": "NUEVA",
        "close": "Cerrar",
        "save": "Guardar",

        "basics": "Datos básicos",
        "logoLabel": "Logo de la organización (opcional)",
        "logoHint": "Recomendado: proporción 1:1, PNG o JPG",
        "name": "Nombre",
        "namePlaceholder": "Nombre de la organización",
        "organizationType": "Tipo de organización",
        "typeLeague": "Liga / Torneo",
        "typeAcademy": "Academia / Escuela",
        "organizationTypeHint": "Esto ayuda a AngeonX Sports a configurar valores por defecto (divisiones, temporadas, reglas) para la organización.",

        "location": "Ubicación",
        "address": "Dirección",
        "addressPlaceholder": "Buscar una ubicación",
        "addressHint": "Se usa para mapas, distancia de viaje y descubrimiento local. Puedes cambiarlo más adelante.",

        "venues": "Sedes",
        "availableFields": "Campos disponibles",
        "selectedFields": "Campos seleccionados",

        "billing": "Facturación",
        "currency": "Moneda",
        "selectCurrency": "— Selecciona una moneda —",
        "currencyHint": "La moneda se aplicará a tarifas, facturas y pagos de esta organización.",
        "stripeAccount": "Cuenta de pagos de Stripe (opcional, solo para pagos en línea)",
        "noAccount": "— Sin cuenta —",
        "stripeAccountHint": "Si planeas aceptar pagos en línea, conecta una cuenta de Stripe más adelante o selecciona una ahora.",

        "pleaseEnterText": "Por favor ingresa un texto",
        "noActiveProfile": "No hay un perfil activo seleccionado.",
        "createError": "Error al crear la organización.",
        "createdSuccess": "Organización creada correctamente",
        "logoUploadFailedWithErrors": "La organización fue creada, pero falló la subida del logo: {{errors}}",
        "logoUploadFailedWithMessage": "La organización fue creada, pero falló la subida del logo: {{message}}",
        "selectActiveProfileFirst": "Selecciona primero un perfil activo",
        "createOrganization": "Crear organización"
    },
    editOrganization: {
        "title": "Editar organización",
        "editBadge": "EDITAR",
        "close": "Cerrar",
        "save": "Guardar",
        "saving": "Guardando...",
        "saveChanges": "Guardar cambios",

        "basics": "Datos básicos",
        "logoLabel": "Logo de la organización (opcional)",
        "logoHint": "Recomendado: proporción 1:1, PNG o JPG",
        "name": "Nombre",
        "namePlaceholder": "Nombre de la organización",
        "organizationType": "Tipo de organización",
        "typeLeague": "Liga / Torneo",
        "typeAcademy": "Academia / Escuela",
        "organizationTypeHint": "Esto ayuda a AngeonX Sports a configurar valores por defecto (divisiones, temporadas, reglas) para la organización.",

        "location": "Ubicación",
        "address": "Dirección",
        "addressPlaceholder": "Buscar una ubicación",
        "addressHint": "Se usa para mapas, distancia de viaje y descubrimiento local.",

        "venues": "Sedes",
        "availableFields": "Campos disponibles",
        "selectedFields": "Campos seleccionados",

        "policiesAndRules": "Políticas y reglas",
        "waiverOptional": "Exención de responsabilidad (opcional)",
        "noWaiver": "— Sin exención —",
        "sanctionRuleOptional": "Regla de sanción (opcional para fútbol)",
        "noRule": "— Sin regla —",

        "billing": "Facturación",
        "currency": "Moneda",
        "selectCurrency": "— Selecciona una moneda —",
        "currencyHint": "La moneda se aplica a tarifas, facturas y pagos de esta organización.",
        "stripeAccount": "Cuenta de pagos de Stripe (opcional, solo para pagos en línea)",
        "noAccount": "— Sin cuenta —",
        "stripeAccountHint": "Si planeas aceptar pagos en línea, conecta una cuenta de Stripe más adelante o selecciona una ahora.",

        "updatedSuccess": "Organización actualizada correctamente",
        "logoUploadFailedWithErrors": "La organización fue actualizada, pero falló la subida del logo: {{errors}}",
        "logoUploadFailedWithMessage": "La organización fue actualizada, pero falló la subida del logo: {{message}}",
        "noDetailsForInput": "No hay detalles disponibles para la entrada: '{{name}}'"
    },
    filePicker: {
        "ariaLabel": "Selector de archivos",
        "chooseFile": "Elegir archivo",
        "existingImage": "Imagen existente",
        "noFileSelected": "Ningún archivo seleccionado",
        "dragDropHint": "Arrastra y suelta aquí un logo cuadrado (PNG/JPG). Recomendado 1:1.",
        "remove": "Eliminar",
        "logoPreview": "Vista previa del logo",
        "preview": "Vista previa"
    },
    editOrganizationBranding: {
        "badge": "MARCA",
        "title": "Marca y tema – {{name}}",
        "close": "Cerrar",
        "save": "Guardar",
        "saving": "Guardando...",
        "saveBranding": "Guardar marca",
        "updateFailed": "No se pudo actualizar la marca",
        "updatedSuccess": "La marca se actualizó correctamente",

        "identity": "Identidad",
        "logoLabel": "Logo de marca (opcional)",
        "logoHint": "Este logo se usa en el encabezado y hero del portal personalizado. Recomendado: PNG con fondo transparente.",
        "subdomain": "Subdominio",
        "subdomainPlaceholder": "mi-liga",
        "subdomainHint": "Esto será la URL personalizada, por ejemplo: {{subdomain}}.kbolasport.com",
        "enablePortal": "Habilitar portal personalizado para esta organización",

        "brandColors": "Colores de marca",
        "primary": "Primario",
        "secondary": "Secundario",
        "accent": "Acento",
        "resetDefaults": "Restablecer a los valores de AngeonX Sports",
        "brandColorsHint": "Estos colores controlan botones, destacados y acentos clave en el portal personalizado.",

        "backgroundSurface": "Fondo y superficie",
        "background": "Fondo",
        "surface": "Superficie",
        "border": "Borde",
        "backgroundSurfaceHint": "El fondo es el color principal de la página; la superficie se usa para tarjetas y paneles.",

        "textColors": "Colores de texto",
        "textOnBackground": "Texto sobre fondo",
        "textOnSurface": "Texto sobre superficie",
        "textOnPrimary": "Texto sobre primario",
        "textOnSecondary": "Texto sobre secundario",

        "backgroundPreview": "Vista previa del fondo",
        "backgroundPreviewTitle": "AngeonX Sports – Fondo",
        "backgroundPreviewText": "Así se verá el texto estándar sobre el color principal de tu página.",

        "primaryPreview": "Vista previa del botón primario",
        "primaryPreviewTitle": "Llamado a la acción / Primario",
        "primaryPreviewText": "Asegúrate de que siga siendo legible para botones y destacados."
    },
    divisions: {
        "pageTitle": "Divisiones",
        "organizationFallback": "Organización",

        "archiveSuccess": "La división fue archivada correctamente",
        "archiveFailed": "No se pudo archivar la división",
        "archiveError": "Error al archivar la división",
        "loadError": "No se pudieron cargar las divisiones",

        "confirmArchiveTitle": "¿Archivar esta división?",
        "confirmArchiveMessage": "Esto archivará la división y TODOS los datos relacionados: temporadas, equipos, jugadores, estadísticas, etc. ¿Estás seguro?",
        "archive": "Archivar",
        "cancel": "Cancelar",

        "sport": "Deporte",
        "sportFallback": "Deporte",
        "open": "Abierta",
        "closed": "Cerrada",
        "allStatuses": "Todas",
        "filterByStatus": "Filtrar divisiones por estado",

        "organizationLabel": "Organización",
        "seasonStart": "Inicio de temporada",
        "seasonEnd": "Fin de temporada",
        "season": "Temporada",
        "noneActive": "Ninguna activa",
        "noActiveSeasonConfigured": "No hay una temporada activa configurada",

        "openDetails": "Abrir detalles de la división",
        "details": "Detalles",
        "editDivision": "Editar división",
        "archiveDivision": "Archivar división"
    },
    addDivision: {
        "newBadge": "NUEVA",
        "title": "Nueva división",
        "close": "Cerrar",
        "save": "Guardar",

        "basics": "Datos básicos",
        "name": "Nombre",
        "namePlaceholder": "Nombre de la división",
        "competitionLevel": "Nivel de competencia",
        "competitionLevelPlaceholder": "ej. recreativo, competitivo",
        "optionalSelection": "— Opcional —",
        "competitionOptions": {"recreational": "Recreativo", "competitive": "Competitivo", "select": "Select", "elite": "Élite"},
        "ageGroup": "Grupo de edad",
        "ageGroupPlaceholder": "ej. U12, U14",
        "ageOptions": {"u8": "U8", "u10": "U10", "u12": "U12", "u14": "U14", "u16": "U16", "u18": "U18", "adult": "Adulto", "senior": "Senior"},
        "sport": "Deporte",
        "chooseSport": "— Elige un deporte —",
        "sportHint": "El deporte afecta los valores por defecto y las reglas disponibles para esta división.",

        "rules": "Reglas",
        "mountDistance": "Distancia del montículo (ft)",
        "mountDistancePlaceholder": "ej. 60.5",
        "mountDistanceHint": "Se usa para el seguimiento de lanzamientos y la configuración del juego.",
        "pitchLimit": "Límite de lanzamientos",
        "pitchLimitPlaceholder": "ej. 75",
        "restingGames": "Juegos de descanso",
        "restingGamesPlaceholder": "ej. 1",
        "restingGamesHint": "Cuántos juegos debe descansar un lanzador después de alcanzar el límite de lanzamientos.",
        "gameDuration": "Duración del juego (minutos)",
        "gameDurationPlaceholder": "ej. 90",

        "policy": "Política",
        "waiverOptional": "Exención de responsabilidad (opcional)",
        "noWaiver": "— Sin exención —",
        "waiverHint": "Adjunta una exención para los participantes de esta división (puede cambiarse más adelante).",

        "createdSuccess": "División creada correctamente",
        "error": "Error al crear la división"
    },
    editDivision: {
        "editBadge": "EDITAR",
        "title": "Editar división",
        "close": "Cerrar",
        "save": "Guardar",
        "saving": "Guardando...",

        "basics": "Datos básicos",
        "name": "Nombre",
        "competitionLevel": "Nivel de competencia",
        "competitionLevelPlaceholder": "ej. recreativo, competitivo",
        "optionalSelection": "— Opcional —",
        "competitionOptions": {"recreational": "Recreativo", "competitive": "Competitivo", "select": "Select", "elite": "Élite"},
        "ageGroup": "Grupo de edad",
        "ageGroupPlaceholder": "ej. U12, U14",
        "ageOptions": {"u8": "U8", "u10": "U10", "u12": "U12", "u14": "U14", "u16": "U16", "u18": "U18", "adult": "Adulto", "senior": "Senior"},
        "sport": "Deporte",
        "chooseSport": "— Elige un deporte —",
        "sportHint": "Cambiar el deporte puede afectar las reglas y los valores por defecto.",

        "rules": "Reglas",
        "mountDistance": "Distancia del montículo (ft)",
        "mountDistancePlaceholder": "ej. 60.5",
        "pitchLimit": "Límite de lanzamientos",
        "pitchLimitPlaceholder": "ej. 75",
        "restingGames": "Juegos de descanso",
        "restingGamesPlaceholder": "ej. 1",
        "gameDuration": "Duración del juego (minutos)",
        "gameDurationPlaceholder": "ej. 90",

        "policy": "Política",
        "waiverOptional": "Exención de responsabilidad (opcional)",
        "noWaiver": "— Sin exención —",
        "waiverHint": "Se utiliza para el acuerdo de participación dentro de esta división.",

        "editedSuccess": "División editada correctamente",
        "error": "Error al editar la división"
    },
    divisionDetailPage: {
        "pageTitle": "Detalles de la división",
        "breadcrumbOrganizations": "Organizaciones",
        "breadcrumbDivisions": "Divisiones"
    },
    "divisionHeader": {
        "badge": "División",
        "subtitle": "Resumen rápido del deporte y la temporada activa.",
        "open": "Abierta",
        "closed": "Cerrada",
        "sport": "Deporte",
        "season": "Temporada",
        "divisionStatus": "Estado de la división",
        "active": "Activa",
        "archived": "Archivada",
        "empty": "—"
    },
    "activeSeason": {
        "badge": "Temporadas",
        "title": "Gestión de temporadas",
        "subtitle": "Selecciona la temporada activa para esta división.",
        "newSeason": "Nueva temporada",
        "newSeasonTitle": "Crear una nueva temporada",
        "lockedTitle": "Bloqueado mientras se revisa una temporada anterior",
        "activeSeasonLabel": "Temporada activa",
        "selectSeasonPlaceholder": "— Selecciona una temporada —",
        "hint": "Cambiar la temporada activa actualiza las fases y los equipos para la programación y las estadísticas.",
        "itemLabel": "temporadas"
    },
    "divisionSummary": {
        "stages": "Fases",
        "teams": "Equipos",
        "events": "Eventos",
        "players": "Jugadores",
        "competitionPhases": "Fases de la competición",
        "registeredTeams": "Equipos registrados",
        "scheduledGames": "Partidos programados",
        "activeRosterSize": "Tamaño del roster activo"
    },
    "divisionTags": {
        "title": "Espacio de trabajo de la división",
        "premiumNotice": "Las pestañas de estadísticas y ajustes solo están disponibles para planes premium.",
        "pro": "PRO",
        "basic": "BÁSICO",
        "teams": "Equipos",
        "stages": "Fases",
        "seasons": "Temporadas",
        "schedule": "Calendario",
        "standings": "Clasificación",
        "sanctions": "Sanciones",
        "stats": "Estadísticas",
        "pointAdjustments": "Ajustes de puntos",
        "divisionTabsAriaLabel": "Pestañas de división",
        "loading": "Cargando…",
        "comingSoon": "Próximamente"
    },
    "teamList": {
        "removeSuccess": "Equipo eliminado correctamente",
        "removeFailed": "No se pudo eliminar el equipo",
        "removeTitle": "¿Eliminar este equipo de la temporada?",
        "removeMessageLine1": "Esto desvinculará \"{{teamName}}\" de esta temporada.",
        "removeMessageLine2": "Los jugadores, estadísticas y el calendario de ese equipo en esta temporada pueden verse afectados.",
        "removeMessageLine3": "¿Estás seguro?",
        "removeConfirm": "Eliminar equipo",
        "cancel": "Cancelar",
        "proOnlyFeature": "Esta función está disponible solo para suscriptores Pro/Elite.",
        "title": "Equipos de la temporada",
        "subtitleSeasonFallback": "esta temporada",
        "total": "Total",
        "createTeam": "Crear un equipo",
        "addExistingTeams": "Agregar equipos existentes",
        "headers": {
            "team": "Equipo",
            "players": "Jugadores",
            "actions": "Acciones"
        },
        "seasonTeam": "Equipo de temporada",
        "openTeamDetails": "Abrir detalles del equipo",
        "playersLinked": "Jugadores vinculados al equipo",
        "editTeamName": "Editar nombre del equipo",
        "removeTeamFromSeason": "Eliminar equipo de la temporada",
        "allSelectedAlreadyAdded": "Todos los equipos seleccionados ya están en esta temporada.",
        "addExistingFailed": "No se pudieron agregar los equipos existentes.",
        "teamsAndPlayersCopied": "Los equipos y jugadores se copiaron a esta temporada.",
        "teamsAdded": "Equipos agregados a esta temporada."
    },
    "addTeamModal": {
        "teamAddedSuccess": "Equipo agregado correctamente",
        "teamNameRequired": "Por favor ingresa un nombre de equipo.",
        "teamCreatedLogoFailed": "El equipo fue creado, pero la carga del logo falló: {{errors}}",
        "badge": "Nuevo",
        "title": "Agregar equipo",
        "closeAria": "Cerrar",
        "closeTitle": "Cerrar",
        "sectionTitle": "Detalles del equipo",
        "logoLabel": "Logo del equipo (opcional)",
        "logoHint": "Recomendado: proporción 1:1, PNG o JPG",
        "teamNameLabel": "Nombre del equipo",
        "teamNamePlaceholder": "Escribe el nombre del equipo...",
        "teamNameHint": "Esto creará un equipo y lo vinculará a la temporada actual.",
        "close": "Cerrar",
        "noActiveSeasonSelected": "No hay una temporada activa seleccionada",
        "addTeamTitle": "Agregar equipo",
        "saving": "Guardando...",
        "save": "Guardar"
    },
    "editTeamModal": {
        "missingTeamId": "Falta el id del equipo.",
        "teamUpdatedLogoFailed": "El equipo fue actualizado, pero la carga del logo falló: {{errors}}",
        "teamEditedSuccess": "Equipo editado correctamente",
        "badge": "Editar",
        "title": "Editar equipo",
        "closeAria": "Cerrar",
        "closeTitle": "Cerrar",
        "sectionTitle": "Detalles del equipo",
        "logoLabel": "Logo del equipo (opcional)",
        "logoHint": "Recomendado: proporción 1:1, PNG o JPG",
        "nameLabel": "Nombre",
        "namePlaceholder": "Nombre del equipo",
        "nameHint": "Esto actualiza el nombre del equipo en las vistas de administración web.",
        "close": "Cerrar",
        "save": "Guardar"
    },
    "addExistingSeasonTeamsModal": {
        "allSports": "Todos los deportes",
        "badge": "Copiar",
        "title": "Agregar equipos existentes",
        "closeAria": "Cerrar",
        "closeTitle": "Cerrar",
        "sectionTitle": "Temporada y equipos de origen",
        "includeArchivedDivisions": "Incluir divisiones archivadas",
        "includeArchivedDivisionsTitle": "Mostrar también divisiones archivadas / inactivas",
        "sport": "Deporte",
        "sourceDivision": "División de origen",
        "loadingDivisions": "Cargando divisiones...",
        "selectDivision": "Selecciona una división",
        "noDivisionsAvailable": "No hay divisiones disponibles",
        "couldNotLoadDivisions": "No se pudieron cargar las divisiones. Inténtalo de nuevo más tarde.",
        "sourceSeason": "Temporada de origen",
        "selectSeason": "Selecciona una temporada",
        "noSeasonsAvailable": "No hay temporadas disponibles",
        "sourceSeasonHint": "Elige la temporada desde la que quieres copiar equipos. Normalmente es la temporada del año pasado.",
        "keepPlayersTitle": "Agregar jugadores del equipo a la temporada",
        "keepPlayersHint": "Opcional. Si se activa, los jugadores también se copiarán a la temporada activa para los equipos seleccionados.",
        "keepPlayersWarning": "¡NO MARQUES ESTO SI QUIERES QUE LOS JUGADORES SE REGISTREN EN LA NUEVA TEMPORADA!",
        "keepPlayersRequiredForMove": "Requerido al quitar de la temporada de origen. Los jugadores y managers se copiarán a la temporada de destino.",
        "keepPlayersTitleAttr": "Copiar jugadores a la temporada activa",
        "transferOptionsTitle": "Opciones de transferencia",
        "targetStage": "Etapa de destino",
        "targetGroup": "Grupo de destino",
        "sourceStage": "Etapa de origen",
        "sourceGroup": "Grupo de origen",
        "selectStage": "Selecciona una etapa",
        "selectGroupOptional": "Sin grupo / elegir después",
        "noStagesAvailable": "No hay etapas disponibles",
        "noGroupsAvailable": "No hay grupos disponibles",
        "carryPointsTitle": "Transferir puntos de la tabla",
        "carryPointsHint": "Copia los puntos de la tabla de origen como un ajuste manual en la etapa/grupo de destino.",
        "deactivateSourceTitle": "Quitar de la temporada de origen después de transferir",
        "deactivateSourceHint": "Conserva los datos históricos, pero desactiva el equipo en la temporada de origen. El backend lo bloquea si hay juegos abiertos.",
        "pleaseWaitTitle": "Espera hasta que termine la operación",
        "table": {
            "team": "Equipo",
            "players": "Jugadores",
            "status": "Estado"
        },
        "noTeamsForSeason": "No se encontraron equipos para esta temporada.",
        "selectSeasonToSeeTeams": "Selecciona una temporada para ver sus equipos.",
        "seasonTeam": "Equipo de temporada",
        "alreadyInSeason": "Ya está en {{seasonName}}",
        "selected": "Seleccionado",
        "available": "Disponible",
        "teamsSelectedFooter": "{{count}} equipo(s) seleccionados para agregar.",
        "selectTeamsFooter": "Selecciona uno o más equipos para agregarlos a la temporada activa.",
        "close": "Cerrar",
        "adding": "Agregando...",
        "addSelectedTeams": "Agregar equipos seleccionados"
    },
    "inviteLinkBox": {
        "emailSubject": "Únete a nuestra liga en AngeonX Sports",
        "emailBody": "Hola, únete a nuestra liga en AngeonX Sports con este enlace de invitación:\n\n{{inviteURL}}\n\nSi necesitas crear una cuenta, usa primero este mismo enlace. Después de iniciar sesión, AngeonX Sports te llevará automáticamente de vuelta a la invitación.",
        "whatsAppMessage": "Únete a nuestra liga en AngeonX Sports. Abre este enlace para iniciar sesión o crear una cuenta; después de iniciar sesión, la app continuará automáticamente a la invitación: {{inviteURL}}",
        "title": "¡Enlace de invitación de la temporada!",
        "description": "Comparte este enlace con los managers de equipos para que puedan registrar sus equipos en tu liga. Si necesitan crear una cuenta, AngeonX Sports los llevará de vuelta a esta invitación después de iniciar sesión. Solo los <b>Managers/Capitanes</b> con un equipo activo, <b>Árbitros</b> o <b>Coordinadores de la liga</b> podrán unirse usando este enlace de invitación:",
        "copyLink": "📋 Copiar enlace",
        "sendEmail": "📧 Enviar email",
        "whatsApp": "💬 WhatsApp",
        "important": "Importante: Una vez que tengas todos los equipos registrados, puedes crear <b>Fases</b> y el <b>Calendario</b>."
    },
    "teamDetailPage": {
        "pageTitle": "Detalles del equipo",
        "breadcrumbOrganizations": "Organizaciones",
        "breadcrumbDivisions": "Divisiones"
    },
    "teamHeader": {
        "division": "División",
        "players": "Jugadores",
        "season": "Temporada"
    },
    "inviteTeamLink": {
        "emailSubject": "Únete a nuestro equipo en AngeonX Sports",
        "emailBody": "Hola, únete a nuestro equipo en AngeonX Sports con este enlace de invitación:\n\n{{inviteURL}}\n\nSi necesitas crear una cuenta, usa primero este mismo enlace. Después de iniciar sesión, AngeonX Sports te llevará automáticamente de vuelta a la invitación del equipo.",
        "whatsAppMessage": "Únete a nuestro equipo en AngeonX Sports. Abre este enlace para iniciar sesión o crear una cuenta; después de iniciar sesión, la app continuará automáticamente a la invitación del equipo: {{inviteURL}}",
        "title": "¡Enlace de invitación del manager!",
        "description": "Comparte este enlace con el manager del equipo para que se una al equipo. Si necesita crear una cuenta, AngeonX Sports lo llevará de vuelta a esta invitación después de iniciar sesión. Luego el manager invitará a los jugadores usando la app móvil.",
        "copyLink": "📋 Copiar enlace",
        "sendEmail": "📧 Enviar email",
        "whatsApp": "💬 WhatsApp"
    },
    "teamMemberPicker": {
        "title": "Agregar {{role}} al equipo",
        "addCoach": "Agregar coach",
        "addPlayer": "Agregar jugador",
        "roles": {
            "coach": "coach",
            "player": "jugador"
        },
        "profile": "Perfil de usuario",
        "searchPlaceholder": "Buscar perfiles de usuario...",
        "add": "Agregar",
        "alreadyAdded": "Agregado",
        "loadError": "No se pudieron cargar los perfiles de usuario.",
        "noProfiles": "No hay perfiles de usuario disponibles.",
        "noSearchResults": "No se encontraron perfiles para esta busqueda.",
        "pageInfo": "Pagina {{page}} de {{pages}}",
        "addSuccess": "{{role}} agregado correctamente.",
        "addError": "No se pudo agregar este miembro al equipo."
    },
    "coordinatorPicker": {
        "title": "Agregar coordinador a {{name}}",
        "profile": "Perfil de usuario",
        "searchPlaceholder": "Buscar perfiles de usuario...",
        "add": "Agregar",
        "alreadyAdded": "Agregado",
        "loadError": "No se pudieron cargar los perfiles de usuario.",
        "noProfiles": "No hay perfiles de usuario disponibles.",
        "noSearchResults": "No se encontraron perfiles para esta busqueda.",
        "addSuccess": "Coordinador invitado correctamente.",
        "addError": "No se pudo invitar este coordinador."
    },
    "playersList": {
        "player": "Jugador",
        "jerseyNumber": "Número",
        "position": "Posición",
        "actions": "Acciones",
        "choosePosition": "Selecciona posición",
        "missingProfile": "No hay un perfil activo seleccionado.",
        "invalidShirtNumber": "El número de camiseta debe ser un número entero de 0 o mayor.",
        "saveSuccess": "Jugador actualizado correctamente.",
        "saveError": "No se pudo actualizar el jugador.",
        "deleteTitle": "Eliminar jugador",
        "deleteMessage": "¿Seguro que quieres eliminar a {{name}} de este equipo?",
        "deleteConfirm": "Eliminar",
        "deleteSuccess": "Jugador eliminado correctamente.",
        "deleteError": "No se pudo eliminar el jugador."
    },
    "teamCoaches": {
        "deleteTitle": "Eliminar coach",
        "deleteMessage": "¿Seguro que quieres eliminar a {{name}} de este equipo?",
        "deleteConfirm": "Eliminar",
        "deleteSuccess": "Coach eliminado correctamente.",
        "deleteError": "No se pudo eliminar el coach."
    },
    "positions": {
        "soccer": {
            "goalkeeper": "Portero",
            "defender": "Defensa",
            "left-back": "Lateral izquierdo",
            "right-back": "Lateral derecho",
            "center-back": "Defensa central",
            "midfielder": "Centrocampista",
            "attacking-midfielder": "Mediapunta",
            "defensive-midfielder": "Mediocentro defensivo",
            "winger": "Extremo",
            "forward": "Delantero",
            "striker": "Delantero centro"
        },
        "baseball": {
            "spare": "Emergente",
            "pitcher": "Lanzador",
            "catcher": "Receptor",
            "first-base": "Primera base",
            "second-base": "Segunda base",
            "third-base": "Tercera base",
            "short-stop": "Campo corto",
            "left-fielder": "Jardinero izquierdo",
            "centre-fielder": "Jardinero central",
            "right-fielder": "Jardinero derecho"
        },
        "softball": {
            "spare": "Emergente",
            "pitcher": "Lanzador",
            "catcher": "Receptor",
            "first-base": "Primera base",
            "second-base": "Segunda base",
            "third-base": "Tercera base",
            "short-stop": "Campo corto",
            "left-fielder": "Jardinero izquierdo",
            "short-fielder": "Jardinero corto / Rover",
            "centre-fielder": "Jardinero central",
            "right-fielder": "Jardinero derecho"
        },
        "basketball": {
            "point-guard": "Base",
            "shooting-guard": "Escolta",
            "small-forward": "Alero",
            "power-forward": "Ala-pívot",
            "center": "Pívot"
        },
        "american-football": {
            "quarterback": "Mariscal de campo",
            "running-back": "Corredor",
            "fullback": "Corredor de poder",
            "wide-receiver": "Receptor abierto",
            "tight-end": "Ala cerrada",
            "offensive-lineman": "Línea ofensiva",
            "defensive-lineman": "Línea defensiva",
            "linebacker": "Apoyador",
            "cornerback": "Esquinero",
            "safety": "Profundo",
            "kicker": "Pateador",
            "punter": "Pateador de despeje"
        },
        "hockey": {
            "goalie": "Portero",
            "defenseman": "Defensa",
            "left-wing": "Extremo izquierdo",
            "right-wing": "Extremo derecho",
            "center": "Centro"
        },
        "rugby": {
            "loosehead-prop": "Pilar izquierdo",
            "hooker": "Talón",
            "tighthead-prop": "Pilar derecho",
            "lock": "Segunda línea",
            "flanker": "Ala",
            "number-eight": "Ocho",
            "scrum-half": "Medio melé",
            "fly-half": "Apertura",
            "inside-centre": "Centro interior",
            "outside-centre": "Centro exterior",
            "wing": "Ala",
            "fullback": "Zaguero"
        },
        "volleyball": {
            "outside-hitter": "Punta / Atacante exterior",
            "opposite-hitter": "Opuesto",
            "middle-blocker": "Central / Bloqueador central",
            "setter": "Colocador",
            "libero": "Líbero",
            "defensive-specialist": "Especialista defensivo",
            "serving-specialist": "Especialista en servicio"
        }
    },
    addStageModal: {
        badge: "Nuevo",
        title: "Nueva fase",
        createFor: "Crear una fase para",
        thisSeason: "esta temporada",
        close: "Cerrar",
        save: "Guardar",

        fields: {
            stageName: "Nombre de la fase",
            stageType: "Tipo de fase",
            minGamesRequired: "Juegos minimos requeridos",
            gameMode: "Modo de juego",
            qualifiedTeamsPerGroup: "Equipos clasificados por grupo a la siguiente fase",
            additionalTeams: "Equipos adicionales a la siguiente fase",
        },

        placeholders: {
            stageName: "Introduce un nombre para la fase...",
            minGamesRequired: "Ingresa el minimo de juegos requeridos",
            chooseStageType: "Selecciona el tipo de fase",
            chooseGameMode: "Selecciona el modo de juego",
        },

        helpers: {
            stageName: "Ejemplo: Temporada regular, Playoffs, Grupo A",
            minGamesRequired: "Los jugadores deben haber disputado al menos esta cantidad de juegos para participar en esta fase. Deja 0 por defecto si no se requieren juegos.",
            stageType: "Las fases de entrenamiento no requieren modo de juego ni reglas de clasificación.",
        },

        stageTypes: {
            league: "Liga",
            roundRobin: "Todos contra todos",
            brackets: "Playoffs (Llaves)",
            training: "Sesión de entrenamiento",
        },

        gameModes: {
            singleGame: "Juego único",
            doubleGame: "Doble juego (mismo día)",
            doubleHeader: "Doble cartelera (la 2da ronda empieza después de completar la 1ra ronda)",
            series3: "Serie de 3 (gana 2 de 3 juegos)",
            series5: "Serie de 5 (gana 3 de 5 juegos)",
            series7: "Serie de 7 (gana 4 de 7 juegos)",
        },

        toasts: {
            createdSuccess: "Fase creada correctamente",
            minGamesInvalid: "El minimo de juegos requeridos debe ser un numero entero de 0 o mayor",
        },
    },
    stageList: {
        title: "Fases de la temporada",
        subtitleManage: "Gestiona las fases de",
        thisSeason: "esta temporada",
        total: "Total",

        headers: {
            stage: "Fase",
            type: "Tipo",
            actions: "Acciones",
        },

        status: {
            completed: "Completada",
            inProgress: "En progreso",
            nextStageEnabled: "Siguiente fase habilitada",
        },

        labels: {
            scheduleType: "Tipo de calendario",
        },

        actions: {
            openSchedule: "Abrir calendario",
            advanceTeams: "Avanzar equipos a la siguiente fase",
            deleteStage: "Eliminar fase",
        },

        badges: {
            stageDoneCreateNext: "Fase terminada · Crear siguiente fase",
        },

        toasts: {
            removeSuccess: "Fase eliminada correctamente",
            removeFailed: "No se pudo eliminar la fase",
        },

        deleteDialog: {
            title: "¿Eliminar esta fase?",
            message:
                'Estás a punto de eliminar "{name}".\n\nEsto también eliminará sus juegos/calendario de esta temporada. Esta acción no se puede deshacer.\n\n¿Estás seguro?',
            confirm: "Eliminar fase",
            cancel: "Cancelar",
        },
    },
    confirmDelete: {
        badge: {
            danger: "PELIGRO",
            confirm: "CONFIRMAR",
        },
        aria: {
            close: "Cerrar",
        },
        hints: {
            danger: "Esta acción es destructiva y puede afectar datos relacionados.",
            confirm: "Por favor confirma para continuar.",
        },
        buttons: {
            working: "Procesando...",
            delete: "Eliminar",
            cancel: "Cancelar",
            confirm: "Confirmar",
        },
        defaults: {
            title: "¿Estás seguro?",
            message: "Esta acción no se puede deshacer.",
        },
    },
    seasonList: {
        title: "Temporadas",
        subtitleManage: "Gestiona las temporadas de",
        thisDivision: "esta división",

        headers: {
            season: "Temporada",
            start: "Inicio",
            end: "Fin",
            registrationStart: "Fecha de inscripción",
            registrationEnd: "Fecha de cierre de inscripción",
            actions: "Acciones",
        },

        labels: {
            seasons: "temporadas",
            teamsInSeason: "Equipos en esta temporada",
            stagesInSeason: "Fases en esta temporada",
        },

        actions: {
            editSeason: "Editar temporada",
            deleteSeason: "Eliminar temporada",
        },

        toasts: {
            removeSuccess: "Temporada eliminada correctamente",
            removeFailed: "No se pudo eliminar la temporada",
        },

        deleteDialog: {
            title: "¿Eliminar esta temporada?",
            message:
                'Estás a punto de eliminar "{name}".\n\nEsto eliminará la temporada de esta división. Esta acción no se puede deshacer.\n\n¿Estás seguro?',
            confirm: "Eliminar temporada",
            cancel: "Cancelar",
        },
    },
    addSeasonModal: {
        badge: "NUEVO",
        title: "Nueva temporada",

        sections: {
            season: "Temporada",
            pointSystem: "Sistema de puntos",
            policies: "Políticas",
            registrationFee: "Cuota de inscripción por equipo",
        },

        fields: {
            name: "Nombre",
            registrationStartDate: "Fecha de inicio de inscripción",
            registrationEndDate: "Fecha de cierre de inscripción",
            lateRegistrationUntil: "Inscripción tardía hasta",
            startDate: "Fecha de inicio",
            endDate: "Fecha de finalización",
            winPoints: "Puntos por victoria",
            drawPoints: "Puntos por empate",
            losePoints: "Puntos por derrota",
            forfeitWinPoints: "Puntos por victoria por forfeit",
            forfeitLossPoints: "Puntos por derrota por forfeit",
            forfeitWinScore: "Marcador ganador por forfeit",
            forfeitLossScore: "Marcador perdedor por forfeit",
            doubleForfeitPoints: "Puntos por doble forfeit",
            overtimeWinPoints: "Puntos por victoria en prórroga",
            overtimeLosePoints: "Puntos por derrota en prórroga",
            waiverOptional: "Exención (opcional)",
            feeType: "Tipo de cuota",
            lateRegistrationFee: "Cuota por inscripción tardía por jugador",
            amount: "Monto",
            dueDate: "Fecha de vencimiento",
        },

        placeholders: {
            seasonName: "Nombre de la temporada",
            winPoints: "Puntos al ganar",
            drawPoints: "Puntos al empatar",
            losePoints: "Puntos al perder",
            forfeitWinPoints: "Puntos para el equipo que no hizo forfeit",
            forfeitLossPoints: "Puntos para el equipo que hizo forfeit",
            forfeitWinScore: "Marcador para el equipo que no hizo forfeit",
            forfeitLossScore: "Marcador para el equipo que hizo forfeit",
            doubleForfeitPoints: "Puntos para cada equipo",
            overtimeWinPoints: "Puntos al ganar en prórroga",
            overtimeLosePoints: "Puntos al perder en prórroga",
            amountExample: "ej. 100.00",
            installmentAmountExample: "ej. 50.00",
        },

        options: {
            noWaiver: "— Sin exención —",
            mandatoryOnRegistration: "Generar al registrarse",
            payLater: "Pagar después",
            installments: "Cuotas",
        },

        toggles: {
            useOvertime: "Usar prórroga",
            enableRegistrationFee: "Habilitar cuota de inscripción",
        },

        hints: {
            overtime:
                "Si está habilitado, los puntos por victoria/derrota en prórroga pueden ser diferentes a los del tiempo regular.",
            forfeit:
                "Configura puntos de clasificación y marcadores predeterminados para reglas de forfeit.",
            waiver:
                "Exención opcional que los participantes deben aceptar al unirse.",
            installments:
                "Agrega uno o más pagos en cuotas con sus fechas de vencimiento.",
        },

        buttons: {
            close: "Cerrar",
            save: "Guardar",
            remove: "Eliminar",
            addInstallment: "+ Agregar cuota",
        },

        installment: {
            amountNumber: "Monto #{{number}}",
            dueDateNumber: "Fecha de vencimiento #{{number}}",
            removeTitle: "Eliminar cuota",
        },

        toast: {
            success: "Temporada creada correctamente",
        },
    },
    editSeasonModal: {
        badge: "EDITAR",
        title: "Editar temporada",
        updateSettingsFor: "Actualizar configuración de {{season}}",

        sections: {
            season: "Temporada",
            pointSystem: "Sistema de puntos",
            registrationFee: "Cuota de inscripción por equipo",
        },

        sectionHints: {
            season: "Nombre y fechas",
            pointSystem: "Puntos de la clasificación",
            registrationFee: "Configuración opcional de cuota",
            overtime: "Puntos opcionales en prórroga",
            forfeit: "Reglas de forfeit y doble forfeit",
            installments: "Agrega una o más cuotas",
        },

        fields: {
            name: "Nombre",
            registrationStartDate: "Fecha de inicio de inscripción",
            registrationEndDate: "Fecha de cierre de inscripción",
            lateRegistrationUntil: "Inscripción tardía hasta",
            startDate: "Fecha de inicio",
            endDate: "Fecha de finalización",
            waiverOptional: "Exención (opcional)",
            winPoints: "Puntos por victoria",
            drawPoints: "Puntos por empate",
            losePoints: "Puntos por derrota",
            forfeitWinPoints: "Puntos por victoria por forfeit",
            forfeitLossPoints: "Puntos por derrota por forfeit",
            forfeitWinScore: "Marcador ganador por forfeit",
            forfeitLossScore: "Marcador perdedor por forfeit",
            doubleForfeitPoints: "Puntos por doble forfeit",
            otWinPoints: "Puntos por victoria en prórroga",
            otLossPoints: "Puntos por derrota en prórroga",
            feeType: "Tipo de cuota",
            lateRegistrationFee: "Cuota por inscripción tardía por jugador",
            amount: "Monto",
            dueDate: "Fecha de vencimiento",
        },

        placeholders: {
            seasonName: "Nombre de la temporada",
            otWinPoints: "Puntos por victoria en prórroga",
            otLossPoints: "Puntos por derrota en prórroga",
            amountExample: "ej. 100.00",
            installmentAmount: "Monto de la cuota #{{number}}",
        },

        options: {
            noWaiver: "— Sin exención —",
            none: "Ninguno",
            mandatoryOnRegistration: "Generar al registrarse",
            payLater: "Pagar después",
            installments: "Cuotas",
        },

        toggles: {
            useOvertime: "Usar prórroga",
            enableRegistrationFee: "Habilitar cuota de inscripción",
        },

        installmentChip: "Cuotas",

        buttons: {
            close: "Cerrar",
            saveChanges: "Guardar cambios",
            addInstallment: "Agregar cuota",
        },

        titles: {
            removeInstallment: "Eliminar cuota",
        },

        fallback: {
            season: "temporada",
        },

        validation: {
            atLeastOneInstallment: "Se requiere al menos una cuota.",
            installmentPositiveAmount: "La cuota #{{number}} debe tener un monto positivo.",
            installmentDueDate: "La cuota #{{number}} debe tener una fecha de vencimiento.",
            registrationFeeRequired: "Se requieren el monto y la fecha de vencimiento de la cuota de inscripción.",
        },

        toast: {
            updated: "Temporada actualizada",
        },
    },
    standings: {
        title: "Clasificación",
        seasonStandings: "Clasificación de la temporada",
        seasonStandingsFor: "Clasificación de la temporada para {{division}}",
        loading: "Cargando clasificación…",
        loadingAria: "Cargando clasificación...",
        empty: "No hay clasificación disponible para esta temporada.",
    },
    baseballStandings: {
        pill: "CLASIFICACIÓN",
        collapse: "Contraer",
        columns: {
            played: "PJ",
            rank: "#",
            team: "Equipo",
            win: "G",
            lose: "P",
            pct: "PCT",
            gb: "JD",
            rs: "CA",
            ra: "CE",
            diff: "DIF",
        },
    },
    soccerStandings: {
        pill: "CLASIFICACIÓN",
        collapse: "Contraer",
        columns: {
            played: "PJ",
            rank: "#",
            team: "Equipo",
            win: "G",
            draw: "E",
            lose: "P",
            goalsFor: "GF",
            goalsAgainst: "GC",
            goalDifference: "DG",
            points: "Pts",
        },
    },
    rugbyStandings: {
        pill: "CLASIFICACIÓN",
        collapse: "Contraer",
        columns: {
            played: "PJ",
            rank: "#",
            team: "Equipo",
            win: "G",
            draw: "E",
            lose: "P",
            pointsFor: "PF",
            pointsAgainst: "PC",
            difference: "DIF",
            points: "Pts",
        },
    },
    hockeyStandings: {
        pill: "CLASIFICACIÓN",
        collapse: "Contraer",
        columns: {
            rank: "#",
            team: "Equipo",
            played: "PJ",
            win: "G",
            lose: "P",
            overtimeLosses: "PTE",
            points: "Pts",
            goalsFor: "GF",
            goalsAgainst: "GC",
            goalDifference: "DIF",
        },
    },
    sanctions: {
        title: "Sanciones",
        headers: {
            player: "Jugador",
            game: "Juego",
            type: "Tipo",
            missedGames: "Part. perdidos",
            date: "Fecha",
            actions: "",
        },

        actions: {
            edit: "Editar",
            delete: "Eliminar",
            close: "Cerrar",
            cancel: "Cancelar",
            update: "Actualizar",
            add: "Agregar",
            saving: "Guardando…",
        },

        badge: {
            edit: "EDITAR",
            new: "NUEVO",
        },

        modal: {
            editTitle: "Editar sanción",
            addTitle: "Agregar sanción",
            editSubtitle: "Actualiza este registro para el jugador seleccionado.",
            addSubtitle: "Crea una sanción para {{season}}.",
        },

        fields: {
            game: "Juego",
            team: "Equipo",
            player: "Jugador",
            type: "Tipo",
            gamesSuspended: "Juegos suspendido",
            reason: "Motivo",
            notes: "Notas",
        },

        options: {
            selectGame: "Selecciona juego",
            selectTeam: "Selecciona equipo",
            selectPlayer: "Selecciona jugador",
            selectType: "Selecciona tipo",
        },

        placeholders: {
            gamesSuspended: "0",
            reason: "ej., Tarjeta roja, conducta antideportiva…",
            notes: "Detalles opcionales…",
            empty: "—",
        },

        toasts: {
            loadError: "No se pudieron cargar las sanciones",
            updateSuccess: "Sanción actualizada",
            createSuccess: "Sanción creada",
            genericError: "Algo salió mal",
            deleted: "Eliminado",
            deleteError: "No se pudo eliminar",
        },

        deleteConfirm: {
            title: "Eliminar sanción",
            message:
                "Esta sanción se eliminará permanentemente. Ya no aparecerá en el historial de este jugador.\n\n¿Seguro que deseas continuar?",
            confirmLabel: "Sí, eliminar",
            cancelLabel: "No",
        },

        values: {
            thisSeason: "esta temporada",
        },
        sanctionTypes: {
            fine: "Multa",
            suspension: "Suspensión",
        },
    },
    statsDashboard: {
        title: "Estadísticas",
        subtitle: "Líderes y tarjetas de esta temporada{{stageSuffix}}.",
        stageSuffix: " (filtrado por fase)",

        plan: {
            pro: "PRO",
            basic: "BÁSICO",
        },

        sections: {
            leaders: "Líderes",
            cards: "Tarjetas",
            gamesPlayed: "Más Partidos Jugados"
        },

        tabsAria: "Secciones de estadísticas",

        actions: {
            refresh: "Actualizar",
        },

        upgrade: {
            title: "Se requiere actualización.",
            description: "Las estadísticas están disponibles en los planes Pro o Elite.",
        },

        cards: {
            top10: "Top 10",
            stageFiltered: "Filtrado por fase",
            seasonTotal: "Total de la temporada",
            accumulatedYellowCards: "Tarjetas amarillas acumuladas",
            accumulatedYellowCardsSubtitle: "Tarjetas amarillas por jugador (totales de la temporada)",
            failedToLoad: "No se pudieron cargar las tarjetas amarillas acumuladas. Inténtalo de nuevo.",
            yellowsTitle: "{{count}} tarjetas amarillas acumuladas",
        },

        leaderCards: {
            topScorers: "Máximos goleadores",
            topAssists: "Máximas asistencias",
            topRedCards: "Más tarjetas rojas",
            topGoalContributions: "Participaciones en goles",
            topOwnGoals: "Autogoles",
            hockey_goals: "Máximos goleadores",
            hockey_assists: "Más asistencias",
            hockey_shots: "Más tiros",
            hockey_penalty_minutes: "Minutos de penalización",
            hockey_saves: "Más atajadas",
            hockey_hits: "Más contactos",
            hockey_blocked_shots: "Más tiros bloqueados",
            hockey_takeaways: "Más recuperaciones",
            hockey_giveaways: "Más pérdidas de disco",
            hockey_faceoff_wins: "Más enfrentamientos ganados",
            hockey_faceoff_losses: "Más enfrentamientos perdidos",
            hockey_shots_against: "Más tiros recibidos",
            hockey_goals_against: "Más goles recibidos",
            hockey_shutouts: "Más partidos sin goles recibidos",
            batting_avg: "Líderes de promedio de bateo",
            hits: "Líderes en hits",
            home_runs: "Líderes en jonrones",
            rbi: "Líderes en carreras impulsadas",
            runs_scored: "Líderes en carreras anotadas",
            strikeouts: "Líderes en ponches",
            stolen_bases: "Líderes en bases robadas",
            doubles: "Líderes en dobles",
            triples: "Líderes en triples",
            walks: "Líderes en bases por bolas",
            hit_by_pitch: "Líderes en golpeados por lanzamiento",
            sacrifice_hits: "Líderes en sacrificios",
            caught_stealing: "Líderes en atrapados robando",
            plate_appearances: "Líderes en apariciones al plato",
            innings_played: "Líderes en entradas jugadas",
        },

        metrics: {
            goals: "Goles",
            assists: "Asistencias",
            reds: "Rojas",
            goalContributions: "Goles + asistencias",
            ownGoals: "Autogoles",
            yellows: "Amarillas",
            value: "Valor",
            hockey_goals: "Goles",
            hockey_assists: "Asistencias",
            hockey_shots: "Tiros",
            hockey_penalty_minutes: "Minutos de penalización",
            hockey_saves: "Atajadas",
            hockey_hits: "Contactos",
            hockey_blocked_shots: "Tiros bloqueados",
            hockey_takeaways: "Recuperaciones",
            hockey_giveaways: "Pérdidas de disco",
            hockey_faceoff_wins: "Enfrentamientos ganados",
            hockey_faceoff_losses: "Enfrentamientos perdidos",
            hockey_shots_against: "Tiros recibidos",
            hockey_goals_against: "Goles recibidos",
            hockey_shutouts: "Partidos sin goles recibidos",
            batting_avg: "PRO",
            hits: "Hits",
            home_runs: "Jonrones",
            rbi: "CI",
            runs_scored: "Carreras",
            strikeouts: "Ponches",
            stolen_bases: "Bases robadas",
            doubles: "Dobles",
            triples: "Triples",
            walks: "Bases por bolas",
            hit_by_pitch: "Golpeado por lanzamiento",
            sacrifice_hits: "Sacrificios",
            caught_stealing: "Atrapado robando",
            plate_appearances: "Apariciones al plato",
            innings_played: "Entradas jugadas",
        },

        states: {
            loading: "Cargando…",
            failedToLoad: "No se pudo cargar. Inténtalo de nuevo.",
            noData: "Aún no hay datos.",
            unavailable: "No disponible",
            empty: "—",
        },

        table: {
            player: "Jugador",
            team: "Equipo",
            yellows: "Amarillas",
            gamesPlayed: "Partidos Jugados"
        },
        "gamesPlayed": {
            "title": "Más Partidos Jugados",
            "subtitle": "Jugadores con la mayor cantidad de partidos jugados",
            "failedToLoad": "No se pudieron cargar los jugadores con más partidos jugados.",
            "stageFiltered": "Filtrado por fase",
            "seasonTotal": "Total de la temporada",
            "gamesTitle": "{{count}} partidos jugados"
        }
    },
    adjustment: {
        title: "Ajustes de puntos",
        subtitle: "Gestiona los ajustes de {{season}}",

        headers: {
            createdAt: "Creado el",
            stage: "Fase",
            team: "Equipo",
            points: "Puntos",
            reason: "Motivo",
            comment: "Comentario",
            actions: "Acciones",
        },

        badge: {
            edit: "EDITAR",
            new: "NUEVO",
        },

        modal: {
            editTitle: "Editar ajuste",
            addTitle: "Agregar ajuste",
            subtitle: "Actualiza los puntos que afectan la clasificación.",
        },

        fields: {
            team: "Equipo",
            stage: "Fase",
            points: "Puntos",
            reason: "Motivo",
            commentOptional: "Comentario (opcional)",
        },

        options: {
            selectTeam: "Selecciona un equipo",
            selectStage: "Selecciona una fase",
            selectReason: "Selecciona un motivo",
        },

        reasons: {
            fairPlayBonus: "Bono por juego limpio",
            disciplinePenalty: "Penalización disciplinaria",
            manualAdjustment: "Ajuste manual",
        },

        actions: {
            edit: "Editar ajuste",
            delete: "Eliminar ajuste",
            close: "Cerrar",
            cancel: "Cancelar",
            saving: "Guardando…",
            update: "Actualizar",
            add: "Agregar",
        },

        deleteConfirm: {
            title: "¿Eliminar este ajuste?",
            message:
                "Este ajuste se eliminará y los puntos ya no afectarán la clasificación.\n\n¿Seguro que deseas continuar?",
            confirmLabel: "Eliminar",
            cancelLabel: "Cancelar",
        },

        toasts: {
            loadError: "No se pudieron cargar los ajustes",
            createdSuccess: "Ajuste creado correctamente",
            editedSuccess: "Ajuste editado correctamente",
            deletedSuccess: "Ajuste eliminado correctamente",
            genericError: "Algo salió mal",
            deleteError: "No se pudo eliminar",
        },

        values: {
            thisSeason: "esta temporada",
            empty: "—",
            noComment: "-",
        },
    },
    "fixtures": {
        "title": "Eventos",
        "headers": {
            "matchweek": "Jornada",
            "stageGroup": "Fase/Grupo",
            "away": "Visitante",
            "home": "Local",
            "score": "Marcador",
            "details": "Detalles",
            "actions": "Acciones"
        },
        "buttons": {
            "actions": "Acciones",
            "addGames": "Agregar juegos",
            "addTrainings": "Agregar entrenamientos",
            "bulkEdit": "Editar en bloque",
            "assignReferee": "Asignar oficiales",
            "printSchedule": "Imprimir calendario",
            "printGameSheet": "Imprimir acta de juego",
            "downloadGamesTemplate": "Descargar plantilla de importación",
            "importGamesExcel": "Importar juegos (Excel)"
        },
        "tooltips": {
            "openPublicSchedule": "Abrir el calendario público y copiar el enlace",
            "printOfficialGameSheets": "Selecciona juegos e imprime las actas oficiales",
            "downloadGamesTemplate": "Selecciona una fase y descarga la plantilla de importación de juegos",
            "importGamesExcel": "Sube un archivo Excel, revisa filas e importa juegos"
        },
        "messages": {
            "failedToLoadEvents": "No se pudieron cargar los eventos",
            "publicScheduleCopied": "Enlace del calendario público copiado al portapapeles.",
            "noGamesToPrint": "No hay juegos para imprimir en esta página.",
            "noStagesAvailable": "No hay fases disponibles para esta temporada.",
            "failedToDownloadTemplate": "No se pudo descargar la plantilla de importación de juegos.",
            "templateDownloaded": "Plantilla de importación de juegos descargada.",
            "excelToolsPlanRequired": "Esta función solo está disponible para planes Elite, Enterprise o Trial.",
            "refereeManagementFeatureRequired": "La asignación de árbitros requiere la función de gestión de árbitros."
        },
        "pageSize": {
            "label": "Filas",
            "option": "{{size}} / página"
        },
        "assignmentFilter": {
            "label": "Asignaciones de árbitros",
            "all": "Todos los partidos",
            "unassigned": "Sin asignar",
            "manual": "Manual",
            "proposed": "Propuesta",
            "invited": "Invitación pendiente",
            "accepted": "Aceptada",
            "declined": "Rechazada",
            "completed": "Completada"
        },
        "templateModal": {
            "title": "Descargar plantilla de importación de juegos",
            "stageLabel": "Fase",
            "maxRowsLabel": "Máximo de filas",
            "maxRowsHint": "Cantidad de filas a generar en la plantilla.",
            "selectStage": "Selecciona una fase",
            "download": "Descargar plantilla",
            "generating": "Generando...",
            "templateTypeLabel": "Tipo de plantilla",
            "dropdownTemplate": "Plantilla prellenada con listas desplegables",
            "dropdownTemplateHint": "Usa esta plantilla si quieres listas desplegables de Excel prellenadas, datos de referencia e IDs ocultos.",
            "blankTemplate": "Plantilla en blanco con texto",
            "blankTemplateHint": "Usa esta plantilla si prefieres escribir los nombres manualmente y validarlos durante la importación."
        },
        "importModal": {
            "rowNumber": "Fila",
            "badge": "IMPORTAR",
            "title": "Importar juegos desde Excel",
            "close": "Cerrar",
            "uploadTitle": "Subir plantilla completada",
            "uploadHint": "Formatos aceptados: .xlsx, .xls",
            "clear": "Limpiar",
            "previewHint": "Previsualizando {count} fila(s). Corrige lo necesario antes de importar.",
            "rowLabel": "Fila {row}:",
            "supportedTemplatesHint": "Compatible con la plantilla prellenada y la plantilla en blanco con texto.",
            "detectedTemplateType": "Detectado: {type}",
            "dropdownImportType": "Plantilla prellenada con listas desplegables",
            "blankImportType": "Plantilla en blanco con texto",
            "buttons": {
                "importGames": "Importar juegos",
                "importing": "Importando..."
            },
            "messages": {
                "fileParsed": "Archivo procesado: {count} fila(s) listas para revisar.",
                "importSuccess": "Juegos importados correctamente.",
                "fileParsedWithErrors": "{count} filas cargadas con {errors} problemas. Revisa las filas marcadas."
            },
            "errors": {
                "fixRows": "Corrige las siguientes filas:",
                "completeAllRequired": "Completa todos los campos obligatorios.",
                "teamsMustBeDifferent": "Local y visitante deben ser equipos diferentes.",
                "onlyExcelFiles": "Solo se permiten archivos Excel (.xlsx, .xls).",
                "emptyWorkbook": "El libro está vacío.",
                "noRowsDetected": "No se detectaron filas de juegos en el archivo.",
                "missingColumns": "Faltan columnas obligatorias: {columns}",
                "parseFailed": "No se pudo procesar este archivo Excel.",
                "importFailed": "No se pudieron importar los juegos. {message}",
                "invalidMatchDay": "La jornada debe ser un número válido.",
                "stageNotFound": "Etapa no encontrada: {value}",
                "groupNotFound": "Grupo no encontrado en esta etapa: {value}",
                "awayTeamNotFound": "Equipo visitante no encontrado en esta etapa/temporada: {value}",
                "homeTeamNotFound": "Equipo local no encontrado en esta etapa/temporada: {value}",
                "fieldNotFound": "Sede/cancha no encontrada en esta etapa: {value}",
                "refereeNotFound": "Árbitro/umpire no encontrado: {value}",
                "managerNotFound": "Coordinador no encontrado: {value}",
                "invalidDateTime": "Formato de fecha y hora inválido. Usa yyyy-mm-dd HH:mm."
            }
        }
    },
    "officialAssignmentModal": {
        "badge": "OFICIALES",
        "title": "Asignar oficiales",
        "subtitle": "Invita oficiales de la fase para confirmar la cobertura del partido.",
        "close": "Cerrar",
        "send": "Enviar invitaciones",
        "sending": "Enviando...",
        "labels": {"stagePool": "Grupo de la fase", "stagePoolHint": "Solo se muestran los oficiales incluidos en los grupos de las fases seleccionadas.", "games": "partidos", "available": "disponibles", "current": "asignado actualmente", "selectOfficials": "Oficiales a invitar", "selected": "seleccionados", "noOfficials": "No hay oficiales disponibles en este grupo de la fase.", "resend": "Reenviar", "replace": "Reemplazar", "cancelReplacement": "Cancelar reemplazo", "confirmReplacement": "Confirmar reemplazo", "replacing": "Reemplazando...", "assignmentHistory": "Historial de asignaciones", "referee": "Oficial", "coordinator": "Coordinador", "multipleHint": "Selecciona uno o más oficiales para invitar a este partido.", "bulkOfficials": "Oficiales para este lote", "bulkOfficialsHint": "Selecciona los oficiales una vez y añádelos a los partidos seleccionados. Las invitaciones se envían solo al pulsar Enviar invitaciones.", "addBulkOfficials": "Añadir a partidos seleccionados", "undoBulkOfficials": "Deshacer última adición", "searchOfficials": "Buscar oficiales", "selectVisible": "Seleccionar visibles", "clearSelected": "Limpiar", "removeOfficial": "Quitar oficial", "noBulkOfficialsSelected": "No hay oficiales seleccionados", "noBulkOfficialsFound": "No se encontraron oficiales", "plannedInvitations": "invitaciones por enviar", "notInStagePool": "fuera de los grupos de fase", "conflicts": "conflictos", "resolveConflicts": "Resuelve los conflictos de horario antes de enviar.", "conflict": "Conflicto de horario", "conflictHint": "Este oficial está seleccionado para otro partido a la misma hora.", "home": "Equipo local", "away": "Equipo visitante", "homeLogo": "Logo del equipo local", "awayLogo": "Logo del equipo visitante", "gameNumber": "Partido {{id}}"},
        "statuses": {"proposed": "Propuesto", "invited": "Invitado", "accepted": "Aceptado", "declined": "Rechazado", "cancelled": "Cancelado", "completed": "Completado"},
        "messages": {"selectGame": "Selecciona al menos un partido programado.", "selectReferee": "Selecciona al menos un oficial para invitar.", "selectBulkOfficial": "Selecciona al menos un oficial para el lote.", "bulkApplied": "Oficiales aplicados a los partidos seleccionados.", "selectReplacement": "Selecciona un oficial de reemplazo elegible.", "sent": "Las invitaciones a los oficiales se enviaron correctamente.", "partialSent": "Se enviaron algunas invitaciones, pero {{count}} no se pudieron enviar. Revisa las selecciones restantes.", "resent": "La invitación al oficial se reenvió correctamente.", "replaced": "La invitación al oficial de reemplazo se envió correctamente.", "failed": "No se pudieron enviar las invitaciones a los oficiales."}
    },
    "bulkEditGamesModal": {
        "title": "Editar eventos en bloque",
        "selectedCount": "{{count}} evento(s) seleccionado(s).",
        "field": "Cancha",
        "referees": "Oficiales",
        "managers": "Coordinador",
        "description": "Descripción",
        "descriptionPlaceholder": "Ingresa una descripción...",
        "noChange": "Sin cambios",
        "save": "Guardar cambios",
        "noEventsSelected": "Selecciona al menos un evento programado.",
        "failed": "No se pudieron actualizar los eventos seleccionados.",
        "failedToResolveMatching": "No se pudieron cargar los eventos coincidentes para la edición masiva.",
        "success": "{{count}} evento(s) actualizado(s) correctamente.",
        "applyToAllMatching": "Aplicar a todos los eventos programados de esta temporada",
        "applyToAllMatchingHint": "Esto aplica los cambios a eventos programados coincidentes en todas las páginas.",
        "validation": {
            "selectAtLeastOneChange": "Selecciona al menos un cambio antes de guardar."
        }
    },
    "event": {
        "new": {
            "form": {
                "responsible": "Árbitro(s)",
                "managers": "Coordinador(s)"
            }
        }
    },
    "gameElement": {
        "matchweekLabel": "JUEGO · JORNADA {{matchDay}}",
        "emptyValue": "—",
        "noGame": "Sin juego",
        "scheduled": "Programado",
        "locationLabel": "Ubicación: {{value}}",
        "coachLabel": "Entrenador: {{value}}",
        "managerLabel": "Coordinador: {{value}}",
        "refereeUmpireLabel": "Oficiales: {{value}}",
        "actions": "Acciones",
        "more": "Más",
        "toggleDropdown": "Mostrar menú",
        "enterResult": "Ingresar resultado",
        "enterDetails": "Detalles del partido",
        "enterInnings": "Ingresar entradas",
        "editGame": "Editar juego",
        "deleteGame": "Eliminar juego",
        "addSanction": "Agregar sanción",
        "visitorLogoAlt": "Logo visitante",
        "homeLogoAlt": "Logo local",
        "penaltiesShort": "pen.",
        "messages": {
            "gameRemovedSuccessfully": "Juego eliminado correctamente",
            "failedToRemoveGame": "No se pudo eliminar el juego"
        },
        "confirmDelete": {
            "title": "¿Eliminar este juego?",
            "message": "Estás a punto de eliminar:\n{{visitorName}} @ {{homeName}}\n\nEste juego se eliminará permanentemente de esta fase.\n\n¿Estás seguro?",
            "confirmLabel": "Eliminar juego",
            "cancelLabel": "Cancelar"
        },
        "soccerGameSheet": {
            "title": "Detalles del Partido",
            "visitorShort": "VISITANTE",
            "homeShort": "LOCAL",
            "teamLabel": "Equipo",
            "select": "Seleccionar",
            "noEvents": "No hay eventos aún",
            "loading": "Cargando...",
            "form": {
                "addEvent": "Agregar Evento",
                "save": "Guardar",
                "saving": "Guardando..."
            },
            "fields": {
                "team": "Equipo",
                "eventType": "Tipo de Evento",
                "player": "Jugador",
                "relatedPlayer": "Jugador Relacionado (opcional)",
                "minute": "Minuto",
                "period": "Periodo",
                "notes": "Notas (opcional)"
            },
            "validation": {
                "required": "Por favor completa todos los campos obligatorios"
            },
            "toasts": {
                "saveSuccess": "Evento guardado correctamente",
                "saveFailed": "Error al guardar el evento",
                "deleteSuccess": "Evento eliminado correctamente"
            },
            "eventTypes": {
                "goal": "Gol",
                "assist": "Asistencia",
                "substitutionIn": "Entró",
                "substitution_out": "Sustitución",
                "yellow_card": "Tarjeta amarilla",
                "red_card": "Tarjeta roja",
                "own_goal": "Autogol"
            },
            "proDetailedResultsRequired": "Esta función requiere un plan de suscripción Pro o superior.",
            "timeline": "Cronología"
        },
        "hockeyGameSheet": {
            "title": "Detalles del partido de hockey",
            "visitor": "Visitante",
            "home": "Local",
            "visitorShort": "VISITANTE",
            "homeShort": "LOCAL",
            "gameFeed": "SEGUIMIENTO DEL PARTIDO",
            "eventEntry": "REGISTRO DE EVENTOS",
            "timeline": "Cronología",
            "allPeriods": "Todos",
            "periodLabel": "Periodo {{period}}",
            "periodShort": "P{{period}}",
            "overtimeShort": "TE{{period}}",
            "overtimeLabel": "Tiempo extra",
            "shootoutLabel": "Penaltis",
            "noEventsInPeriod": "No hay eventos en este periodo.",
            "penaltyMinutesSummary": "{{minutes}} minutos de penalización",
            "relatedPlayerSummary": "Relacionado: {{player}}",
            "closeAria": "Cerrar detalles del partido de hockey",
            "addEvent": "Agregar evento",
            "noEvents": "Aún no hay eventos.",
            "loading": "Cargando eventos de hockey...",
            "loadFailed": "No se pudieron cargar los eventos de hockey.",
            "team": "Equipo",
            "action": "Acción",
            "player": "Jugador",
            "relatedPlayer": "Jugador relacionado",
            "optional": "opcional",
            "period": "Periodo",
            "minute": "Minuto",
            "second": "Segundo",
            "penaltyType": "Tipo de penalización",
            "penaltyMinutes": "Minutos de penalización",
            "notes": "Notas",
            "select": "Seleccionar",
            "optionalSelect": "Opcional",
            "saveEvent": "Guardar evento",
            "saving": "Guardando...",
            "close": "Cerrar",
            "delete": "Eliminar evento",
            "confirmDeleteTitle": "¿Eliminar evento de hockey?",
            "confirmDeleteMessage": "¿Eliminar el evento {{action}} del período {{period}} a las {{time}}? Esta acción no se puede deshacer.",
            "confirmDeleteConfirm": "Eliminar evento",
            "confirmDeleteCancel": "Conservar evento",
            "required": "Completa los campos de equipo, jugador, acción, periodo y minuto.",
            "invalidPeriod": "El período debe ser un número entero mayor que cero.",
            "invalidMinute": "Cada período dura 20 minutos. Ingresa un tiempo entre 0:00 y 20:00.",
            "invalidSecond": "Los segundos deben ser un número entero entre 0 y 59.",
            "saveSuccess": "Evento de hockey guardado correctamente.",
            "eventTypes": {
                "goal": "Gol",
                "assist": "Asistencia",
                "shot": "Tiro",
                "penalty": "Penalización",
                "faceoff_win": "Faceoff ganado",
                "faceoff_loss": "Faceoff perdido",
                "hit": "Golpe",
                "blocked_shot": "Tiro bloqueado",
                "takeaway": "Recuperación",
                "giveaway": "Pérdida",
                "save": "Atajada",
                "goal_against": "Gol recibido",
                "substitution_in": "Entrada",
                "substitution_out": "Salida"
            },
            "penaltyTypes": {
                "minor": "Menor",
                "major": "Mayor",
                "misconduct": "Mala conducta",
                "game_misconduct": "Mala conducta de partido",
                "match": "De partido"
            }
        }
    },
    "trainingElement": {
        "type": "ENTRENAMIENTO",
        "scheduled": "Programado",
        "trainingSession": "Sesión de entrenamiento",
        "noTeams": "Sin equipos",
        "noParticipants": "Sin participantes",
        "emptyValue": "—",
        "teamsCount": "Equipos: ({{count}})",
        "participantsCount": "Participantes: ({{count}})",
        "locationLabel": "Ubicación: {{value}}",
        "coachLabel": "Entrenador: {{value}}",
        "actions": "Acciones",
        "more": "Más",
        "toggleDropdown": "Mostrar menú",
        "deleteSession": "Eliminar sesión",
        "showParticipants": "Mostrar participantes",
        "hideParticipants": "Ocultar participantes",
        "messages": {
            "removedSuccessfully": "Sesión de entrenamiento eliminada correctamente",
            "failedToDelete": "No se pudo eliminar la sesión de entrenamiento"
        },
        "confirmDelete": {
            "title": "¿Eliminar esta sesión?",
            "message": "Estás a punto de eliminar esta sesión de entrenamiento.\n\nEsta acción no se puede deshacer.\n\n¿Estás seguro?",
            "confirmLabel": "Eliminar sesión",
            "cancelLabel": "Cancelar"
        }
    },
    "bulkAddGamesModal": {
        "bulk": "LOTE",
        "title": "Agregar juegos en lote",
        "close": "Cerrar",
        "choose": "Elegir",
        "notAvailable": "N/D",
        "teamFallback": "Equipo",
        "headers": {
            "stage": "Fase",
            "group": "Grupo",
            "description": "Descripción",
            "datetime": "Fecha y hora",
            "away": "Visitante",
            "home": "Local",
            "venue": "Sede",
            "responsible": "Árbitro",
            "manager": "Coordinador",
            "matchday": "Jornada"
        },
        "placeholders": {
            "description": "Descripción"
        },
        "alerts": {
            "fixFollowing": "Por favor corrige lo siguiente:",
            "rowLabel": "Fila {{row}}:"
        },
        "validation": {
            "completeAllFields": "Por favor completa todos los campos.",
            "teamsMustBeDifferent": "Los equipos local y visitante deben ser diferentes."
        },
        "messages": {
            "gamesCreatedSuccessfully": "¡Juegos creados correctamente!",
            "errorCreatingGames": "Error al crear los juegos: {{message}}"
        },
        "buttons": {
            "addAnotherGame": "Agregar otro juego",
            "saveAll": "Guardar todo",
            "saving": "Guardando..."
        },
        "hint": "Consejo: usa jornadas consistentes para mantener una programación ordenada.",
        "matchdayOption": "Jornada {{matchDay}}",
        "matchdayNewOption": "Jornada {{matchDay}} (nueva)",
        "removeRow": "Eliminar fila"
    },
    "bulkAddTrainingsModal": {
        "bulk": "LOTE",
        "title": "Agregar entrenamientos en lote",
        "close": "Cerrar",
        "choose": "Elegir",
        "notAvailable": "N/D",
        "headers": {
            "stage": "Fase",
            "group": "Grupo",
            "datetime": "Fecha y hora",
            "teams": "Equipos",
            "venue": "Sede",
            "responsibleCoach": "Responsable/Entrenador"
        },
        "alerts": {
            "fixFollowing": "Por favor corrige lo siguiente:",
            "rowLabel": "Fila {{row}}:"
        },
        "validation": {
            "completeAllFields": "Por favor completa todos los campos.",
            "selectAtLeastOneTeam": "Selecciona al menos un equipo."
        },
        "messages": {
            "trainingsCreatedSuccessfully": "¡Sesiones de entrenamiento creadas correctamente!",
            "errorCreatingTrainings": "Error al crear los entrenamientos: {{message}}"
        },
        "buttons": {
            "addAnotherTraining": "Agregar otro entrenamiento",
            "saveAll": "Guardar todo",
            "saving": "Guardando..."
        },
        "helpText": "Mantén presionado Ctrl/Cmd para seleccionar varios equipos.",
        "hint": "Consejo: puedes seleccionar varios equipos por sesión.",
        "removeRow": "Eliminar fila"
    },
    "printGameSheetsModal": {
        "title": "Selecciona los juegos para imprimir",
        "noGamesAvailable": "No hay juegos disponibles para imprimir.",
        "selectAll": "Seleccionar todo",
        "unselectAll": "Deseleccionar todo",
        "selectedCount": "Seleccionados: {{selected}} / {{total}}",
        "headers": {
            "dateTime": "Fecha / Hora",
            "field": "Campo",
            "match": "Partido"
        },
        "fallbacks": {
            "home": "Local",
            "away": "Visitante",
            "emptyValue": "—"
        },
        "vs": "vs",
        "close": "Cerrar",
        "printGames": "Imprimir {{count}} juego",
        "printGames_plural": "Imprimir {{count}} juegos"
    },
    "gameSheet": {
        "fallbacks": {
            "organization": "Organización",
            "homeTeam": "Equipo local",
            "awayTeam": "Equipo visitante",
            "emptyValue": "—",
            "match": "Partido"
        },
        "matchweekLabel": "Jornada {{matchDay}}",
        "header": {
            "division": "División",
            "season": "Temporada",
            "stageGroup": "Fase/Grupo",
            "date": "Fecha",
            "time": "Hora",
            "field": "Campo",
            "location": "Ubicación"
        },
        "teams": {
            "away": "Visitante",
            "home": "Local"
        },
        "score": {
            "finalScore": "Marcador final"
        },
        "notes": {
            "weather": "Clima",
            "category": "Categoría",
            "pageHint": "* Usa la segunda página para registrar incidentes, goles, jugadas y sanciones."
        },
        "rosters": {
            "awayRoster": "Roster visitante",
            "homeRoster": "Roster local",
            "number": "#",
            "player": "Jugador",
            "position": "Pos",
            "starter": "Titular",
            "notes": "Notas"
        },
        "officials": {
            "title": "Oficiales",
            "refereeCrewChief": "Árbitro principal / Jefe de crew",
            "assistantUmpire1": "Asistente / Umpire 1",
            "assistantUmpire2": "Asistente / Umpire 2",
            "fourthOfficialUmpire3": "4to oficial / Umpire 3",
            "scorerTableOfficial": "Anotador / Oficial de mesa",
            "timekeeper": "Cronometrador",
            "otherOfficials": "Otros oficiales"
        },
        "incidents": {
            "title": "Incidentes / goles / jugadas",
            "timeSegment": "Tiempo / Inning / Set / Cuarto",
            "team": "Equipo",
            "player": "# / Jugador",
            "eventDescription": "Evento / Descripción"
        },
        "signatures": {
            "title": "Firmas",
            "awayRepresentative": "Representante visitante",
            "homeRepresentative": "Representante local",
            "refereeCrewChief": "Árbitro principal / Jefe de crew",
            "leagueRepresentativeOptional": "Representante de la liga (opcional)",
            "commentsProtests": "Comentarios / protestas"
        }
    },
    "publicSchedulePage": {
        "meta": {
            "schedule": "Calendario",
            "seasonSchedule": "Calendario de la temporada",
            "pageTitleSuffix": "AngeonX Sports",
            "descriptionWithTitle": "Calendario oficial de {{title}}. Consulta juegos, entrenamientos y eventos actualizados en tiempo real.",
            "defaultDescription": "Calendario oficial de temporada impulsado por AngeonX Sports. Consulta juegos en vivo, entrenamientos y competencias."
        },
        "header": {
            "lastUpdated": "Última actualización: {{value}}",
            "share": "Compartir",
            "printSchedule": "Imprimir calendario"
        },
        "sections": {
            "seasonSchedule": "Calendario de la temporada",
            "liveScheduleDescription": "Este es el calendario en vivo de esta temporada. Cualquier cambio realizado por el personal de la organización aparecerá automáticamente aquí. Puedes imprimir esta vista o compartir el enlace con equipos y familias.",
            "readOnlyNote": "Este calendario es solo de lectura. La versión oficial y siempre actualizada está en AngeonX Sports. Si imprimes esto, revisa esta página para cambios de último minuto."
        },
        "loading": {
            "title": "Cargando calendario de la temporada..."
        },
        "error": {
            "title": "Calendario no disponible"
        },
        "shareMessages": {
            "copied": "Enlace copiado al portapapeles.",
            "copyFailed": "La copia falló. Puedes copiar la URL desde la barra de direcciones.",
            "copyPrompt": "Copia este enlace:"
        },
        "table": {
            "headers": {
                "dateTime": "Fecha y hora",
                "type": "Tipo",
                "matchSession": "Partido / Sesión",
                "stageGroup": "Fase / Grupo",
                "field": "Campo",
                "responsible": "Responsable",
                "scoreStatus": "Marcador / Estado"
            },
            "empty": "Aún no hay eventos programados."
        },
        "eventTypes": {
            "game": "Juego",
            "training": "Entrenamiento",
            "competition": "Competencia",
            "event": "Evento"
        },
        "eventLabels": {
            "teams": "Equipos: {{teams}}",
            "trainingSession": "Sesión de entrenamiento",
            "competition": "Competencia",
            "event": "Evento",
            "visitor": "Visitante",
            "home": "Local",
            "scheduled": "Programado",
            "emptyValue": "—"
        },
        "print": {
            "footer": "Calendario oficial • Generado desde AngeonX Sports • {{url}}",
            "watermark": "Calendario AngeonX Sports"
        }
    },
    "editGameModal": {
        "edit": "EDITAR",
        "title": "Editar juego",
        "close": "Cerrar",
        "save": "Guardar",
        "labels": {
            "stage": "Fase",
            "datetime": "Fecha y hora",
            "description": "Descripción",
            "visitorTeam": "Equipo visitante",
            "homeTeam": "Equipo local",
            "facilityField": "Instalación/Campo",
            "coach": "Entrenador",
            "refereeUmpire": "Oficiales",
            "notInStagePool": "fuera de la lista de la fase",
            "manager": "Coordinador",
        },
        "placeholders": {
            "chooseStage": "Elegir fase",
            "enterDatetime": "Ingresa fecha y hora ...",
            "enterDescription": "Ingresa descripción ...",
            "chooseVisitorTeam": "Elegir equipo visitante",
            "chooseHomeTeam": "Elegir equipo local",
            "chooseField": "Elegir campo",
            "chooseRefereeUmpire": "Elegir árbitro",
            "chooseManager": "Elegir coordinador"
        },
        "helpText": {
            "stageLocked": "La fase está bloqueada para edición."
        },
        "messages": {
            "gameModifiedSuccessfully": "Juego modificado correctamente"
        },
        "validation": {
            "conflictOn": "{{name}} el {{date}} en {{field}}"
        }
    },
    "gameResultModal": {
        "result": "RESULTADO",
        "title": "Resultado del juego",
        "close": "Cerrar",
        "save": "Guardar",
        "headers": {
            "team": "Equipo",
            "score": "Marcador"
        },
        "labels": {
            "status": "Estado del evento",
            "forfeitTeam": "Equipo que hizo forfeit",
            "resetIndividualStats": "Reiniciar estadísticas individuales",
            "penaltyShootout": "Tanda de penaltis"
        },
        "hockey": {
            "resultType": "Tipo de resultado",
            "regulation": "Reglamentario",
            "overtime": "Tiempo extra",
            "shootout": "Penaltis",
            "resultTypeHint": "Usa tiempo extra o penaltis solo cuando el partido se decidió después del tiempo reglamentario.",
            "sections": {
                "teamStats": "Estadísticas de equipo",
                "scoring": "Anotación y tiros",
                "goalkeeping": "Portería",
                "discipline": "Disciplina y juego físico",
                "home": "Local",
                "visitor": "Visitante"
            },
            "stats": {
                "shotsOnGoal": "Tiros a puerta", "powerPlayGoals": "Goles de superioridad", "powerPlayOpportunities": "Oportunidades de superioridad",
                "saves": "Atajadas", "penaltyMinutes": "Minutos de penalización", "hits": "Golpes", "blockedShots": "Tiros bloqueados",
                "homeShotsOnGoal": "Tiros a puerta local", "awayShotsOnGoal": "Tiros a puerta visitante",
                "homePenaltyMinutes": "Minutos de penalización local", "awayPenaltyMinutes": "Minutos de penalización visitante",
                "homeSaves": "Atajadas locales", "awaySaves": "Atajadas visitantes",
                "homePowerPlayGoals": "Goles de superioridad local", "awayPowerPlayGoals": "Goles de superioridad visitante",
                "homePowerPlayOpportunities": "Oportunidades de superioridad local", "awayPowerPlayOpportunities": "Oportunidades de superioridad visitante",
                "homeHits": "Golpes locales", "awayHits": "Golpes visitantes",
                "homeBlockedShots": "Tiros bloqueados locales", "awayBlockedShots": "Tiros bloqueados visitantes"
            }
        },
        "teams": {
            "visitor": "Visitante",
            "home": "Local"
        },
        "aria": {
            "visitorScore": "Marcador visitante",
            "homeScore": "Marcador local",
            "eventStatus": "Estado del evento",
            "forfeitTeam": "Equipo que hizo forfeit",
            "visitorPenalties": "Penaltis del equipo visitante",
            "homePenalties": "Penaltis del equipo local"
        },
        "options": {
            "selectForfeitTeam": "Selecciona equipo"
        },
        "validation": {
            "selectForfeitTeam": "Selecciona el equipo que hizo forfeit.",
            "penaltyScoresRequired": "Ingresa ambos marcadores de penaltis.",
            "penaltyWinnerRequired": "Los penaltis deben producir un ganador."
        },
        "scheduledStatusWarningWithIndividualStats": "Advertencia: Si el juego se guarda como Programado, se reiniciarán las estadísticas globales e individuales.",
        "scheduledStatusWarningWithoutIndividualStats": "Advertencia: Si el juego se guarda como Programado, se reiniciarán las estadísticas globales. Las estadísticas individuales no se reiniciarán a menos que se seleccione.",
        "hint": "Consejo: Ingresa solo los marcadores finales. Podrás editarlo después mientras el juego siga programado/en progreso.",
        "messages": {
            "gameResultAddedSuccessfully": "Resultado del juego agregado correctamente"
        }
    },
    "baseballScore": {
        "badge": "ENTRADAS",
        "title": "Marcador por entradas",
        "subtitle": "Registra las carreras entrada por entrada",
        "visitor": "Visitante",
        "home": "Local",
        "final": "Marcador final",
        "extended": "Marcador extendido",
        "scorecard": "Planilla de juego",
        "runsShort": "Carreras",
        "team": "Equipo",
        "hint": "Ingresa las carreras de las entradas jugadas. Deja las entradas futuras en cero.",
        "inning": "Entrada",
        "total": "C",
        "addInning": "Agregar entrada",
        "save": "Guardar marcador",
        "cancel": "Cancelar",
        "close": "Cerrar",
        "saving": "Guardando...",
        "messages": {"saved": "Marcador guardado correctamente", "saveFailed": "No se pudo guardar el marcador"}
    },
    "gameSanctionModal": {
        "new": "NUEVA",
        "title": "Agregar sanción",
        "subtitle": "Crear una sanción para {{season}}.",
        "fallbacks": {
            "season": "esta temporada",
            "visitor": "Visitante",
            "home": "Local"
        },
        "labels": {
            "team": "Equipo",
            "player": "Jugador",
            "type": "Tipo",
            "gamesSuspended": "Juegos suspendidos",
            "reason": "Motivo",
            "notes": "Notas",
            "matchweek": "Jornada {{value}}"
        },
        "placeholders": {
            "selectTeam": "Seleccionar equipo",
            "selectPlayer": "Seleccionar jugador",
            "selectType": "Seleccionar tipo",
            "gamesSuspended": "0",
            "reason": "ej., tarjeta roja, conducta antideportiva…",
            "notes": "Detalles opcionales…"
        },
        "types": {
            "suspension": "Suspensión"
        },
        "buttons": {
            "close": "Cerrar",
            "cancel": "Cancelar",
            "add": "Agregar",
            "saving": "Guardando…"
        },
        "messages": {
            "requiredFields": "Por favor completa los campos requeridos.",
            "created": "Sanción creada",
            "failed": "No se pudo crear la sanción"
        }
    },
    stageDetail: {
        nav: {
            schedule: "Calendario",
            organizations: "Organizaciones",
            divisions: "Divisiones",
            divisionShort: "Div",
        },

        labels: {
            coaches: "Entrenadores",
            refereesOrUmpires: "Oficiales",
            groups: "Grupos",
            date: "Fecha",
            venues: "Sedes",
            availableFields: "Campos disponibles",
            selectedFields: "Campos seleccionados",
        },

        dualList: {
            venuesTitle: "Sedes",
            venuesDescription: "Selecciona las sedes para esta etapa",
        },

        buttons: {
            createSchedule: "Crear calendario",
            cancel: "Cancelar",
            processing: "Procesando...",
        },

        confirm: {
            title: "Confirmar generación del calendario",
            message:
                "Estás a punto de generar todo el calendario usando los Grupos/Equipos, Sedes, Fechas y Árbitros configurados.\n\n¿Deseas continuar?",
        },

        alerts: {
            somethingWentWrong: "Algo salió mal",
            scheduleCreated: "Calendario creado correctamente",
            failedToCreateSchedule: "No se pudo crear el calendario",

            tabGroupsErrorTitle: "Error en la pestaña Grupos.",
            tabGroupsErrorMessage: "Por favor, crea los grupos primero.",

            tabDateErrorTitle: "Error en la pestaña Fecha.",
            tabDateErrorMessage: "Por favor, selecciona al menos un día.",

            tabVenuesErrorTitle: "Error en la pestaña Sedes.",
            tabVenuesErrorMessage: "Por favor, selecciona al menos un campo.",

            scheduleErrorTitle: "Error de calendario.",
            scheduleErrorMessage:
                "No puedes crear el calendario para etapas con partidos que ya tienen resultados registrados.",
        },
    },
    groupsList: {
        header: {
            title: "Grupos y Equipos",
            subtitle: "Distribuye equipos en grupos para {{seasonName}}",
            fallbackSeason: "esta temporada",
        },

        info: {
            teamsInStage: "Equipos en esta etapa",
            teamsCount: "{{count}} equipos",
            scheduleType: "Tipo de calendario",
            emptyValue: "—",
        },

        sections: {
            draftTools: "Herramientas de distribución",
            draftToolsDescription:
                "Asigna aleatoriamente los equipos marcados como todo entre los grupos existentes o reinicia la distribución.",
            groups: "Grupos",
            groupsDescription: "Crea y administra grupos para esta etapa.",
        },

        buttons: {
            randomDraft: "Distribución aleatoria",
            restartDraft: "Reiniciar distribución",
        },

        tooltips: {
            randomDraft: "Distribuir aleatoriamente los equipos en grupos",
            restartDraft: "Reiniciar distribución (quitar equipos de los grupos)",
        },

        alerts: {
            createGroupsFirst: "Por favor, crea los grupos primero",
            addTeamGroupError: "No se pudieron agregar los equipos a los grupos",
            cleanGroupsError: "No se pudieron limpiar los grupos",
        },

        emptyState: {
            createGroupsFirst: "Crea los grupos primero",
            createGroupsFirstDescription:
                "Usa el panel de Grupos para crear la estructura de grupos antes de distribuir los equipos.",
        },
    },
    listTeams: {
        section: {
            title: "Grupos y Equipos",
            subtitle:
                "Arrastra equipos a los grupos. Usa las casillas para quitar varios equipos de un grupo.",
        },

        containers: {
            teams: "Equipos",
            noUnassignedTeams: "No hay equipos sin asignar",
            dropTeamsHere: "Suelta equipos aquí",
            teamsListAria: "Lista de equipos",
            groupDropZoneAria: "Zona de grupo para soltar",
        },

        buttons: {
            removeSelected: "Quitar seleccionados",
            deleteGroup: "Eliminar grupo",
        },

        confirm: {
            deleteGroupTitle: "¿Eliminar este grupo?",
            deleteGroupMessage:
                "Los equipos de este grupo volverán a la lista de Equipos.\n\n¿Seguro que deseas continuar?",
            deleteGroupConfirmLabel: "Eliminar grupo",
            cancel: "Cancelar",
        },

        status: {
            unassigned: "Sin asignar",
            assignedToGroup: "Asignado al grupo",
        },

        toasts: {
            addingTeamToGroup: "Agregando equipo al grupo…",
            failedToRemoveTeamFromGroup: "No se pudo quitar el equipo del grupo",
            failedToAddTeamToGroup: "No se pudo agregar el equipo al grupo",
            failedToRemoveTeams: "No se pudieron quitar los equipos",
            failedToDeleteGroup: "No se pudo eliminar el grupo",
        },

        misc: {
            drag: "Arrastrar",
        },
    },
    createGroup: {
        labels: {
            groupName: "Nombre del grupo",
            poolName: "Nombre del grupo",
            gameName: "Nombre del juego",
        },

        placeholders: {
            groupName: "Nombre del grupo",
            poolName: "Nombre del grupo",
            gameName: "Nombre del juego",
        },

        buttons: {
            createGroup: "Crear grupo",
            createPool: "Crear grupo",
            createGame: "Crear juego",
        },

        nouns: {
            group: "Grupo",
            pool: "Grupo",
            game: "Juego",
        },

        hints: {
            tip: "Consejo: Crea primero todos los {{itemName}}, luego usa {{randomDraft}} para distribuir los equipos. Si tu fase es una estrutura de liga crea un solo grupo con todos los equipos. ",
            randomDraft: "Distribución aleatoria",
        },

        toasts: {
            createdSuccessfully: "{{noun}} creado correctamente",
            onlyOnePoolAllowed: "Solo se permite un grupo",
            failedToCreate: "No se pudo crear {{noun}}",
        },
    },
    stagePlayDaysList: {
        header: {
            title: "Días y horarios disponibles",
            subtitle: "Franjas horarias para los juegos en esta etapa",
            addDay: "Agregar día",
            addDayTitle: "Agregar un día/horario",
        },

        table: {
            day: "Día",
            time: "Hora",
            actions: "Acciones",
            weeklySlot: "Horario semanal",
            fromTime: "Hora de inicio",
            deleteDayTime: "Eliminar día/horario",
        },

        confirm: {
            deleteTitle: "¿Eliminar este día/horario?",
            deleteMessage:
                "Estás a punto de eliminar:\n\n{{dayName}} a las {{fromTime}}\n\nEsto afectará la generación del calendario para esta etapa. Esta acción no se puede deshacer.",
            delete: "Eliminar",
            cancel: "Cancelar",
        },

        days: {
            monday: "Lunes",
            tuesday: "Martes",
            wednesday: "Miércoles",
            thursday: "Jueves",
            friday: "Viernes",
            saturday: "Sábado",
            sunday: "Domingo",
            selectedDay: "Día seleccionado",
        },
    },
    addStagePlayDayModal: {
        header: {
            title: "Agregar día y hora",
            subtitle: "Define un día/horario disponible para esta etapa",
            close: "Cerrar",
        },

        fields: {
            day: "Día",
            time: "Hora",
            chooseDay: "Selecciona un día",
            enterTime: "Ingresa la hora...",
        },

        buttons: {
            close: "Cerrar",
            save: "Guardar",
            saving: "Guardando...",
        },

        helper: {
            tip: "Consejo: elige horarios consistentes (por ejemplo, 18:00) para simplificar la programación y reducir conflictos.",
        },

        toasts: {
            addedSuccessfully: "Día y hora agregados correctamente",
            somethingWentWrong: "Algo salió mal",
            stageRequired: "No se encontró la etapa. Actualiza la página e inténtalo de nuevo.",
            dayRequired: "Por favor, selecciona un día",
            timeRequired: "Por favor, selecciona una hora",
            invalidDay: "El día seleccionado no es válido",
        },

        days: {
            monday: "Lunes",
            tuesday: "Martes",
            wednesday: "Miércoles",
            thursday: "Jueves",
            friday: "Viernes",
            saturday: "Sábado",
            sunday: "Domingo",
        },
    },
    dualListSelector: {
        defaults: {
            title: "Seleccionar elementos",
            description: "Elige elementos de la lista",
            leftTitle: "Disponibles",
            rightTitle: "Seleccionados",
        },

        search: {
            placeholder: "Buscar...",
        },

        labels: {
            available: "Disponible",
            selected: "Seleccionado",
        },

        buttons: {
            add: "Agregar",
            remove: "Quitar",
        },

        empty: {
            noItemsFound: "No se encontraron elementos.",
            noItemsSelected: "No hay elementos seleccionados.",
        },

        hints: {
            searchByVenueOrField: "Consejo: busca por nombre de sede o nombre de campo.",
            selectedItemsUsedForStage: "Los elementos seleccionados se usarán para esta etapa.",
        },

        titles: {
            add: "Agregar",
            remove: "Quitar",
        },
    },
    refereeList: {
        roles: {
            coaches: "Entrenadores",
            refereesOrUmpires: "Oficiales",
        },

        header: {
            chooseForStage: "Elige los {{role}} para esta etapa",
        },

        sections: {
            available: "{{role}} disponibles",
            selected: "{{role}} seleccionados",
        },

        search: {
            placeholder: "Buscar {{role}}...",
        },

        labels: {
            rating: "Calificación",
        },

        buttons: {
            add: "Agregar",
            remove: "Quitar",
        },

        empty: {
            noRoleFound: "No se encontraron {{role}}.",
            noRoleSelected: "No hay {{role}} seleccionados.",
        },

        helper: {
            availableTip:
                "Consejo: agrega {{role}} a la izquierda; aparecerán en “Seleccionados”.",
            selectedTip:
                "Los {{role}} seleccionados se usarán para la programación y asignación en esta etapa.",
        },

        actions: {
            remove: "quitar",
        },
    },
    errorPage: {
        meta: {
            title: "AngeonX Sports – Página no encontrada",
        },

        brand: {
            platform: "Plataforma AngeonX Sports",
            pageNotFound: "Página no encontrada",
        },

        content: {
            title404: "404",
            description:
                "La página que buscas no existe o el enlace ya no es válido.",
        },

        reasons: {
            typo: "La URL puede tener un error.",
            movedOrRemoved: "La página pudo haber sido movida o eliminada.",
            outdatedLink: "Un enlace antiguo puede estar apuntando a una ubicación desactualizada.",
        },

        buttons: {
            backToHome: "Volver al inicio",
            goBack: "Regresar",
        },

        help: {
            internalAppIssue:
                "Si esto sigue ocurriendo dentro de la app, por favor avisa al administrador de tu liga u organización para que revise el enlace.",
            quickTips: "Consejos rápidos",
            navTip:
                "Usa la navegación principal para acceder a tus ligas, calendarios y juegos.",
            inviteTip:
                "Si abriste una invitación o un enlace compartido, asegúrate de que no haya expirado o cambiado.",
            needHelp: "¿Necesitas ayuda o encontraste un enlace roto?",
            supportText:
                "Para soporte con AngeonX Sports y otros productos de AngeonX, puedes contactarnos en:",
            productLine: "AngeonX Sports™ es un producto de AngeonX Inc.",
        },
    },
    verifyEmail: {
        meta: {
            title: "AngeonX Sports – Verificación de correo",
        },

        brand: {
            namePrimary: "kBola",
            nameSecondary: "Sports",
            logoAlt: "kBola Sports",
        },

        content: {
            title: "Verificación de correo",
            readyForSignIn: "¡Tu cuenta está lista para iniciar sesión!",
        },

        status: {
            verifying: "Verificando...",
            verifiedSuccess:
                "✅ ¡Tu correo ha sido verificado! Ahora puedes iniciar sesión en AngeonX Sports.",
            unknownError: "Ocurrió un error desconocido.",
            genericError: "⚠️ Algo salió mal. Inténtalo de nuevo.",
            accountAlreadyVerified: "La cuenta ya ha sido verificada.",
        },

        actions: {
            openApp: "Abrir la app AngeonX Sports",
            continueWeb: "Continuar al inicio de sesión web",
        },
    },
    deleteAccount: {
        meta: {
            title: "AngeonX Sports – Eliminar cuenta",
        },

        brand: {
            namePrimary: "kBola",
            nameSecondary: "Sports",
            logoAlt: "kBola Sports",
        },

        content: {
            title: "Eliminar tu cuenta",
            intro:
                "Puedes eliminar tu cuenta de AngeonX Sports en cualquier momento directamente desde la aplicación móvil:",
        },

        steps: {
            openApp: "Abre la aplicación",
            goSettings: "Ve a Más → Configuración",
            tapDelete: 'Pulsa "Eliminar cuenta"',
        },

        help: {
            emailIntro:
                "Si no puedes acceder a la aplicación, envíanos un correo a",
            emailInstruction:
                "desde tu dirección de correo registrada con tu solicitud de eliminación.",
            processingTime: "Procesaremos tu solicitud en un plazo de 7 días.",
        },

        actions: {
            backToLogin: "Volver al inicio de sesión",
        },
    },
    marketplaceRedirect: {title: "Abre este anuncio en AngeonX Sports", description: "Continúa en la aplicación móvil de AngeonX Sports para ver este anuncio del marketplace.", openApp: "Abrir en la aplicación", invalid: "El enlace del anuncio no es válido.", noApp: "Si la aplicación no se abrió, instálala aquí:", ios: "iPhone / iPad", android: "Android"},
    inviteRedirect: {
        meta: {
            title: "AngeonX Sports – Abriendo la app",
        },

        brand: {
            namePrimary: "kBola",
            nameSecondary: "Sports",
            logoAlt: "kBola Sports",
        },

        content: {
            title: "Abriendo la aplicación...",
            description:
                "Si no ocurre nada, serás redirigido en breve para instalar la aplicación.",
        },
    },
    successPage: {
        meta: {
            title: "AngeonX Sports – Suscripción exitosa",
        },

        brand: {
            namePrimary: "kBola",
            nameSecondary: "Sports",
            logoAlt: "kBola Sports",
        },

        content: {
            title: "¡Suscripción creada exitosamente!",
            description: "¡Tu nuevo plan de suscripción está listo para usarse!",
        },
    },
    cancelPage: {
        meta: {
            title: "AngeonX Sports – Suscripción cancelada",
        },

        brand: {
            namePrimary: "kBola",
            nameSecondary: "Sports",
            logoAlt: "kBola Sports",
        },

        content: {
            title: "¡Suscripción cancelada exitosamente!",
        },
    },
    passwordReset: {
        meta: {
            title: "AngeonX Sports – Restablecer contraseña",
        },

        brand: {
            namePrimary: "kBola",
            nameSecondary: "Sports",
            logoAlt: "kBola Sports",
        },

        content: {
            title: "Restablecer contraseña",
        },

        fields: {
            newPassword: "Nueva contraseña",
            confirmNewPassword: "Confirmar nueva contraseña",
        },

        buttons: {
            resetPassword: "Restablecer contraseña",
            resetting: "Restableciendo...",
            close: "Cerrar",
        },

        status: {
            success: "✅ ¡Tu contraseña ha sido restablecida! Ahora puedes iniciar sesión.",
        },

        errors: {
            title: "Errores",
            enterAndConfirmPassword: "Por favor, escribe y confirma tu nueva contraseña.",
            passwordsDoNotMatch: "Las contraseñas no coinciden.",
            unknownError: "Ocurrió un error desconocido.",
            somethingWentWrong: "⚠️ Algo salió mal. Inténtalo de nuevo.",
        },
    },
    publicEventPage: {
        meta: {
            siteName: "AngeonX Sports",
            defaultDescription: "Detalles oficiales del evento impulsados por AngeonX Sports.",
            locale: "es_CA",
            eventFallback: "Evento",
            loadingTitle: "Cargando evento...",
            notFoundTitle: "Evento no encontrado",
        },

        loading: {
            details: "Cargando detalles del evento...",
        },

        error: {
            title: "Evento no encontrado",
            description: "Este evento pudo haber sido eliminado o ya no está disponible.",
        },

        breadcrumb: {
            events: "Eventos",
        },

        status: {
            final: "Final",
            live: "En vivo",
            cancelled: "Cancelado",
            upcoming: "Próximo",
            scheduled: "Programado",
            completed: "Completado",
            inProgress: "En progreso",
        },

        sections: {
            event: "Evento",
            eventOverview: "Resumen del evento",
            photos: "Fotos",
        },

        labels: {
            home: "Local",
            away: "Visitante",
            timeline: "Cronología",
            lineups: "Alineaciones",
            stats: "Estadísticas",
            dateTime: "Fecha y hora",
            venue: "Sede",
            competition: "Competencia",
            eventType: "Tipo de evento",
            locationMap: "Mapa de ubicación",
            googleMaps: "Google Maps",
            rating: "Calificación",
            gameSummary: "Resumen del juego",
            eventTypeFallback: "EVENTO",
            teamFallback: "Equipo",
        },

        timeline: {
            emptyTitle: "Aún no se han publicado eventos en la cronología.",
            emptyDescription: "Vuelve más cerca de la hora del juego o consulta en la app de AngeonX Sports.",
        },

        lineups: {
            title: "Las alineaciones se gestionan dentro de AngeonX Sports.",
            description: "Descarga la app para ver las alineaciones oficiales y cambios en tiempo real.",
        },

        stats: {
            title: "Las estadísticas de este evento aparecerán aquí.",
            description: "Sigue el evento en AngeonX Sports para desbloquear estadísticas completas de jugadores y equipos.",
        },

        photos: {
            open: "Abrir foto",
            close: "Cerrar foto",
            previous: "Foto anterior",
            next: "Foto siguiente",
            photoAlt: "Foto del evento",
        },
    },
    advertisePage: {
        meta: {
            title: "AngeonX Sports – Anúnciate",
        },

        hero: {
            title: "Pon tu marca frente a jugadores, padres y equipos",
            description1:
                "AngeonX Sports es donde ligas, torneos y academias gestionan sus juegos, calendarios, plantillas, estadísticas y comunicación.",
            description2:
                "Tu negocio puede aparecer justo donde ellos pasan su tiempo — dentro de la app.",
            bullet1:
                "Muestra tu marca dentro de la app de AngeonX Sports — como una tarjeta destacada.",
            bullet2:
                'Botón para abrir al tocar (“Ver más”) que lleva a las personas a tu promoción o sitio.',
            bullet3:
                "Vista ampliada opcional con tu mensaje completo y gráfico.",
            bullet4:
                "Segmenta por deporte (fútbol, béisbol, softbol, etc.).",
            pricing:
                "Los espacios publicitarios comienzan en $99 por semana. Sin contrato a largo plazo.",
            createSponsorAccount: "Crear cuenta de patrocinador",
            alreadyHaveAccount: "¿Ya tienes una cuenta?",
            signIn: "Iniciar sesión",
        },

        preview: {
            logoPlaceholder: "Tu Logo",
            cardTitle: "Tu negocio — consigue más jugadores, clientes o consumidores",
            cardText:
                "“Entrena con los mejores coaches de la ciudad. Cupos limitados este mes…”",
            viewMore: "Ver más",
            seeMore: "Ver más",
            sponsoredPlacement: "Espacio patrocinado dentro de AngeonX Sports",
            expandedTitle: "Destacado en pantalla completa",
            expandedSubtitle: "(Tu marca destacada)",
            expandedHeadline: "Tu titular — destaca ante la audiencia correcta",
            expandedText:
                "Aquí es donde cuentas toda tu historia: tu campamento, tu clínica, tu servicio, tu tienda. Los usuarios pueden tocar para saber más, registrarse o contactarte.",
            expandedFooter: "Ejemplo de vista ampliada del patrocinador en la app",
        },

        howItWorks: {
            title: "Cómo funciona",
            step1Title: "1. Crea tu cuenta de patrocinador",
            step1Text:
                "Cuéntanos quién eres y qué ofreces. Esto te da acceso a tu panel de patrocinador.",
            step2Title: "2. Lanza tu campaña",
            step2Text:
                "Sube tu banner, elige el deporte (fútbol, béisbol, etc.), selecciona tus fechas y paga con tarjeta.",
            step3Title: "3. Hazte visible en la app",
            step3Text:
                "Tu anuncio aparece en AngeonX Sports para jugadores, padres y coaches. Podrás ver vistas y clics.",
        },

        faq: {
            whoIsThisForTitle: "¿Para quién es esto?",
            whoIsThisForText:
                "Academias de entrenamiento, negocios locales, clínicas deportivas, fisioterapia, productos de recuperación, torneos, mercancía, campamentos, coaches privados — cualquiera que quiera visibilidad en el deporte juvenil y amateur.",
            longContractTitle: "¿Necesito un contrato largo?",
            longContractText:
                "No. Puedes hacer una campaña corta por una semana. Perfecto para campamentos con fechas limitadas o promociones con plazo.",
        },

        finalCta: {
            createSponsorAccount: "Crear cuenta de patrocinador",
            alreadySponsor: "¿Ya eres patrocinador?",
            signIn: "Iniciar sesión",
        },
    },
    notificationsPage: {
        page: {
            title: "Notificaciones",
            inbox: "Bandeja",
            subtitle: "{{count}} notificación{{suffix}} para {{name}}",
        },

        tabs: {
            label: "Vistas de notificaciones",
            received: "Recibidas",
            sent: "Enviadas",
        },

        table: {
            headers: {
                sender: "Remitente",
                title: "Título",
                message: "Mensaje",
                type: "Tipo",
                created: "Creado",
                actions: "Acciones",
            },
            notificationFallback: "Notificación",
            systemSender: "Sistema",
            emptyType: "—",
            read: "Leída",
            unread: "No leída",
            rating: "Calificación",
        },

        actions: {
            markAsRead: "Marcar como leída",
            alreadyRead: "Ya leída",
            read: "Leída",
            delete: "Eliminar",
            deleteAll: "Eliminar todas",
            markAllAsRead: "Marcar todas como leídas",
            refresh: "Actualizar",
            noActions: "Sin acciones",
        },

        bulk: {
            markAllAsReadTitle: "Marcar todas las notificaciones como leídas",
            deleteAllTitle: "Eliminar todas las notificaciones",
            refreshTitle: "Actualizar",
        },

        confirmations: {
            markAllTitle: "Marcar todas como leídas",
            markAllMessage:
                "Esto marcará todas las notificaciones como leídas para tu perfil activo. ¿Continuar?",
            markAllConfirm: "Marcar todas como leídas",
            deleteAllTitle: "Eliminar todas las notificaciones",
            deleteAllMessage:
                "Esto eliminará permanentemente todas las notificaciones de tu perfil activo. ¿Continuar?",
            deleteAllConfirm: "Eliminar todas",
        },

        toasts: {
            missingActiveProfile: "Falta el perfil activo.",
            missingNotificationId: "Falta el id de la notificación.",
            failedMarkRead: "No se pudo marcar como leída.",
            failedDelete: "No se pudo eliminar la notificación.",
            failedMarkAllRead: "No se pudieron marcar todas como leídas.",
            failedDeleteAll: "No se pudieron eliminar todas las notificaciones.",
            markedRead: "Marcada como leída.",
            couldNotMarkRead: "No se pudo marcar como leída.",
            deleted: "Eliminada.",
            couldNotDelete: "No se pudo eliminar la notificación.",
            allMarkedRead: "Todas las notificaciones fueron marcadas como leídas.",
            couldNotMarkAllRead: "No se pudieron marcar todas como leídas.",
            allDeleted: "Todas las notificaciones fueron eliminadas.",
            couldNotDeleteAll: "No se pudieron eliminar todas las notificaciones.",
            failedSend: "No se pudo enviar la notificación.",
            sentCreated: "Enviado. Se crearon {{count}} notificaciones.",
            sendFailed: "El envío falló.",
            titleRequired: "El título es obligatorio.",
            messageRequired: "El mensaje es obligatorio.",
            selectOrganization: "Por favor, selecciona una organización.",
        },

        compose: {
            allDivisions: "Todas las divisiones",
            allSeasons: "Todas las temporadas",
            allTeams: "Todos los equipos",
            selectedCount: "{{count}} seleccionados",
            audienceManagersOnly: "Solo managers",
            audienceRefereesOnly: "Solo árbitros",
            audienceEveryone: "Todos (Managers, Árbitros, Jugadores)",
            orgFallback: "Organización",
            divisionFallback: "División",
        },

        row: {
            unreadTitle: "No leída",
            readTitle: "Leída",
            sentTitle: "Enviada",
        },


        recipients: {
            everyone: "Todos (Managers, Árbitros, Jugadores)",
            managersOnly: "Solo managers de equipo",
            refereesOnly: "Solo árbitros/umpires",
        },

        hints: {
            recipients:
                "Esto controla qué roles reciben la notificación dentro de la segmentación seleccionada.",
            teams:
                "Selecciona uno o más equipos, o déjalo vacío para todos.",
            teamsDisabled:
                "La selección de equipos está deshabilitada cuando los destinatarios son Árbitros.",
        },

        labels: {
            all: "Todos",
            selectedCount: "{{count}} seleccionados",
        },
    },
    notificationFiltersBar: {
        header: {
            title: "Filtros",
            subtitle: "Reduce los resultados por estado y tipo, luego haz clic en Aplicar",
        },

        actions: {
            compose: "Redactar",
            reset: "Restablecer",
            apply: "Aplicar",
        },

        tooltips: {
            compose: "Redactar nueva notificación",
            reset: "Restablecer filtros",
            apply: "Aplicar filtros",
        },

        fields: {
            status: "Estado",
            typeSingleSelect: "Tipos (selección única: haz clic para elegir, haz clic nuevamente para limpiar)",
            filterByStatus: "Filtrar por estado",
            filterByType: "Filtrar por tipo",
        },

        statusOptions: {
            all: "Todos",
            unread: "No leídas",
            read: "Leídas",
        },

        empty: {
            noTypesAvailable: "No hay tipos de notificación disponibles.",
        },
    },

    notificationTypes: {
        chat: "Chat",
        event: "Evento",
        gamification: "Gamificación",
        notification: "Notificación",
        invite: "Invitación",
        payment: "Pago",
        rate: "Calificaciones",
        result: "Resultado",
        team: "Equipo",
        organization: "Organización",
        link: "Enlace",
    },

    notificationComposeDrawer: {
        header: {
            title: "Redactar",
            subtitle: "Crea una nueva notificación y segmenta los destinatarios",
            close: "Cerrar",
        },

        recipientBar: {
            previewTitle: "Vista previa de segmentación de destinatarios",
            org: "Org:",
            division: "División:",
            season: "Temporada:",
            teams: "Equipos:",
            recipients: "Destinatarios:",
        },

        fields: {
            title: "Título",
            titlePlaceholder: "Ej.: Actualización del calendario",
            message: "Mensaje",
            messagePlaceholder: "Escribe tu mensaje…",
            recipients: "Destinatarios",
            organization: "Organización",
            division: "División",
            season: "Temporada",
            teamsMulti: "Equipos (selección múltiple)",
        },

        recipients: {
            everyone: "Todos (Managers, Árbitros y Jugadores)",
            managersOnly: "Solo managers de equipos",
            refereesOnly: "Solo árbitros",
        },

        hints: {
            recipients:
                "Esto controla qué roles reciben la notificación dentro de la segmentación seleccionada.",
            teams:
                "Selecciona uno o más equipos, o déjalo vacío para todos.",
            teamsDisabled:
                "La selección de equipos está deshabilitada cuando la audiencia está configurada en Árbitros.",
        },

        actions: {
            cancel: "Cancelar",
            send: "Enviar",
            sending: "Enviando...",
        },

        labels: {
            all: "Todos",
            selectedCount: "{{count}} seleccionados",
        },
    },
    "subscriptionLimit": {
        "organization_limit_reached": "Tus suscripciones de organización permiten solo {{limit}} {{item}}. Mejora tu suscripción para crear más.",
        "limit_reached": "Has alcanzado el límite de tu suscripción. Mejora tu suscripción para continuar.",
        "planLimit": "Tu plan actual ({{currentPlan}}) permite solo {{limit}} {{itemLabel}}. Actualiza tu suscripción para desbloquear más.",
        "feature_required": "Esta función no está disponible en tu suscripción actual. Mejora tu suscripción para continuar."
    },
    "organizationDivisionSummary": {
        "loading": "Cargando resumen de la organización...",
        "error": "No se pudo cargar el resumen de la organización.",
        "noData": "Todavía no hay datos disponibles.",
        "title": "Resumen de la Organización",
        "subtitle": "Resumen de divisiones, temporadas activas, equipos, jugadores y partidos.",
        "seasonProgress": "Progreso de la Temporada",
        "cards": {
            "divisions": "Divisiones",
            "activeSeasons": "Temporadas Activas",
            "teams": "Equipos",
            "players": "Jugadores",
            "games": "Partidos",
            "completed": "Completados",
            "scheduled": "Programados",
            "issues": "Incidencias"
        },
        "hints": {
            "openDivisions": "{{count}} abiertas",
            "currentlyRunning": "Actualmente activas",
            "registeredTeams": "Equipos registrados",
            "registeredPlayers": "Jugadores registrados",
            "completedGames": "{{count}} completados",
            "finishedGames": "Partidos finalizados",
            "upcomingPending": "Próximos/pendientes",
            "postponedCancelled": "Cancelados"
        },
        "charts": {
            "teamsByDivision": {
                "title": "Equipos por División",
                "subtitle": "Divisiones principales por equipos registrados"
            },
            "playersByDivision": {
                "title": "Jugadores por División",
                "subtitle": "Divisiones principales por jugadores registrados"
            },
            "gamesByStatus": {
                "title": "Partidos por Estado",
                "subtitle": "Estado operativo actual"
            }
        },
        "chartLabels": {
            "teams": "Equipos",
            "players": "Jugadores"
        },
        "status": {
            "completed": "Completado",
            "scheduled": "Programado",
            "pending": "Pendiente",
            "open": "Abierto",
            "postponed": "Pospuesto",
            "cancelled": "Cancelado",
            "done": "Hecho",
            "finished": "Finalizado",
            "unknown": "Desconocido"
        }
    },
    advertisingDashboard: {
        "United States": "Estados Unidos",
        "Canada": "Canadá",
        "All Statuses": "Todos los estados",
        "Running": "En curso",
        "Paused": "Pausada",
        "Ended": "Finalizada",
        "Draft": "Borrador",
        "Archived": "Archivada",
        "Pending Payment": "Pago pendiente",
        "Active": "Activa",
        "Inactive": "Inactiva",
        "Scheduled": "Programada",
        "Completed": "Completada",
        "Canceled": "Cancelada",
        "Cancelled": "Cancelada",
        "Expired": "Vencida",
        noAdvertisingDataForPeriod: "No hay datos de publicidad para este período.",
        "No advertising data for this period.": "No hay datos de publicidad para este período.",
        "Campaign Details": "Detalles de la campaña",
        "Campaign": "Campaña",
        "Sponsor": "Patrocinador",
        "Status": "Estado",
        "Impressions": "Impresiones",
        "Clicks": "Clics",
        "CTR": "CTR",
        "CPM": "CPM",
        "CPC": "CPC",
        "Budget": "Presupuesto",
        "Spent": "Gastado",
        "Advertising": "Publicidad",
        "Dashboard": "Panel de control",
        "All Sponsors": "Todos los patrocinadores",
        "All Campaigns": "Todas las campañas",
        "All Screens": "Todas las pantallas",
        "All Countries": "Todos los países",
        "Start Date": "Fecha de inicio",
        "End Date": "Fecha de fin",
        "Screen": "Pantalla",
        "Country": "País",
        "Reset": "Restablecer",
        "Unable to load advertising analytics.": "No se pudieron cargar las analíticas de publicidad.",
        "Loading advertising analytics...": "Cargando analíticas de publicidad...",
        "Total ad views": "Total de vistas de anuncios",
        "Total ad clicks": "Total de clics en anuncios",
        "Click-through rate": "Tasa de clics",
        "Cost per thousand impressions": "Costo por mil impresiones",
        "Cost per click": "Costo por clic",
        "Campaigns": "Campañas",
        "active": "activo",
        "Paid": "Pagado",
        "Confirmed ad orders": "Órdenes de anuncios confirmadas",
        "remaining": "restante",
        "Tracked campaign spend": "Gasto de campaña rastreado",
        "Daily Performance": "Rendimiento diario",
        "Traffic By Country": "Tráfico por país",
        "Traffic By Screen": "Tráfico por pantalla",
        "Traffic By Ad Zone": "Tráfico por zona de anuncios",
        "Creative Performance": "Rendimiento creativo",
        "Campaign Performance": "Rendimiento de campaña",
        performanceOverview: "Resumen de rendimiento de sus campañas publicitarias.",
        "Performance overview for your advertising campaigns.": "Resumen de rendimiento de sus campañas publicitarias."
    },
    advertisingAudience: {
        advertising: "Publicidad",
        audience: "Audiencia",
        description: "Estimaciones de audiencia para planificar campañas publicitarias.",
        scopedDescription: "Las estimaciones de audiencia reflejan los usuarios que tus campañas pueden alcanzar bajo las reglas de protección Enterprise.",
        staffDescription: "La vista de staff muestra por defecto todos los usuarios activos de la plataforma. Los filtros reducen el tablero por deporte, organización o ubicación.",
        sport: "Deporte",
        league: "Organización",
        city: "Ciudad",
        state: "Estado / Provincia",
        country: "País",
        allSports: "Todos los deportes",
        allLeagues: "Todas las organizaciones",
        allVisibleLeagues: "Todas las organizaciones visibles",
        cityPlaceholder: "Cualquier ciudad",
        statePlaceholder: "Todos los estados/provincias",
        countryPlaceholder: "Todos los países",
        selectCountryFirst: "Selecciona primero un país",
        reset: "Restablecer",
        loadError: "No se pudieron cargar las estimaciones de audiencia.",
        loading: "Cargando estimaciones de audiencia...",
        activePeriod: "Periodo activo",
        last7Days: "Últimos 7 días",
        last30Days: "Últimos 30 días",
        last3Months: "Últimos 3 meses",
        last6Months: "Últimos 6 meses",
        last1Year: "Último año",
        totalUsers: "Usuarios totales",
        totalUsersHint: "Usuarios alcanzables en la plataforma",
        reachableUsers: "Usuarios alcanzables",
        reachableUsersHint: "Filtrado por el alcance publicitario de tu organización",
        staffTotalUsersHint: "Todos los usuarios activos de la plataforma",
        staffAllUsersNotice: "Modo staff: este tablero usa toda la audiencia de usuarios activos salvo que apliques filtros.",
        activeUsers: "Usuarios activos",
        newUsers: "Usuarios nuevos",
        active7Days: "Activos 7 días",
        active7DaysHint: "Usuarios activos recientemente",
        active30Days: "Activos 30 días",
        active30DaysHint: "Usuarios activos mensuales",
        newUsersOverTime: "Usuarios nuevos en el tiempo",
        audienceBySport: "Audiencia por deporte",
        visibleLeagueAudience: "Audiencia de organizaciones visibles",
        topLeagues: "Organizaciones principales",
        noAudienceData: "No hay datos de audiencia disponibles.",
        noLeagueData: "No hay datos de audiencia por organización disponibles."
    },
    sponsors: {
        advertising: "Publicidad",
        sponsors: "Patrocinadores",
        deleteSponsor: "Eliminar patrocinador",
        deleteConfirmMessage: "¿Estás seguro de que quieres eliminar \"{name}\"?\nEsto no se puede deshacer.",
        delete: "Eliminar",
        cancel: "Cancelar",
        deleteError: "Error al eliminar el patrocinador.",
        deleteCouldNot: "No se pudo eliminar el patrocinador.",
        deleteSuccess: "Patrocinador eliminado correctamente.",
        headers: {
            name: "Nombre",
            contactName: "Nombre de contacto",
            contactEmail: "Email de contacto",
            active: "Activo",
            actions: "Acciones"
        },
        sport: "Deporte",
        billing: "Facturación",
        activeBadge: "Activo",
        inactiveBadge: "Inactivo",
        editSponsor: "Editar patrocinador",
        deleteSponsorTitle: "Eliminar patrocinador",
        form: {
            newBadge: "NUEVO",
            editBadge: "EDITAR",
            newSponsor: "Nuevo patrocinador",
            editSponsor: "Editar patrocinador",
            close: "Cerrar",
            save: "Guardar",
            saving: "Guardando...",
            sponsorBusinessName: "Nombre del patrocinador / negocio",
            contactName: "Nombre de contacto",
            contactEmail: "Correo electrónico de contacto",
            websiteLandingUrl: "Sitio web / URL de destino",
            primarySport: "Deporte principal",
            selectSport: "Selecciona un deporte…",
            multipleGeneralSports: "Múltiples deportes / deportes generales",
            billingCountryOptional: "País de facturación (opcional)",
            billingCurrencyOptional: "Moneda de facturación (opcional)",
            useProfileDefault: "Usar predeterminado del perfil",
            useProfileCountryDefault: "Usar predeterminado del perfil/país",
            useBackendDefault: "Usar predeterminado del sistema",
            unitedStatesUs: "Estados Unidos (US)",
            canadaCa: "Canadá (CA)",
            notesInternalOnly: "Notas (solo internas)",
            notesPlaceholder: "Contacto de facturación, precios especiales, etc.",
            activeSponsor: "Patrocinador activo (puede ejecutar campañas)",
            toast: {
                createError: "Error al crear el patrocinador.",
                createCouldNot: "No se pudo crear el patrocinador.",
                created: "¡Patrocinador creado correctamente!",
                updateError: "Error al actualizar el patrocinador",
                updated: "¡Patrocinador actualizado correctamente!"
            }
        }
    },
    campaigns: {
        advertising: "Publicidad",
        campaigns: "Campañas",
        newCampaign: "Nueva campaña",
        editCampaign: "Editar campaña",
        deleteCampaign: "Eliminar campaña",
        deleteConfirmMessage: "Estás a punto de eliminar permanentemente la campaña \"{name}\".\n\nEsto dejará de mostrar anuncios inmediatamente.\n\n¿Estás seguro de que deseas continuar?",
        deleteConfirmLabel: "Sí, eliminar",
        cancelLabel: "No",
        campaignDeleted: "Campaña eliminada",
        failedToDelete: "Error al eliminar la campaña",
        allCountries: "Todos los países",
        allPlatforms: "Todas las plataformas",
        allSports: "Todos los deportes",
        noZones: "Sin zonas",
        zonesCount: "{count} zonas",
        headers: {
            name: "Nombre",
            status: "Estado",
            sponsor: "Patrocinador",
            dates: "Fechas",
            targeting: "Segmentación",
            actions: "Acciones"
        },
        zones: "Zonas",
        start: "Inicio",
        end: "Fin",
        geo: "Ubicación",
        platform: "Plataforma",
        sport: "Deporte",
        loading: "Cargando...",
        notFound: "Campaña no encontrada.",
        status: {
            running: "En curso",
            paused: "Pausada",
            ended: "Finalizada",
            draft: "Borrador",
            archived: "Archivada",
            pending_payment: "Pago pendiente",
            active: "Activa",
            inactive: "Inactiva",
            scheduled: "Programada",
            completed: "Completada",
            canceled: "Cancelada",
            cancelled: "Cancelada",
            expired: "Vencida"
        },
        countries: {
            US: "Estados Unidos",
            CA: "Canadá"
        },
        platforms: {
            ios: "iOS",
            android: "Android"
        }
    },
    checkout: {
        paymentSuccess: "Pago exitoso",
        paymentReceived: "Pago recibido",
        paymentSuccessMessage: "El pago de tu campaña se ha completado correctamente. Se activará una vez se procese la confirmación.",
        openReview: "Abrir revisión de campaña",
        campaignList: "Lista de campañas",
        backToCampaigns: "Volver a campañas",
        checkoutCanceled: "Pago cancelado",
        checkoutCanceledMessage: "No se realizaron cargos. Puedes editar tu campaña y volver a intentarlo.",
        openDraft: "Abrir borrador",
        backToReview: "Volver a la revisión"
    },
    campaignReview: {
        notFound: "Campaña no encontrada.",
        addPlacement: "Agrega al menos una ubicación antes de pagar.",
        couldNotCreateSession: "No se pudo crear la sesión de pago.",
        checkoutFailed: "Error al procesar el pago.",
        errorLoading: "Error al cargar la campaña",
        reviewConfirm: "Revisar y Confirmar",
        edit: "Editar",
        campaign: "Campaña",
        billingCurrency: "Moneda de facturación",
        placements: "Ubicaciones",
        countries: "Países",
        platforms: "Plataformas",
        sports: "Deportes",
        organizations: "Organizaciones",
        all: "Todos",
        total: "Total",
        calculatedOnStripe: "El monto final se calcula en Stripe ({currency})",
        enterpriseMarketplaceNoPaymentRequired: "Incluido con la suscripción Enterprise de tu liga",
        calculatedAtCheckout: "Calculado al pagar",
        backToEdit: "Volver a Editar",
        redirecting: "Redirigiendo...",
        confirmPay: "Confirmar y Pagar",
        beforeYouPay: "Antes de pagar",
        tip1: "Confirma las ubicaciones y fechas.",
        tip2: "Asegúrate de que tu creatividad cumple con las pautas de tamaño y contenido.",
        tip3: "Los impuestos se calculan automáticamente en Stripe.",
        tip4: "La moneda está vinculada a la configuración de facturación del patrocinador.",
        footerText: "Revisa tus detalles y luego continúa a Stripe para pagar."
    },
    campaignForm: {
        collapse: "Contraer",
        expand: "Expandir",
        filePicker: "Selector de archivo",
        chooseFile: "Elegir archivo",
        existingImage: "Imagen existente",
        existingImageLower: "imagen existente",
        noFileSelected: "No se seleccionó ningún archivo",
        dragDropHint: "Arrastra y suelta un logo cuadrado aquí (PNG/JPG). Recomendado 1:1.",
        remove: "Eliminar",
        logoPreview: "Vista previa del logo",
        preview: "Vista previa",
        basics: "Información básica",
        campaignName: "Nombre de la campaña",
        campaignNamePlaceholder: "Pruebas de fútbol de otoño - Toronto",
        sponsorBrand: "Patrocinador / Marca",
        selectSponsor: "Selecciona un patrocinador",
        inactive: "(inactivo)",
        billingCurrency: "Moneda de facturación",
        billingCurrencyHint: "Bloqueada según la configuración de facturación del patrocinador.",
        placement: "Ubicación",
        placementHint: "¿Dónde aparecerá tu anuncio?",
        placementFallback: "Ubicación",
        targeting: "Segmentación",
        targetingHint: "¿Quién debe ver tu campaña?",
        countries: "Países",
        countryUnitedStates: "Estados Unidos",
        countryCanada: "Canadá",
        geoTargeting: "Segmentación geográfica",
        platforms: "Plataformas",
        sportsAudienceFocus: "Deportes / enfoque de audiencia",
        audienceSignal: "Señal de audiencia",
        allSportsUncheckedHint: "Si no seleccionas deportes, se interpretará como “todos los deportes”.",
        specificOrganizationsOptional: "Organizaciones específicas (opcional)",
        leagueTournament: "Liga / Torneo",
        scheduleBudget: "Calendario y presupuesto",
        startDate: "Fecha de inicio",
        endDate: "Fecha de fin",
        missingRatesFor: "Faltan tarifas para",
        estimatedTotal: "Total estimado",
        estimatedTotalShort: "Total est.",
        basedOnPlacementsCountriesDuration: "Basado en ubicaciones, países y duración",
        days: "días",
        missingRatesLabel: "Faltan tarifas",
        finalPriceHint: "El precio final se muestra al pagar. Tu anuncio no se ejecutará hasta que se confirme el pago.",
        creative: "Creativo",
        creativeHint: "Lo que verán los usuarios.",
        brandLogoSquare: "Marca / Logo (cuadrado)",
        recommendedRatio: "Recomendado: proporción 1:1, PNG o JPG",
        headline: "Titular",
        headlinePlaceholder: "Clínica elite de fútbol de invierno - cupos limitados",
        bodyPitch: "Texto / Propuesta",
        bodyPitchPlaceholder: "Entrena con entrenadores certificados. Edades 10-16. Sesiones en Toronto empiezan el 5 de nov.",
        ctaButtonLabel: "Texto del botón CTA",
        ctaButtonLabelPlaceholder: "Regístrate ahora",
        ctaUrl: "URL del CTA",
        ctaUrlPlaceholder: "https://miacademia.com/pruebas",
        campaignSummary: "Resumen de campaña",
        name: "Nombre",
        sponsor: "Patrocinador",
        currency: "Moneda",
        placements: "Ubicaciones",
        selected: "seleccionadas",
        sports: "Deportes",
        all: "Todos",
        dates: "Fechas",
        yourLogo: "Tu logo",
        yourLogoFirst: "Tu",
        yourLogoSecond: "Logo",
        logo: "Logo",
        yourBusinessCardTitle: "Tu negocio — consigue más jugadores, clientes o compradores",
        trainWithBestCoaches: "Entrena con los mejores entrenadores de la ciudad. Cupos limitados este mes.",
        viewMore: "Ver más",
        sponsoredPlacement: "Ubicación patrocinada dentro de AngeonX Sports",
        fullScreenHighlight: "Destacado en pantalla completa",
        yourBrandFeature: "(Destacado de tu marca)",
        yourHeadline: "Tu titular — destaca ante la audiencia correcta",
        fullStoryText: "Aquí cuentas tu historia completa: tu campamento, clínica, servicio o tienda. Los usuarios pueden tocar para saber más, registrarse o contactarte.",
        exampleExpandedView: "Ejemplo de vista expandida del patrocinador en la app",
        seeMore: "Ver más",
        editingDraft: "Editando borrador...",
        unsavedChanges: "Cambios sin guardar",
        cancel: "Cancelar",
        saving: "Guardando...",
        saveDraft: "Guardar borrador",
        saveChanges: "Guardar cambios",
        reviewConfirm: "Revisar y confirmar",
        type: "Tipo",
        campaignReach: "Alcance de la campaña",
        standardCampaign: "Campaña estándar de patrocinador o liga",
        standardCampaignHint: "Usa las reglas normales de pago o de organización Enterprise.",
        internalCampaign: "Campaña interna de AngeonX Sports",
        internalCampaignHint: "Visible para todos los usuarios elegibles, incluidas las organizaciones Enterprise.",
        internalCampaignReachHint: "Esta campaña interna puede alcanzar usuarios de todas las organizaciones. No se usa segmentación por organización.",
        enterpriseOrganizationTargetingHint: "Los administradores de ligas Enterprise pueden segmentar cualquier organización gestionada. Déjalo vacío para una campaña global pagada de patrocinador.",
        enterprisePlan: "Plan Enterprise",
        managedOrganization: "Organización gestionada",
        internalCampaignIncluded: "Las campañas internas de AngeonX Sports no requieren pago con Stripe.",
        enterpriseCampaignIncluded: "Las campañas dirigidas a organizaciones están incluidas con el plan Enterprise. No se requiere pago con Stripe.",
        enterpriseMarketplaceIncluded: "Esta promoción del marketplace está incluida con la suscripción Enterprise de tu liga. No se requiere pago con Stripe.",
        enterpriseMarketplaceIncludedShort: "Incluido con la liga Enterprise",
        marketplacePromotion: "Promoción del marketplace",
        internalIncludedShort: "Campaña interna",
        enterpriseIncludedShort: "Incluido con Enterprise",
        organizationCampaign: "Campaña de organización",
        globalSponsorCampaign: "Campaña global de patrocinador",
        allUsers: "Todos los usuarios",
        global: "Global",
        moreItems: "+{count} más",
        platformOptions: {
            ios: "iOS",
            android: "Android"
        },
        adZones: {
            events_banner: { name: "Banner de la pantalla de eventos", description: "Banner para mostrar en la pantalla de eventos" },
            roster_banner: { name: "Banner de la pantalla de roster", description: "Banner para mostrar en la pantalla de roster" },
            marketplace_banner: { name: "Banner de la pantalla Connect", description: "Banner para mostrar en la pantalla Connect" },
            payments_banner: { name: "Banner de la pantalla de pagos", description: "Banner para mostrar en la pantalla de pagos" },
            more_banner: { name: "Banner de la pantalla de más", description: "Banner para mostrar en la pantalla de más" },
            profiles_banner: { name: "Banner de la pantalla de perfiles", description: "Banner para mostrar en la pantalla de perfiles" },
            event_details_banner: { name: "Banner de la pantalla de detalles del evento", description: "Banner para mostrar en la pantalla de detalles del evento" },
            event_result_banner: { name: "Banner de la pantalla de resultado del evento", description: "Banner para mostrar en la pantalla de resultado del evento" },
            standing_banner: { name: "Banner de la pantalla de posiciones", description: "Banner para mostrar en la pantalla de posiciones" },
            edit_team_player_banner: { name: "Banner de la pantalla de edición de jugador del roster", description: "Banner para mostrar en la pantalla de edición de jugador del roster" },
            stats_banner: { name: "Banner de la pantalla de estadísticas", description: "Banner para mostrar en la pantalla de estadísticas" },
            kbs_fantasy_banner: { name: "Banner de kBs Fantasy", description: "Banner para mostrar en la pantalla de kBs Fantasy" },
            preferences_banner: { name: "Banner de preferencias", description: "Banner para mostrar en la pantalla de preferencias" },
            add_profile_banner: { name: "Banner para agregar perfil", description: "Banner para mostrar en la pantalla de agregar perfil" },
            add_team_banner: { name: "Banner para agregar equipo", description: "Banner para mostrar en la pantalla de agregar equipo" },
            edit_team_banner: { name: "Banner para editar equipo", description: "Banner para mostrar en la pantalla de editar equipo" },
            organizations_banner: { name: "Banner de la pantalla de organizaciones", description: "Banner para mostrar en la pantalla de organizaciones" },
            organization_banner: { name: "Banner de la pantalla de detalle de organización", description: "Banner para mostrar en la pantalla de detalle de organización" },
            divisions_banner: { name: "Banner de la pantalla de divisiones", description: "Banner para mostrar en la pantalla de divisiones" },
            division_banner: { name: "Banner de la pantalla de detalle de división", description: "Banner para mostrar en la pantalla de detalle de división" },
            division_team_players_banner: { name: "Banner de la pantalla de jugadores del equipo de división", description: "Banner para mostrar en la pantalla de jugadores del equipo de división" },
            division_teams_add_player_banner: { name: "Banner de la pantalla para agregar jugadores al equipo de división", description: "Banner para mostrar en la pantalla para agregar jugadores al equipo de división" },
            kbs_challenges_banner: { name: "Banner de desafíos de kBs Fantasy", description: "Banner para mostrar en la pantalla de desafíos de kBs Fantasy" },
            chat_list_banner: { name: "Banner de la pantalla de lista de chats", description: "Banner para mostrar en la pantalla de lista de chats" },
            leaders_banner: { name: "Banner de la pantalla de líderes", description: "Banner para mostrar en la pantalla de líderes" },
            marketplace_listings_banner: { name: "Banner de la pantalla de anuncios del marketplace", description: "Banner para mostrar en la pantalla de anuncios del marketplace" },
            marketplace_listing_banner: { name: "Banner de la pantalla de detalle del anuncio del marketplace", description: "Banner para mostrar en la pantalla de detalle del anuncio del marketplace" },
            marketplace_favorites_banner: { name: "Banner de la pantalla de favoritos del marketplace", description: "Banner para mostrar en la pantalla de favoritos del marketplace" },
            marketplace_my_listings_banner: { name: "Banner de la pantalla de mis anuncios del marketplace", description: "Banner para mostrar en la pantalla de mis anuncios del marketplace" },
            marketplace_blocked_users_banner: { name: "Banner de la pantalla de usuarios bloqueados del marketplace", description: "Banner para mostrar en la pantalla de usuarios bloqueados del marketplace" },
            referee_assignments_banner: { name: "Banner de la pantalla de asignaciones de árbitros", description: "Banner para mostrar en la pantalla de asignaciones de árbitros" },
            referee_availability_banner: { name: "Banner de la pantalla de disponibilidad de árbitros", description: "Banner para mostrar en la pantalla de disponibilidad de árbitros" },
            subscription_banner: { name: "Banner de la pantalla de suscripción", description: "Banner para mostrar en la pantalla de suscripción" },
            invoices_banner: { name: "Banner de la pantalla de facturas", description: "Banner para mostrar en la pantalla de facturas" },
            notifications_banner: { name: "Banner de la pantalla de notificaciones", description: "Banner para mostrar en la pantalla de notificaciones" },
            team_events_banner: { name: "Banner de la pantalla de eventos del equipo", description: "Banner para mostrar en la pantalla de eventos del equipo" },
            team_stats_banner: { name: "Banner de la pantalla de estadísticas del equipo", description: "Banner para mostrar en la pantalla de estadísticas del equipo" },
            event_photos_banner: { name: "Banner de la pantalla de fotos del evento", description: "Banner para mostrar en la pantalla de fotos del evento" },
            event_referee_rating_banner: { name: "Banner de la pantalla de calificación de árbitros del evento", description: "Banner para mostrar en la pantalla de calificación de árbitros del evento" },
            memory_game_banner: { name: "Banner de la pantalla del juego de memoria", description: "Banner para mostrar en la pantalla del juego de memoria" },
            player_fight_banner: { name: "Banner de la pantalla de combate de jugadores", description: "Banner para mostrar en la pantalla de combate de jugadores" },
            rate_player_banner: { name: "Banner de la pantalla para calificar jugadores", description: "Banner para mostrar en la pantalla para calificar jugadores" },
            marketplace_rating_list_banner: { name: "Banner de la pantalla de calificaciones del marketplace", description: "Banner para mostrar en la pantalla de calificaciones del marketplace" },
            send_notification_banner: { name: "Banner de la pantalla para enviar notificaciones", description: "Banner para mostrar en la pantalla para enviar notificaciones" },
            player_profile_banner: { name: "Banner de la pantalla del perfil del jugador", description: "Banner para mostrar en la pantalla del perfil del jugador" },
            player_insights_banner: { name: "Banner de la pantalla de análisis del jugador", description: "Banner para mostrar en la pantalla de análisis del jugador" },
            referee_profile_banner: { name: "Banner de la pantalla del perfil del árbitro", description: "Banner para mostrar en la pantalla del perfil del árbitro" },
            referee_assignment_detail_banner: { name: "Banner de la pantalla de detalle de asignación de árbitro", description: "Banner para mostrar en la pantalla de detalle de asignación de árbitro" },
            referee_rating_comments_banner: { name: "Banner de la pantalla de comentarios de calificación del árbitro", description: "Banner para mostrar en la pantalla de comentarios de calificación del árbitro" }
        },
        toast: {
            enterNameSponsorPlacement: "Ingresa un nombre, selecciona un patrocinador y elige al menos una ubicación.",
            missingRates: "Faltan tarifas para la zona/país seleccionados en la moneda del patrocinador.",
            provideImage: "Proporciona una imagen (carga o URL).",
            couldNotSaveDraft: "No se pudo guardar el borrador:",
            unknownError: "Error desconocido",
            draftSaved: "¡Borrador guardado!",
            somethingWentWrongSaving: "Algo salió mal al guardar el borrador.",
            missingCampaignId: "Falta el ID de la campaña.",
            completeRequiredFields: "Completa los campos obligatorios.",
            updateFailed: "Error al actualizar:",
            draftUpdated: "¡Borrador actualizado!",
            somethingWentWrongUpdating: "Algo salió mal al actualizar el borrador.",
            couldNotProceedToReview: "No se pudo continuar a la revisión."
        }
    }
};

export default es;
